import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  HiOutlinePlus,
  HiOutlineChevronRight,
  HiOutlineX,
  HiOutlineMenu,
} from "react-icons/hi";

import fileIcon from "../../assets/svg/file.svg";
import LegalAdviceHeadset from "../../assets/svg/legal-advice-headset.svg";
import ProposalToClientView from "./ProposalToClientView";
import ConfirmationFromClientView from "./ConfirmationFromClientView";
import InvoiceToClientFinalView from "./InvoiceToClientFinalView";
import PaymentFromClientView from "./PaymentFromClientView";
import ChecklistDocumentsToClientView from "./ChecklistDocumentsToClientView";
import DocumentsFromClientView from "./DocumentsFromClientView";
import FilingDetailsToClientView from "./FilingDetailsToClientView";
import ConfirmationOfFilingDetailsView from "./ConfirmationOfFilingDetailsView";
import StampPaperDetailsToVendorView from "./StampPaperDetailsToVendorView";
import StampPaperFromVendorView from "./StampPaperFromVendorView";
import PreparationOfPowerOfAttorneyView from "./PreparationOfPowerOfAttorneyView";
import PreparationOfUserAffidavitView from "./PreparationOfUserAffidavitView";
import InactiveStepView from "./InactiveStepView";
import SignatureFromClientView from "./SignatureFromClientView";
import NotarisationOfDocumentsView from "./NotarisationOfDocumentsView";
import ScanningOfDocumentsView from "./ScanningOfDocumentsView";
import UploadingApplicationDetailsView from "./UploadingApplicationDetailsView";
import FilingOfApplicationView from "./FilingOfApplicationView";
import AcknowledgementToClientView from "./AcknowledgementToClientView";
import FilingOfExpeditedApplicationView from "./FilingOfExpeditedApplicationView";
import InvoiceToClientForExpeditedApplicationView from "./InvoiceToClientForExpeditedApplicationView";
import PaymentFromClientExpeditedView from "./PaymentFromClientExpeditedView";
import PreliminaryDiscussionView from "./PreliminaryDiscussionView";
import FormalitiesCheckView from "./FormalitiesCheckView";
import MarkedForExamView, {
  MARKED_FOR_EXAM_ACCEPTED_FORM_ID,
  MARKED_FOR_EXAM_AAO_FORM_ID,
} from "./MarkedForExamView";
import ExaminationReportView, {
  EXAMINATION_REPORT_NOTICE_FORM_ID,
  EXAMINATION_REPORT_SOA_FORM_ID,
  EXAMINATION_REPORT_INFORM_FORM_ID,
  EXAMINATION_REPORT_SOO_FORM_ID,
  EXAMINATION_REPORT_NTCO_FORM_ID,
  EXAMINATION_REPORT_INCO_FORM_ID,
  EXAMINATION_REPORT_CCRO_FORM_ID,
  EXAMINATION_REPORT_CCO_FORM_ID,
  EXAMINATION_REPORT_INV_FORM_ID,
  EXAMINATION_REPORT_PAY_FORM_ID,
  EXAMINATION_REPORT_DOC_FORM_ID,
  EXAMINATION_REPORT_FRO_FORM_ID,
  EXAMINATION_REPORT_ICR_FORM_ID,
  EXAMINATION_REPORT_AAO_STATUS_FORM_ID,
  EXAMINATION_REPORT_AAO_NOTICE_FORM_ID,
  EXAMINATION_REPORT_AAO_INFORM_FORM_ID,
  EXAMINATION_REPORT_HAO_INFORM_FORM_ID,
  EXAMINATION_REPORT_HAO_STATUS_FORM_ID,
  EXAMINATION_REPORT_HAO_NOTICE_FORM_ID,
  EXAMINATION_REPORT_HAO_INFORM_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_CALL_CLIENT_FORM_ID,
  EXAMINATION_REPORT_HAO_CONFIRMATION_FORM_ID,
  EXAMINATION_REPORT_HAO_REVISED_INVOICE_FORM_ID,
  EXAMINATION_REPORT_HAO_INVOICE_FORM_ID,
  EXAMINATION_REPORT_HAO_TMM_INVOICE_FORM_ID,
  EXAMINATION_REPORT_HAO_TMM_PAYMENT_FORM_ID,
  EXAMINATION_REPORT_HAO_TMM_FILE_FORM_ID,
  EXAMINATION_REPORT_HAO_TMM_INFORM_FORM_ID,
  EXAMINATION_REPORT_HAO_PAYMENT_FORM_ID,
  EXAMINATION_REPORT_HAO_STAMP_VENDOR_FORM_ID,
  EXAMINATION_REPORT_HAO_STAMP_FROM_VENDOR_FORM_ID,
  EXAMINATION_REPORT_HAO_DOCS_FROM_CLIENT_FORM_ID,
  EXAMINATION_REPORT_HAO_USER_AFFIDAVIT_FORM_ID,
  EXAMINATION_REPORT_HAO_SIGNATURE_FORM_ID,
  EXAMINATION_REPORT_HAO_NOTARISATION_FORM_ID,
  EXAMINATION_REPORT_HAO_SCANNING_FORM_ID,
  EXAMINATION_REPORT_HAO_FILE_HEARING_DOC_FORM_ID,
  EXAMINATION_REPORT_HAO_NOTE_ON_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_ATTEND_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_HEARING_NOT_HAPPENED_FORM_ID,
  EXAMINATION_REPORT_HAO_INFORM_AFTER_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_UPLOAD_DOCS_AFTER_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_TMM_AFTER_INVOICE_FORM_ID,
  EXAMINATION_REPORT_HAO_TMM_AFTER_PAYMENT_FORM_ID,
  EXAMINATION_REPORT_HAO_FILE_TMM_AFTER_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_INFORM_TMM_AFTER_HEARING_FORM_ID,
  EXAMINATION_REPORT_HAO_SUBSEQUENT_HEARINGS_FORM_ID,
  EXAMINATION_REPORT_HAO_SUBSEQUENT_INVOICE_FORM_ID,
  EXAMINATION_REPORT_HAO_SUBSEQUENT_PAYMENT_FORM_ID,
  EXAMINATION_REPORT_HAO_SUBSEQUENT_ATTEND_FORM_ID,
  EXAMINATION_REPORT_HAO_SUBSEQUENT_POSTPONEMENT_FORM_ID,
  EXAMINATION_REPORT_HAO_ORDER_OF_HEARING_FORM_ID,
} from "./ExaminationReportView";
import AdvertisedInJournalView, {
  ADVERTISED_IN_JOURNAL_STATUS_FORM_ID,
  ADVERTISED_IN_JOURNAL_NOTICE_FORM_ID,
  ADVERTISED_IN_JOURNAL_INFORM_FORM_ID,
  OPPOSITION_COUNTER_STATUS_FORM_ID,
  OPPOSITION_COUNTER_NOTICE_FORM_ID,
  OPPOSITION_COUNTER_INFORM_FORM_ID,
  OPPOSITION_COUNTER_CALL_FORM_ID,
  OPPOSITION_COUNTER_CONFIRMATION_FORM_ID,
  OPPOSITION_COUNTER_INVOICE_FORM_ID,
  OPPOSITION_COUNTER_PAYMENT_FORM_ID,
  OPPOSITION_COUNTER_PREPARE_FORM_ID,
  OPPOSITION_COUNTER_FILE_COUNTER_FORM_ID,
  OPPOSITION_COUNTER_INFORM_FILING_FORM_ID,
  OPPOSITION_COUNTER_NOTICE_OF_COUNTER_FORM_ID,
  OPPOSITION_COUNTER_INFORM_NOTICE_FORM_ID,
  OPPOSITION_COUNTER_EVIDENCE_BY_OPPONENT_FORM_ID,
  OPPOSITION_COUNTER_NOTICE_EVIDENCE_BY_OPP_FORM_ID,
  OPPOSITION_COUNTER_INFORM_EVIDENCE_BY_OPP_FORM_ID,
  OPPOSITION_COUNTER_CALL_CLIENT_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_EVIDENCE_CONFIRMATION_FORM_ID,
  OPPOSITION_COUNTER_EVIDENCE_INVOICE_FORM_ID,
  OPPOSITION_COUNTER_EVIDENCE_PAYMENT_FORM_ID,
  OPPOSITION_COUNTER_STAMP_VENDOR_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_STAMP_FROM_VENDOR_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_DOCUMENTS_FROM_CLIENT_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_PREPARATION_EVIDENCE_AFFIDAVIT_FORM_ID,
  OPPOSITION_COUNTER_SIGNATURE_AFFIDAVIT_FORM_ID,
  OPPOSITION_COUNTER_NOTARISATION_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_SCANNING_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_FILE_EVIDENCE_AFFIDAVIT_FORM_ID,
  OPPOSITION_COUNTER_INFORM_FILING_EVIDENCE_FORM_ID,
  OPPOSITION_COUNTER_DOWNLOAD_REJOINDER_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_STATUS_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_NOTICE_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_INFORM_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_INVOICE_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_CALL_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_CONFIRMATION_FORM_ID,
  OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_INVOICE_FORM_ID,
  OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_PAYMENT_FORM_ID,
  OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_FILED_FORM_ID,
  OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_INFORM_FORM_ID,
  OPPOSITION_COUNTER_OPPOSITION_HEARING_PAYMENT_FORM_ID,
  OPPOSITION_COUNTER_DOCUMENTS_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_FILING_OPP_HEARING_DOC_FORM_ID,
  OPPOSITION_COUNTER_NOTE_ON_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_ATTEND_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_INFORM_AFTER_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_INVOICE_TMM_AFTER_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_PAYMENT_TMM_AFTER_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_FILE_TMM_AFTER_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_INFORM_TMM_AFTER_OPP_HEARING_FORM_ID,
  OPPOSITION_COUNTER_SUBSEQUENT_OPP_HEARINGS_FORM_ID,
  OPPOSITION_COUNTER_SUBSEQUENT_OPP_HEARING_INVOICE_FORM_ID,
  OPPOSITION_COUNTER_SUBSEQUENT_OPP_HEARING_PAYMENT_FORM_ID,
  OPPOSITION_COUNTER_ORDER_OF_OPP_HEARING_FORM_ID,
} from "./AdvertisedInJournalView";
import FinalOrderView, {
  FINAL_ORDER_REGISTERED_STATUS_FORM_ID,
  FINAL_ORDER_REGISTERED_NOTICE_FORM_ID,
  FINAL_ORDER_REGISTERED_INFORM_FORM_ID,
  FINAL_ORDER_REFUSED_STATUS_FORM_ID,
  FINAL_ORDER_REFUSED_NOTICE_FORM_ID,
  FINAL_ORDER_REFUSED_INFORM_FORM_ID,
} from "./FinalOrderView";
import StatusHistoryView from "./StatusHistoryView";
import DateTimePicker from "components/DateTimePicker";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  getLeadDetails,
  sendChecklist,
  sendDocChecklist,
  buildWhatsAppLink,
  submitSearchDetails,
  getAdvanceAmount,
  invoiceAdvance,
  collectAdvance,
  getSavedClassList,
  getListsByClass,
  saveClassList,
  sendClassListToClient,
  getSearchReportDetails,
  generateSearchReportUploadUrls,
  submitSearchReport,
  completeLegalAdvice,
  submitNewMarkFromLegalAdvice,
} from "api/discussion";
import {
  skipStep,
  NewApplicationStep,
  getWorkflowStatus,
} from "api/applications";
import { useWorkflowStatus } from "hooks/useWorkflowStatus";
import { formatPhoneInput, validateMobileNumber } from "../../utils/phone";
import { toLocalYmd } from "../../utils/filingApiDates";
import { toast } from "sonner";
import DashboardLayout from "layouts/dashboard/DashboardLayout";
import ConfirmMessageModal from "components/ConfirmMessageModal";
import FilePreviewModal, { detectPreviewKind } from "components/FilePreviewModal";
import type { FilePreviewKind } from "components/FilePreviewModal";
import { DOCUMENTS_PREVIEW_TEXT } from "constants/messagePreviews";
import { renderWhatsAppFormatting } from "lib/whatsappFormatting";

const STEP_ID_TO_SLUG: Record<string, string> = {
  preliminary: "preliminary-discussion-with-the-client",
  checklist: "check-list-for-search-to-client",
  details: "details-for-search-from-client",
  "invoice-advance": "invoice-of-advance-amount-to-client",
  "advance-amount": "advance-amount-from-client",
  "class-list": "class-list-to-client",
  "search-report": "search-report-to-client",
  "legal-advice": "legal-advice",
  proposal: "proposal-to-client",
  confirmation: "confirmation-from-client",
  "invoice-final": "invoice-to-client-final",
  payment: "payment-from-client",
};

const STEP_SLUG_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(STEP_ID_TO_SLUG).map(([k, v]) => [v, k])
);

const FILING_ID_TO_SLUG: Record<string, string> = {
  f1: "check-list-of-documents-to-client",
  f2: "documents-from-client",
  f3: "filing-details-to-client",
  f4: "confirmation-of-filing-details",
  f5: "stamp-paper-details-to-vendor",
  f6: "stamp-paper-from-vendor",
  f7: "preparation-of-power-of-attorney",
  f8: "preparation-of-user-affidavit",
  f9: "signature-from-client",
  f10: "notarisation-of-documents",
  f11: "scanning-of-documents",
  f12: "uploading-application-details",
  f13: "filing-of-application",
  f14: "acknowledgement-to-client",
  f15: "filing-of-expedited-application",
  f16: "invoice-to-client-for-expedited-application",
  f17: "payment-from-client-expedited",
};

const STATUS_ITEMS = [
  { id: "s1", label: "Formalities Check" },
  { id: "s2", label: "Marked for Exam" },
  { id: "s3", label: "Examination Report" },
  { id: "s5", label: "Advertised in Journal" },
  { id: "s6", label: "Final Order" },
  { id: "s7", label: "Status History" },
];

const STATUS_ID_TO_SLUG: Record<string, string> = {
  s1: "formalities-check",
  s2: "marked-for-exam",
  s3: "examination-report",
  s5: "advertised-in-journal",
  s6: "final-order",
  s7: "status-history",
};

const STATUS_SLUG_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(STATUS_ID_TO_SLUG).map(([k, v]) => [v, k])
);

const FILING_SLUG_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(FILING_ID_TO_SLUG).map(([k, v]) => [v, k])
);

const FILING_FORM_IDS: Record<string, string> = {
  f2: "documents-from-client-form",
  f3: "filing-details-to-client-form",
  f4: "confirmation-of-filing-details-form",
  f5: "stamp-paper-details-to-vendor-form",
  f6: "stamp-paper-from-vendor-form",
  f7: "preparation-of-power-of-attorney-form",
  f8: "preparation-of-user-affidavit-form",
  f9: "signature-from-client-form",
  f10: "notarisation-of-documents-form",
  f11: "scanning-of-documents-form",
  f12: "uploading-application-details-form",
  f13: "filing-of-application-form",
  f14: "acknowledgement-to-client-form",
  f15: "filing-of-expedited-application-form",
  f16: "expedited-invoice-form",
  f17: "payment-expedited-form",
};

/** Pages that show the Progress (skip) button — maps menu/filing id to workflow step to skip */
const PROGRESS_STEPS: Record<string, string> = {
  "invoice-advance": NewApplicationStep.S1_04_AdvanceInvoiceToClient,
  "advance-amount": NewApplicationStep.S1_05_AdvanceAmountFromClient,
  payment: NewApplicationStep.S1_12_PaymentFromClient,
  f7: NewApplicationStep.S2_07_PoaPreparation,
  f17: NewApplicationStep.S2_17_PaymentFromClientExpedited,
};

const FILING_ITEMS = [
  { id: "f1", label: "Check list of Documents to Client" },
  { id: "f2", label: "Documents from Client" },
  { id: "f3", label: "Filing Details to Client" },
  { id: "f4", label: "Confirmation of Filing Details" },
  { id: "f5", label: "Stamp Paper details to Vendor" },
  { id: "f6", label: "Stamp Paper from Vendor" },
  { id: "f7", label: "Preparation of Power of Attorney" },
  { id: "f8", label: "Preparation of User Affidavit" },
  { id: "f9", label: "Signature from Client" },
  { id: "f10", label: "Notarisation of Documents" },
  { id: "f11", label: "Scanning of Documents" },
  { id: "f12", label: "Uploading Application Details" },
  { id: "f13", label: "Filing of Application" },
  { id: "f14", label: "Acknowledgement to Client" },
  { id: "f15", label: "Filing of Expedited Application" },
  { id: "f16", label: "Invoice to Client for Expedited Application" },
  { id: "f17", label: "Payment from Client (Expedited)" },
];

const CHECKLIST_MESSAGE_TEMPLATE = `Details required in conducting search for the availability of Trademark :-
*Mark Details*
1. Tradename (An image of the logo to be shared) :
2. Date from which the tradename is used :
3. List of Goods / Services using the tradename :

Adv. Rekha das
UpRight Legal Solutions`;

const detailsSearchValidationSchema = Yup.object({
  tradeName: Yup.string().required("Client Tradename is required"),
  dateOfUse: Yup.date()
    .required("Date of Use is required")
    .nullable()
    .typeError("Please select a valid date"),
  goodsDescription: Yup.string().required("Goods / Services Shared is required"),
});

type DetailsSearchFormValues = {
  tradeName: string;
  dateOfUse: Date | null;
  goodsDescription: string;
};

type DetailsSearchFromClientViewProps = {
  leadId?: string;
  onSuccess?: (leadId: string) => void;
};

function DetailsSearchFromClientView({
  leadId,
  onSuccess,
}: DetailsSearchFromClientViewProps) {
  const [loading, setLoading] = useState(!!leadId);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [loadedValues, setLoadedValues] = useState<DetailsSearchFormValues | null>(null);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoFileName, setLogoFileName] = useState("");
  const [logoPreviewUrl, setLogoPreviewUrl] = useState<string | null>(null);
  const [showLargeLogoPreview, setShowLargeLogoPreview] = useState(false);
  const logoInputRef = useRef<HTMLInputElement>(null);
  const logoCacheKey = `details-search-logo:${leadId ?? "new"}`;

  const getFileNameFromUrl = (url: string): string => {
    try {
      const parsed = new URL(url);
      const last = parsed.pathname.split("/").filter(Boolean).pop() ?? "";
      return decodeURIComponent(last);
    } catch {
      const last = url.split("/").filter(Boolean).pop() ?? "";
      return decodeURIComponent(last);
    }
  };

  const isRenderableImagePreview = (url: string | null | undefined): boolean => {
    if (!url) return false;
    const value = url.trim();
    if (!value) return false;
    // Local pseudo URLs (e.g. local:...) are not browser-fetchable.
    if (value.startsWith("local:")) return false;
    // Allow in-memory previews and standard web URLs.
    if (
      value.startsWith("data:image/") ||
      value.startsWith("blob:") ||
      value.startsWith("http://") ||
      value.startsWith("https://")
    ) {
      return true;
    }
    return false;
  };

  const persistLogoToSession = (name: string, previewUrl?: string | null) => {
    if (!leadId) return;
    sessionStorage.setItem(
      logoCacheKey,
      JSON.stringify({
        name,
        previewUrl: previewUrl ?? null,
      })
    );
  };

  const clearLogoSessionCache = () => {
    if (!leadId) return;
    sessionStorage.removeItem(logoCacheKey);
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoFileName("");
    setLogoPreviewUrl(null);
    setShowLargeLogoPreview(false);
    clearLogoSessionCache();
    if (logoInputRef.current) logoInputRef.current.value = "";
  };

  const handleLogoSelection = (file: File | null) => {
    setLogoFile(file);
    setLogoFileName(file?.name ?? "");
    if (!file) {
      setLogoPreviewUrl(null);
      clearLogoSessionCache();
      return;
    }

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = typeof reader.result === "string" ? reader.result : null;
        setLogoPreviewUrl(dataUrl);
        persistLogoToSession(file.name, dataUrl);
      };
      reader.onerror = () => {
        setLogoPreviewUrl(null);
        persistLogoToSession(file.name, null);
      };
      reader.readAsDataURL(file);
      return;
    }

    if (file.type === "application/pdf") {
      const blobUrl = URL.createObjectURL(file);
      setLogoPreviewUrl(blobUrl);
      // Blob URLs can't be persisted across reloads; clear the session cache.
      persistLogoToSession(file.name, null);
      return;
    }

    setLogoPreviewUrl(null);
    persistLogoToSession(file.name, null);
  };

  const initialValues: DetailsSearchFormValues = {
    tradeName: "",
    dateOfUse: null,
    goodsDescription: "",
  };

  useEffect(() => {
    if (!leadId) {
      setLoadedValues(null);
      setLoading(false);
      setLogoFile(null);
      setLogoFileName("");
      setLogoPreviewUrl(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    getLeadDetails(leadId)
      .then(({ lead }) => {
        if (!cancelled) {
          setLoadedValues({
            tradeName: lead.tradeName ?? "",
            dateOfUse: lead.dateOfUse ? new Date(lead.dateOfUse) : null,
            goodsDescription: lead.descriptionOfGoods ?? "",
          });
          if (lead.logoUrl) {
            const fileName = getFileNameFromUrl(lead.logoUrl);
            setLogoFile(null);
            setLogoFileName(fileName);
            const preview = isRenderableImagePreview(lead.logoUrl) ? lead.logoUrl : null;
            setLogoPreviewUrl(preview);
            persistLogoToSession(fileName, preview);
          } else {
            const cached = sessionStorage.getItem(logoCacheKey);
            if (cached) {
              try {
                const parsed = JSON.parse(cached) as { name?: string; previewUrl?: string | null };
                setLogoFile(null);
                setLogoFileName(parsed?.name ?? "");
                setLogoPreviewUrl(parsed?.previewUrl ?? null);
              } catch {
                setLogoFile(null);
                setLogoFileName("");
                setLogoPreviewUrl(null);
              }
            } else {
              setLogoFile(null);
              setLogoFileName("");
              setLogoPreviewUrl(null);
            }
          }
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setLoadError(err instanceof Error ? err.message : "Failed to load details");
          toast.error(err instanceof Error ? err.message : "Failed to load details");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  const startValues = loadedValues ?? initialValues;
  const isReady = !leadId || loadedValues !== null || loadError !== null;

  if (!leadId) {
    return (
      <div className="max-w-[1085px] flex flex-col gap-5">
        <p className="text-xs text-[#6D6D6D]">
          Please complete the previous steps to access this form.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-[1085px] flex items-center justify-center py-12">
        <p className="text-sm text-[#6D6D6D]">Loading details...</p>
      </div>
    );
  }

  return (
    <Formik
      key={leadId}
      initialValues={startValues}
      enableReinitialize
      validationSchema={detailsSearchValidationSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        if (!leadId) return;
        try {
          const dateOfUseStr = values.dateOfUse ? toLocalYmd(values.dateOfUse) : "";
          await submitSearchDetails(
            leadId,
            {
              tradeName: values.tradeName,
              dateOfUse: dateOfUseStr,
              goodsDescription: values.goodsDescription,
            },
            logoFile ?? undefined
          );
          toast.success("Details for search saved successfully.");
          setStatus({ type: "success", message: "Details saved successfully." });
          onSuccess?.(leadId);
        } catch (err) {
          setStatus({
            type: "error",
            message: err instanceof Error ? err.message : "Failed to save details.",
          });
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ setFieldValue, values, status }) => (
        <Form
          id="details-search-form"
          className="max-w-[1085px] flex flex-col gap-5"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="flex flex-col gap-1">
              <label className="text-xs text-[#222] font-normal leading-5">
                Client Tradename
              </label>
              <Field
                name="tradeName"
                type="text"
                placeholder="Text Here"
                className="w-full px-2.5 py-2 text-xs border border-[#EEE] rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-[#222] placeholder:text-[#6D6D6D]"
              />
              <ErrorMessage
                name="tradeName"
                component="div"
                className="text-xs text-red-500 mt-0.5"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-[#222] font-normal leading-5">
                Date of Use
              </label>
              <DateTimePicker
                value={values.dateOfUse}
                onChange={(date) => setFieldValue("dateOfUse", date)}
              />
              <ErrorMessage
                name="dateOfUse"
                component="div"
                className="text-xs text-red-500 mt-0.5"
              />
            </div>
          </div>
          {/* Logo Upload - matches Figma & ImageOfMarkField pattern */}
          <div className="flex flex-col gap-2">
            <label className="text-xs text-[#222222] font-normal leading-5">
              Logo Upload
            </label>
            <p className="text-[11px] text-[#6D6D6D] leading-4">
              Choose a file and upload securely to proceed.
            </p>
            <input
              ref={logoInputRef}
              type="file"
              accept="image/*,.pdf"
              className="hidden"
              onChange={(e) => {
                const file = e.target.files?.[0] ?? null;
                handleLogoSelection(file);
              }}
            />
            <div
              onClick={() => logoInputRef.current?.click()}
              onDragOver={(e) => {
                e.preventDefault();
                e.currentTarget.classList.add("!border-[#222222]", "!bg-[#F7F7F7]");
              }}
              onDragLeave={(e) => {
                e.preventDefault();
                e.currentTarget.classList.remove("!border-[#222222]", "!bg-[#F7F7F7]");
              }}
              onDrop={(e) => {
                e.preventDefault();
                e.currentTarget.classList.remove("!border-[#222222]", "!bg-[#F7F7F7]");
                const file = e.dataTransfer.files?.[0];
                if (file && (file.type.startsWith("image/") || file.type === "application/pdf")) {
                  handleLogoSelection(file);
                }
              }}
              className="box-border flex flex-row flex-wrap items-center gap-3 p-4 w-full min-h-[96px] bg-white border-2 border-dashed border-[#D8DAEB] rounded-[16px] cursor-pointer hover:border-[#222222] hover:bg-[#F7F7F7] transition-colors"
            >
              <div className="flex-shrink-0 w-[60px] h-[60px] flex items-center justify-center">
                <img src={fileIcon} alt="File" className="w-10 h-10" />
              </div>
              <div className="flex-1 min-w-[150px] flex flex-col gap-0.5">
                <span className="text-xs font-medium leading-4 text-[#101111]">
                  Drag and drop your files
                </span>
                <span className="text-[11px] leading-4 text-[#7D7D7D]">
                  JPEG, PNG, PDF, and MP4 formats, up to 50MB
                </span>
                {logoFileName && (
                  <span className="text-[11px] leading-4 text-[#222222] mt-1">
                    Selected: {logoFileName}
                  </span>
                )}
                {logoPreviewUrl && (
                  <div className="mt-2">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowLargeLogoPreview(true);
                      }}
                      className="group inline-flex items-center gap-2 rounded border border-transparent p-0 text-left"
                    >
                      {detectPreviewKind(logoFileName || logoPreviewUrl) === "image" ? (
                        <img
                          src={logoPreviewUrl}
                          alt="Uploaded logo preview"
                          className="h-14 w-auto rounded border border-[#EEE] group-hover:border-[#222]"
                        />
                      ) : (
                        <span className="text-[11px] leading-4 text-[#2E3037] underline underline-offset-2">
                          Preview
                        </span>
                      )}
                    </button>
                  </div>
                )}
              </div>
              <div className="inline-flex items-center gap-2">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    logoInputRef.current?.click();
                  }}
                  className="inline-flex items-center justify-center h-9 px-4 text-xs font-medium leading-5 text-[#2E3037] bg-white border border-[#D5D3E0] rounded-[10px] whitespace-nowrap hover:bg-gray-50"
                >
                  Select File
                </button>
                {logoFileName && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLogoRemove();
                    }}
                    className="inline-flex items-center justify-center h-9 px-4 text-xs font-medium leading-5 text-[#B42318] bg-white border border-[#F0C1BE] rounded-[10px] whitespace-nowrap hover:bg-[#FFF5F4]"
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-[#222] font-normal leading-5">
              Goods / Services Shared
            </label>
            <Field
              name="goodsDescription"
              as="textarea"
              placeholder="Text Here"
              rows={4}
              className="w-full min-h-[100px] px-2.5 py-2 text-xs border border-[#EEE] rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-[#222] placeholder:text-[#6D6D6D] resize-none"
            />
            <ErrorMessage
              name="goodsDescription"
              component="div"
              className="text-xs text-red-500 mt-0.5"
            />
          </div>
          {status && (
            <div
              className={`text-xs ${
                status.type === "success" ? "text-green-600" : "text-red-500"
              }`}
            >
              {status.message}
            </div>
          )}
          <FilePreviewModal
            open={showLargeLogoPreview && !!logoPreviewUrl}
            onClose={() => setShowLargeLogoPreview(false)}
            name={logoFileName || "Logo"}
            url={logoPreviewUrl ?? undefined}
            kind={logoPreviewUrl ? detectPreviewKind(logoFileName || logoPreviewUrl) : undefined}
          />
        </Form>
      )}
    </Formik>
  );
}

type ChecklistSearchToClientViewProps = {
  leadId?: string;
  canResend?: boolean;
  onResend?: () => void;
  resending?: boolean;
};

function ChecklistSearchToClientView({
  leadId,
  canResend,
  onResend,
  resending,
}: ChecklistSearchToClientViewProps) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(!!leadId);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!leadId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    getLeadDetails(leadId)
      .then(({ lead }) => {
        if (!cancelled && lead.phone) {
          setPhoneNumber(lead.phone);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          toast.error(err instanceof Error ? err.message : "Failed to load lead details");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  if (loading) {
    return (
      <div className="max-w-[1085px] flex items-center justify-center py-12">
        <p className="text-sm text-[#6D6D6D]">Loading lead details...</p>
      </div>
    );
  }

  return (
    <div className="max-w-[1085px] flex flex-col gap-5">
      {/* Message to be sent - Figma: prominent title, dark text */}
      <div className="flex flex-col gap-1">
        <h2 className="text-sm font-medium text-[#000000] tracking-[0]">
          Message to be sent:
        </h2>
        <div className="w-full border border-[#EEE] rounded-md bg-white overflow-hidden min-h-[240px]">
          <div
            className="w-full min-h-[228px] px-3 py-3 text-xs text-[#000000] font-normal leading-[1.5] whitespace-pre-wrap break-words"
            style={{ letterSpacing: 0 }}
          >
            {renderWhatsAppFormatting(CHECKLIST_MESSAGE_TEMPLATE)}
          </div>
        </div>
      </div>
      {/* Phone (read-only) */}
      <div className="flex flex-wrap items-center gap-4">
        <input
          type="tel"
          inputMode="numeric"
          value={phoneNumber}
          readOnly
          placeholder="e.g. +919876543210 or 9876543210"
          className="w-full min-w-0 sm:w-[200px] h-9 px-2.5 py-2 text-xs text-[#000000] border border-[#EEE] rounded-md bg-[#F7F7F7] placeholder:text-[#6d6d6d]"
          style={{ letterSpacing: 0 }}
        />
        {canResend && onResend && (
          <button
            type="button"
            onClick={onResend}
            disabled={resending}
            className="inline-flex items-center justify-center h-9 px-4 text-xs font-medium leading-5 text-[#2E3037] bg-white border border-[#D5D3E0] rounded-[10px] whitespace-nowrap hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {resending ? "Resending…" : "Resend to WhatsApp"}
          </button>
        )}
      </div>
    </div>
  );
}

const INVOICE_ADVANCE_PHONE_DEFAULT = "(303) 420-4261";
const INVOICE_ADVANCE_PAYMENT = {
  gpayPhone: "9349193199",
  accountHolder: "UPRIGHT LEGAL SOLUTIONS",
  accountNo: "32613886303",
  bank: "State Bank of India",
  branch: "Nadakkavu, Kozhikode",
  ifsc: "SBIN0002260",
};

function buildInvoiceAdvanceMessage(
  advanceAmount: string | number,
  payment: {
    gpayPhone: string;
    accountHolder: string;
    accountNo: string;
    bank: string;
    branch: string;
    ifsc: string;
  }
): string {
  const amount = advanceAmount || "0";
  return `Advance Amount for Class Identification & Search in Trademark Database: Rs. ${amount}/-

Gpay/Phonepay : ${payment.gpayPhone}

Account holder : ${payment.accountHolder}

Account No. : ${payment.accountNo}

Bank : ${payment.bank}

Branch : ${payment.branch}

IFSC Code : ${payment.ifsc}`;
}

interface InvoiceAdvanceAmountViewProps {
  leadId?: string | null;
  onSuccess?: (leadId: string) => void;
}

const CLASS_LIST_MESSAGE_PREFIX = `Based on the list of goods & services furnished by World Intellectual Property Organisation (WIPO), we understand that your mark falls under the following list of classes & goods / services. We are about to make a detailed search in the database of the Trademark Registry of Govt of India & will be sharing you the search reports.

`;

function buildMessagePreview(
  classes: { classNum: string; goodsServices: string[] }[]
): string {
  if (!classes.length) return CLASS_LIST_MESSAGE_PREFIX.trim();
  const listLines = classes
    .filter((c) => c.classNum && c.goodsServices?.length > 0)
    .map((c) => `*Class ${c.classNum}:*\n${c.goodsServices.join(", ").trim()}`)
    .join("\n\n");
  return CLASS_LIST_MESSAGE_PREFIX + (listLines || "").trim();
}

type ClassRow = { id: string; classNum: string; goodsServices: string[] };

type ClassListToClientViewProps = {
  leadId?: string | null;
  onSuccess?: (leadId: string) => void;
  onSentStatusChange?: (sent: boolean) => void;
};

function ClassListToClientView({
  leadId,
  onSuccess,
  onSentStatusChange,
}: ClassListToClientViewProps) {
  const [classes, setClasses] = useState<ClassRow[]>([
    { id: "1", classNum: "", goodsServices: [] },
  ]);
  const [inputValueByRow, setInputValueByRow] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(!!leadId);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);
  const [goodsSuggestionsByClass, setGoodsSuggestionsByClass] = useState<
    Record<string, string[]>
  >({});
  const [loadingSuggestionsFor, setLoadingSuggestionsFor] = useState<string | null>(null);
  const [focusedRowId, setFocusedRowId] = useState<string | null>(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const searchDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmPreviewContent, setConfirmPreviewContent] = useState("");
  const [hasSentWhatsapp, setHasSentWhatsapp] = useState(false);
  const [confirmMode, setConfirmMode] = useState<"send" | "resend">("send");
  const [sendingToClient, setSendingToClient] = useState(false);

  const fetchGoodsSuggestionsWithSearch = useCallback(
    (classNum: string, rowId: string, search?: string) => {
      const num = parseInt(classNum, 10);
      if (!classNum || num < 1 || num > 45) {
        setGoodsSuggestionsByClass((prev) => ({ ...prev, [rowId]: [] }));
        setLoadingSuggestionsFor(null);
        return;
      }
      setLoadingSuggestionsFor(rowId);
      getListsByClass(num, search?.trim() || undefined)
        .then((res) => {
          setGoodsSuggestionsByClass((prev) => ({
            ...prev,
            [rowId]: res.goodsServices ?? [],
          }));
        })
        .catch(() =>
          setGoodsSuggestionsByClass((prev) => ({ ...prev, [rowId]: [] }))
        )
        .finally(() => setLoadingSuggestionsFor(null));
    },
    []
  );

  useEffect(() => {
    if (!leadId) {
      setLoading(false);
      setLoadError(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    getSavedClassList(leadId)
      .then((classData) => {
        if (cancelled) return;
        getLeadDetails(leadId)
          .then(({ lead }) => {
            if (!cancelled && lead?.phone) {
              setMobileNumber(formatPhoneInput(lead.phone));
            }
          })
          .catch(() => {});
        if (classData?.classes && classData.classes.length > 0) {
          const base = Date.now();
          const newClasses: ClassRow[] = classData.classes.map((c, i) => ({
            id: String(base + i),
            classNum: String(c.classNumber),
            goodsServices: Array.isArray(c.goodsServices)
              ? c.goodsServices.filter((s) => s && String(s).trim())
              : c.goodsServices
                ? [String(c.goodsServices).trim()].filter(Boolean)
                : [],
          }));
          setClasses(newClasses);
          newClasses.forEach((row) => {
            if (row.classNum)
              getListsByClass(parseInt(row.classNum, 10))
                .then((res) => {
                  if (!cancelled)
                    setGoodsSuggestionsByClass((prev) => ({
                      ...prev,
                      [row.id]: res.goodsServices ?? [],
                    }));
                })
                .catch(() => {});
          });
        } else {
          setClasses([{ id: "1", classNum: "", goodsServices: [] }]);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          toast.error(
            err instanceof Error ? err.message : "Failed to load class list"
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  useEffect(() => {
    if (!leadId) {
      setHasSentWhatsapp(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const status = await getWorkflowStatus(leadId);
        const step = status.steps.find(
          (s) => s.slug === "S1_06_CLASS_LIST_TO_CLIENT"
        );
        if (!cancelled && step) {
          setHasSentWhatsapp(step.isCompleted);
          onSentStatusChange?.(step.isCompleted);
        }
      } catch {
        if (!cancelled) {
          setHasSentWhatsapp(false);
          onSentStatusChange?.(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  useEffect(() => {
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, []);

  const handleAddClass = () => {
    setClasses((prev) => [
      ...prev,
      { id: String(Date.now()), classNum: "", goodsServices: [] },
    ]);
  };

  const handleClassChange = (id: string, value: string) => {
    setClasses((prev) =>
      prev.map((c) =>
        c.id !== id ? c : { ...c, classNum: value }
      )
    );
    if (value) fetchGoodsSuggestionsWithSearch(value, id);
  };

  const addGoodsService = (rowId: string, value: string) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    setClasses((prev) =>
      prev.map((c) => {
        if (c.id !== rowId) return c;
        const lower = trimmed.toLowerCase();
        if (c.goodsServices.some((s) => s.toLowerCase() === lower)) return c;
        return { ...c, goodsServices: [...c.goodsServices, trimmed] };
      })
    );
    setInputValueByRow((prev) => ({ ...prev, [rowId]: "" }));
  };

  const removeGoodsService = (rowId: string, index: number) => {
    setClasses((prev) =>
      prev.map((c) =>
        c.id !== rowId
          ? c
          : { ...c, goodsServices: c.goodsServices.filter((_, i) => i !== index) }
      )
    );
  };

  const handleInputChange = (rowId: string, value: string, classNum: string) => {
    setInputValueByRow((prev) => ({ ...prev, [rowId]: value }));
    setFocusedRowId(rowId);
    if (!classNum || parseInt(classNum, 10) < 1 || parseInt(classNum, 10) > 45)
      return;
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      searchDebounceRef.current = null;
      fetchGoodsSuggestionsWithSearch(classNum, rowId, value.trim() || undefined);
    }, 300);
  };

  const handleInputKeyDown = (
    rowId: string,
    e: React.KeyboardEvent<HTMLInputElement>,
    classNum: string
  ) => {
    const inputVal = (inputValueByRow[rowId] ?? "").trim();
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (inputVal) addGoodsService(rowId, inputVal);
    }
  };

  const handleInputPaste = (
    rowId: string,
    e: React.ClipboardEvent<HTMLInputElement>,
    classNum: string
  ) => {
    const pasted = e.clipboardData.getData("text");
    if (!pasted.includes(",") && !pasted.includes(";") && !pasted.includes("\n"))
      return;
    e.preventDefault();
    const items = pasted
      .split(/[,;\n]/)
      .map((s) => s.trim())
      .filter(Boolean);
    items.forEach((item) => addGoodsService(rowId, item));
  };

  const handleSuggestionClick = (rowId: string, suggestion: string) => {
    addGoodsService(rowId, suggestion);
    setFocusedRowId(null);
  };

  const handleRemoveClass = (id: string) => {
    setClasses((prev) => prev.filter((c) => c.id !== id));
  };

  const buildClassListSavePayload = (): {
    classNumber: number;
    goodsServices: string[];
  }[] => {
    return classes
      .filter((c) => c.classNum && c.goodsServices.length > 0)
      .map((c) => {
        const classNum = parseInt(c.classNum, 10);
        const goodsServices = c.goodsServices
          .map((s) => s.trim())
          .filter(Boolean);
        return { classNumber: classNum, goodsServices };
      })
      .filter(
        (c) =>
          c.classNumber >= 1 &&
          c.classNumber <= 45 &&
          c.goodsServices.length > 0
      );
  };

  const handleSaveAndContinue = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadId) return;
    const payload = buildClassListSavePayload();

    if (!payload.length) {
      toast.error("Add at least one class with goods/services");
      return;
    }
    setSaveError(null);
    setSaving(true);
    try {
      await saveClassList(leadId, { classes: payload });
      if (hasSentWhatsapp) {
        toast.success("Class list updated successfully.");
        onSuccess?.(leadId);
        return;
      }
      setConfirmPreviewContent(buildMessagePreview(classes));
      setConfirmMode("send");
      setShowConfirmModal(true);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to save class list");
    } finally {
      setSaving(false);
    }
  };

  const handleConfirmProceed = () => {
    if (!leadId || sendingToClient) return;
    setShowConfirmModal(false);
    setSendingToClient(true);
    (async () => {
      try {
        await sendClassListToClient(leadId);
        setHasSentWhatsapp(true);
        onSentStatusChange?.(true);
        toast.success(
          confirmMode === "resend"
            ? "Class list resent to client via WhatsApp."
            : "Class list sent to client via WhatsApp."
        );
        onSuccess?.(leadId);
      } catch (err) {
        toast.error(
          err instanceof Error ? err.message : "Failed to send class list to client"
        );
      } finally {
        setSendingToClient(false);
      }
    })();
  };

  if (!leadId) {
    return (
      <div className="max-w-[1085px] flex flex-col gap-5">
        <p className="text-xs text-[#6D6D6D]">
          Please complete the previous steps to access this form.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-[1085px] flex items-center justify-center py-12">
        <p className="text-sm text-[#6D6D6D]">Loading...</p>
      </div>
    );
  }

  return (
    <form
      id="class-list-form"
      onSubmit={handleSaveAndContinue}
      className="max-w-[1085px] flex flex-col gap-5"
    >

      {/* Goods / Services - Figma: header row Class 260px | Goods 250px; mobile: stacked */}
      <div className="flex flex-col gap-4">
        <div className="hidden md:flex flex-row items-center gap-5">
          <span className="w-[260px] text-sm font-medium text-[#222] leading-5">
            Class
          </span>
          <span className="w-[250px] text-sm font-medium text-[#222] leading-5">
            Goods / Services (Manual Edit/Paste)
          </span>
        </div>
        <div className="flex flex-col gap-3">
          {classes.map((row) => (
            <div
              key={row.id}
              className="flex flex-col md:flex-row md:items-center gap-3 md:gap-5 w-full p-4 md:p-0 md:py-0 rounded-[6px] border border-[#EEE] md:border-0 md:rounded-none bg-white md:bg-transparent"
            >
              <div className="flex flex-row items-center gap-2 md:gap-0 w-full md:w-[260px] md:flex-shrink-0">
                <label className="md:hidden text-[12px] font-medium text-[#222] leading-5 shrink-0 w-14">
                  Class
                </label>
                <div className="flex-1 min-w-0 md:min-w-0">
                  <Select
                    value={row.classNum || undefined}
                    onValueChange={(v) => handleClassChange(row.id, v)}
                  >
                    <SelectTrigger className="h-10 w-full text-[12px] md:text-sm">
                      <SelectValue placeholder="Class" />
                    </SelectTrigger>
                    <SelectContent>
                      {(() => {
                        const usedByOthers = new Set(
                          classes.filter((c) => c.id !== row.id && c.classNum).map((c) => c.classNum)
                        );
                        return Array.from({ length: 45 }, (_, i) => i + 1).map((n) => (
                          <SelectItem key={n} value={String(n)} disabled={usedByOthers.has(String(n))}>
                            Class {n}
                          </SelectItem>
                        ));
                      })()}
                    </SelectContent>
                  </Select>
                </div>
                <button
                  type="button"
                  onClick={() => handleRemoveClass(row.id)}
                  className="md:hidden flex-shrink-0 w-10 h-10 flex items-center justify-center text-[#6D6D6D] hover:text-[#222] rounded-md hover:bg-[#F7F7F7] touch-manipulation"
                  aria-label="Remove class"
                >
                  <HiOutlineX className="w-4 h-4" strokeWidth={2} />
                </button>
              </div>
              <div className="flex flex-col gap-1 flex-1 min-w-0 w-full md:w-auto relative">
                <label className="md:hidden text-[12px] font-medium text-[#222] leading-5">
                  Goods / Services (Manual Edit/Paste)
                </label>
                <div
                  className="flex flex-wrap gap-2.5 items-center min-h-10 px-2.5 py-2 border border-[#EEE] rounded-[6px] bg-white focus-within:ring-1 focus-within:ring-[#222]"
                  onClick={() =>
                    document.getElementById(row.id + "-goods-input")?.focus()
                  }
                >
                  {row.goodsServices.map((item, idx) => (
                    <span
                      key={`${item}-${idx}`}
                      className="inline-flex gap-1 items-center justify-center px-1 py-0.5 rounded-[6px] bg-[#F7F7F7] text-xs md:text-sm font-normal text-[#222]"
                    >
                      {item}
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeGoodsService(row.id, idx);
                        }}
                        className="p-0.5 rounded hover:bg-[#EEE] text-[#6D6D6D] hover:text-[#222] touch-manipulation"
                        aria-label={`Remove ${item}`}
                      >
                        <HiOutlineX className="w-3 h-3" strokeWidth={2} />
                      </button>
                    </span>
                  ))}
                  <input
                    id={row.id + "-goods-input"}
                    type="text"
                    placeholder={
                      loadingSuggestionsFor === row.id
                        ? "Loading suggestions..."
                        : "Type to search, paste, or select below..."
                    }
                    value={inputValueByRow[row.id] ?? ""}
                    onChange={(e) =>
                      handleInputChange(row.id, e.target.value, row.classNum)
                    }
                    onKeyDown={(e) =>
                      handleInputKeyDown(row.id, e, row.classNum)
                    }
                    onPaste={(e) => handleInputPaste(row.id, e, row.classNum)}
                    onFocus={() => setFocusedRowId(row.id)}
                    onClick={() => setFocusedRowId(row.id)}
                    onBlur={() =>
                      setTimeout(() => setFocusedRowId(null), 150)
                    }
                    className="flex-1 min-w-[80px] md:min-w-[120px] py-1 text-[12px] md:text-sm font-normal text-[#222] bg-transparent border-none focus:outline-none placeholder:text-[#6D6D6D]"
                  />
                </div>
                {focusedRowId === row.id &&
                  row.classNum &&
                  (goodsSuggestionsByClass[row.id]?.length ?? 0) > 0 && (
                    <div
                      className="absolute left-0 right-0 top-full mt-1 z-20 max-h-48 overflow-y-auto border border-[#EEE] rounded-[6px] bg-white shadow-lg"
                      role="listbox"
                    >
                      {goodsSuggestionsByClass[row.id]
                        .filter(
                          (g) =>
                            !row.goodsServices
                              .map((s) => s.toLowerCase())
                              .includes(g.trim().toLowerCase())
                        )
                        .slice(0, 15)
                        .map((g, i) => (
                          <button
                            key={`${g}-${i}`}
                            type="button"
                            role="option"
                            className="w-full text-left px-2.5 py-2.5 text-[12px] md:text-sm text-[#222] hover:bg-[#F7F7F7] active:bg-[#F7F7F7] border-b border-[#EEE] last:border-b-0 touch-manipulation"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleSuggestionClick(row.id, g);
                            }}
                          >
                            {g}
                          </button>
                        ))}
                    </div>
                  )}
              </div>
              <button
                type="button"
                onClick={() => handleRemoveClass(row.id)}
                className="hidden md:flex flex-shrink-0 w-9 h-10 items-center justify-center text-[#6D6D6D] hover:text-[#222] border border-transparent rounded-md hover:bg-[#F7F7F7]"
                aria-label="Remove class"
              >
                <HiOutlineX className="w-4 h-4" strokeWidth={2} />
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={handleAddClass}
          className="flex items-center gap-1.5 text-[12px] md:text-sm text-[#222] font-normal leading-5 hover:text-[#333] py-2 min-h-[44px] touch-manipulation"
        >
          <HiOutlinePlus className="w-4 h-4 shrink-0" strokeWidth={1.5} />
          Add More Custom Class
        </button>
      </div>

      <ConfirmMessageModal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        previewContent={confirmPreviewContent}
        onConfirm={handleConfirmProceed}
      />
      {hasSentWhatsapp && leadId && (
        <div className="flex items-center gap-3">
          <button
            type="button"
            disabled={sendingToClient || saving}
            onClick={async () => {
              if (!leadId || sendingToClient || saving) return;
              const payload = buildClassListSavePayload();
              if (!payload.length) {
                toast.error("Add at least one class with goods/services");
                return;
              }
              setSaveError(null);
              setSaving(true);
              try {
                await saveClassList(leadId, { classes: payload });
                setConfirmPreviewContent(buildMessagePreview(classes));
                setConfirmMode("resend");
                setShowConfirmModal(true);
              } catch (err) {
                toast.error(
                  err instanceof Error ? err.message : "Failed to save class list"
                );
              } finally {
                setSaving(false);
              }
            }}
            className="inline-flex items-center justify-center h-9 px-4 text-xs font-medium leading-5 text-[#2E3037] bg-white border border-[#D5D3E0] rounded-[10px] whitespace-nowrap hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {sendingToClient || saving ? "Resending…" : "Resend to WhatsApp"}
          </button>
        </div>
      )}
    </form>
  );
}

type AdvanceAmountFromClientViewProps = {
  leadId?: string | null;
  onSuccess?: (leadId: string) => void;
};

function AdvanceAmountFromClientView({
  leadId,
  onSuccess,
}: AdvanceAmountFromClientViewProps) {
  const [loading, setLoading] = useState(!!leadId);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [advanceAmount, setAdvanceAmount] = useState("00.00");
  const [collectedAmount, setCollectedAmount] = useState("00.00");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);

  useEffect(() => {
    if (!leadId) {
      setLoading(false);
      setLoadError(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    getAdvanceAmount(leadId)
      .then((data) => {
        if (!cancelled) {
          setAdvanceAmount(
            data.advanceAmount != null && data.advanceAmount > 0
              ? String(data.advanceAmount)
              : "00.00"
          );
          setCollectedAmount(
            data.collectedAmount != null && data.collectedAmount > 0
              ? String(data.collectedAmount)
              : "00.00"
          );
        }
      })
      .catch((err) => {
        if (!cancelled) {
          toast.error(err instanceof Error ? err.message : "Failed to load advance amount");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  const handleSaveAndContinue = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadId) return;
    const num = parseFloat(collectedAmount) || 0;
    const advance = parseFloat(advanceAmount) || 0;
    if (num <= 0) {
      toast.error("Collected amount must be greater than 0");
      return;
    }
    if (num > advance) {
      toast.error("Collected amount cannot exceed the advance amount");
      return;
    }
    setSaveError(null);
    setSaving(true);
    try {
      await collectAdvance(leadId, { collectedAmount: num });
      toast.success("Advance amount saved successfully.");
      onSuccess?.(leadId);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  if (!leadId) {
    return (
      <div className="max-w-[1085px] flex flex-col gap-5">
        <p className="text-xs text-[#6D6D6D]">
          Please complete the previous steps to access this form.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-[1085px] flex items-center justify-center py-12">
        <p className="text-sm text-[#6D6D6D]">Loading...</p>
      </div>
    );
  }

  return (
    <form
      id="advance-amount-form"
      onSubmit={handleSaveAndContinue}
      className="max-w-[1085px] flex flex-col gap-5"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Left column: Advance Amount (Fetched) - readonly from API */}
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#222] font-normal leading-5">
            Advance Amount (Fetched)
          </label>
          <input
            type="text"
            inputMode="decimal"
            placeholder="00.00"
            value={advanceAmount}
            readOnly
            className="w-full px-2.5 py-2 text-xs border border-[#EEE] rounded-md bg-[#F7F7F7] text-[#222] cursor-not-allowed"
          />
        </div>
        {/* Right column: Collected Advance Amount — Rs(₹) + one field */}
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#222] font-normal leading-5">
            Collected Advance Amount
          </label>
          <div className="flex gap-2 items-stretch">
            <Select value="inr" onValueChange={() => {}}>
              <SelectTrigger className="h-[34px] w-auto min-w-[80px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="inr">Rs(₹)</SelectItem>
              </SelectContent>
            </Select>
            <input
              type="text"
              inputMode="decimal"
              placeholder="00.00"
              value={collectedAmount}
              onChange={(e) => setCollectedAmount(e.target.value)}
              className="flex-1 min-w-0 px-2.5 py-2 text-xs border border-[#EEE] rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-[#222] placeholder:text-[#6D6D6D]"
            />
          </div>
        </div>
      </div>
    </form>
  );
}

/** Step 7 WhatsApp text — matches backend `DiscussionTemplates.searchReportToClient` / page 31 (links are appended on send, not shown here). */
const SEARCH_REPORT_MESSAGE_TEMPLATE =
  "We have made a detailed search in the database of the Trademark Registry of Govt of India. Sharing the Search Reports.";

const SEARCH_REPORT_MAX_PDF_BYTES = 10 * 1024 * 1024;
const SEARCH_REPORT_MAX_PDF_MB = 10;

function validateSearchReportPdfFile(file: File): string | null {
  const isPdf =
    file.type === "application/pdf" ||
    file.name.toLowerCase().endsWith(".pdf");
  if (!isPdf) {
    return `${file.name}: only PDF files are allowed.`;
  }
  if (file.size > SEARCH_REPORT_MAX_PDF_BYTES) {
    return `${file.name}: exceeds max size (${SEARCH_REPORT_MAX_PDF_MB} MB per file).`;
  }
  return null;
}

type SearchReportClassRow = {
  classNumber: number;
  similarity: boolean;
  fileUrls: string[];
  fileDownloadUrls: string[];
  pendingFiles: File[];
};

type FilePreview = {
  url: string;
  name: string;
  kind: FilePreviewKind;
  revokeOnClose?: boolean;
};

type SearchReportToClientViewProps = {
  leadId?: string | null;
  onSuccess?: (leadId: string) => void;
  onSentStatusChange?: (sent: boolean) => void;
};

function SearchReportToClientView({
  leadId,
  onSuccess,
  onSentStatusChange,
}: SearchReportToClientViewProps) {
  const [loading, setLoading] = useState(!!leadId);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [classes, setClasses] = useState<SearchReportClassRow[]>([]);
  const [nonDistinctiveness, setNonDistinctiveness] = useState<boolean | "">("");
  const [nonDistinctivenessDisplay, setNonDistinctivenessDisplay] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);
  const [isDraggingByClass, setIsDraggingByClass] = useState<number | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [hasSentWhatsapp, setHasSentWhatsapp] = useState(false);
  const [confirmMode, setConfirmMode] = useState<"send" | "resend">("send");
  const [uploadProgressLabel, setUploadProgressLabel] = useState<string | null>(null);
  const [preview, setPreview] = useState<FilePreview | null>(null);
  const [classFileErrors, setClassFileErrors] = useState<Set<number>>(new Set());

  const openUploadedPreview = (classNumber: number, index: number) => {
    const row = classes.find((c) => c.classNumber === classNumber);
    if (!row) return;
    const url = row.fileDownloadUrls[index];
    if (!url) {
      toast.error("Preview not available. Please save and try again.");
      return;
    }
    const key = row.fileUrls[index] ?? "";
    const name = getUploadedFileLabel(key, index);
    setPreview({ url, name, kind: detectPreviewKind(key) });
  };

  const openPendingPreview = (classNumber: number, index: number) => {
    const row = classes.find((c) => c.classNumber === classNumber);
    const file = row?.pendingFiles[index];
    if (!file) return;
    setPreview({
      url: URL.createObjectURL(file),
      name: file.name,
      kind: detectPreviewKind(file.name, file.type),
      revokeOnClose: true,
    });
  };

  const closePreview = () => {
    if (preview?.revokeOnClose) URL.revokeObjectURL(preview.url);
    setPreview(null);
  };

  useEffect(() => {
    if (!leadId) {
      setLoading(false);
      setLoadError(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    getSearchReportDetails(leadId)
      .then((data) => {
        if (cancelled) return;
        if (data.lead.phone) setPhoneNumber(data.lead.phone);
        const nd = data.lead.nonDistinctiveness;
        setNonDistinctiveness(nd === true ? true : nd === false ? false : "");
        setNonDistinctivenessDisplay(
          nd === true ? "non-distinctive" : nd === false ? "distinct" : ""
        );
        const classRows: SearchReportClassRow[] = (data.classes ?? []).map((c) => {
          const urls = Array.isArray(c.fileUrls) ? c.fileUrls : [];
          const downloads = Array.isArray(c.fileDownloadUrls) ? c.fileDownloadUrls : [];
          return {
            classNumber: c.classNumber,
            similarity: c.similarity ?? false,
            fileUrls: urls,
            fileDownloadUrls: urls.map((_, i) => downloads[i] ?? ""),
            pendingFiles: [],
          };
        });
        setClasses(classRows);
      })
      .catch((err) => {
        if (!cancelled) {
          toast.error(err instanceof Error ? err.message : "Failed to load search report details");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  useEffect(() => {
    if (!leadId) {
      setHasSentWhatsapp(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const status = await getWorkflowStatus(leadId);
        const step = status.steps.find(
          (s) => s.slug === "S1_07_SEARCH_REPORT_TO_CLIENT"
        );
        if (!cancelled && step) {
          setHasSentWhatsapp(step.isCompleted);
          onSentStatusChange?.(step.isCompleted);
        }
      } catch {
        if (!cancelled) {
          setHasSentWhatsapp(false);
          onSentStatusChange?.(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [leadId, onSentStatusChange]);

  const handleSimilarityChange = (classNumber: number, value: boolean) => {
    setClasses((prev) =>
      prev.map((c) =>
        c.classNumber === classNumber ? { ...c, similarity: value } : c
      )
    );
  };

  const handleFilesForClass = (classNumber: number, files: FileList | null) => {
    if (!files?.length) return;
    const accepted: File[] = [];
    for (const f of Array.from(files)) {
      const err = validateSearchReportPdfFile(f);
      if (err) toast.error(err);
      else accepted.push(f);
    }
    if (accepted.length === 0) return;
    setClasses((prev) =>
      prev.map((c) =>
        c.classNumber === classNumber
          ? { ...c, pendingFiles: [...c.pendingFiles, ...accepted] }
          : c
      )
    );
    setClassFileErrors((prev) => {
      if (!prev.has(classNumber)) return prev;
      const next = new Set(prev);
      next.delete(classNumber);
      return next;
    });
  };

  const handleRemovePendingFile = (classNumber: number, index: number) => {
    setClasses((prev) =>
      prev.map((c) =>
        c.classNumber === classNumber
          ? { ...c, pendingFiles: c.pendingFiles.filter((_, i) => i !== index) }
          : c
      )
    );
  };

  const handleRemoveUploadedFile = (classNumber: number, index: number) => {
    setClasses((prev) =>
      prev.map((c) =>
        c.classNumber === classNumber
          ? {
              ...c,
              fileUrls: c.fileUrls.filter((_, i) => i !== index),
              fileDownloadUrls: c.fileDownloadUrls.filter((_, i) => i !== index),
            }
          : c
      )
    );
  };

  const getUploadedFileLabel = (key: string, index: number) => {
    const tail = key.split("/").pop() ?? key;
    const extMatch = tail.match(/\.([A-Za-z0-9]+)$/);
    const ext = extMatch ? `.${extMatch[1].toLowerCase()}` : ".pdf";
    return `Uploaded file ${index + 1}${ext}`;
  };

  const handleDragOver = (e: React.DragEvent, classNumber: number) => {
    e.preventDefault();
    setIsDraggingByClass(classNumber);
  };

  const handleDragLeave = () => setIsDraggingByClass(null);

  const handleDrop = (e: React.DragEvent, classNumber: number) => {
    e.preventDefault();
    setIsDraggingByClass(null);
    handleFilesForClass(classNumber, e.dataTransfer.files);
  };

  const uploadFilesAndGetKeys = async (
    leadId: string,
    files: { classNumber: number; file: File }[]
  ): Promise<{ classNumber: number; keys: string[] }[]> => {
    if (files.length === 0) return [];
    for (const f of files) {
      const err = validateSearchReportPdfFile(f.file);
      if (err) throw new Error(err);
    }
    setUploadProgressLabel("Preparing upload…");
    const meta = files.map((f) => ({
      filename: f.file.name,
      mimeType: f.file.type || "application/octet-stream",
    }));
    const urls = await generateSearchReportUploadUrls(leadId, { files: meta });
    const keys: string[] = [];
    for (let i = 0; i < urls.length; i++) {
      setUploadProgressLabel(
        `Uploading file ${i + 1} of ${files.length}: ${files[i].file.name}…`
      );
      const res = await fetch(urls[i].url, {
        method: "PUT",
        body: files[i].file,
        headers: { "Content-Type": files[i].file.type || "application/octet-stream" },
      });
      if (!res.ok) throw new Error(`Failed to upload ${files[i].file.name}`);
      keys.push(urls[i].key);
    }
    const byClass = new Map<number, string[]>();
    files.forEach((f, i) => {
      const arr = byClass.get(f.classNumber) ?? [];
      arr.push(keys[i]);
      byClass.set(f.classNumber, arr);
    });
    return Array.from(byClass.entries()).map(([classNumber, keysArr]) => ({
      classNumber,
      keys: keysArr,
    }));
  };

  const validateSearchReportInputs = (): boolean => {
    if (classes.length === 0) {
      toast.error("Please complete Class List (Step 6) first.");
      return false;
    }
    if (nonDistinctiveness === "") {
      toast.error("Please select Non-Distinctiveness.");
      return false;
    }
    const missing = new Set(
      classes
        .filter((c) => c.fileUrls.length === 0 && c.pendingFiles.length === 0)
        .map((c) => c.classNumber)
    );
    setClassFileErrors(missing);
    if (missing.size > 0) {
      toast.error("Please upload at least one PDF file for each class.");
      return false;
    }
    return true;
  };

  const saveSearchReport = async (sendWhatsapp: boolean) => {
    if (!leadId) return;
    setSaveError(null);
    setSaving(true);
    try {
      const allPending: { classNumber: number; file: File }[] = [];
      classes.forEach((c) => {
        c.pendingFiles.forEach((f) => allPending.push({ classNumber: c.classNumber, file: f }));
      });
      let uploadedByClass: { classNumber: number; keys: string[] }[] = [];
      if (allPending.length > 0) {
        uploadedByClass = await uploadFilesAndGetKeys(leadId, allPending);
      }
      const classToNewKeys = new Map<number, string[]>();
      uploadedByClass.forEach(({ classNumber, keys }) => {
        classToNewKeys.set(classNumber, [...(classToNewKeys.get(classNumber) ?? []), ...keys]);
      });
      const payload = {
        nonDistinctiveness: nonDistinctiveness === true,
        classes: classes.map((c) => {
          const existing = c.fileUrls;
          const uploaded = classToNewKeys.get(c.classNumber) ?? [];
          return {
            class: c.classNumber,
            similarity: c.similarity,
            fileUrls: [...existing, ...uploaded],
          };
        }),
        sendWhatsapp,
      };
      await submitSearchReport(leadId, payload);
      // Persist uploaded files into local state and clear pending buffers after successful save.
      if (allPending.length > 0) {
        try {
          const refreshed = await getSearchReportDetails(leadId);
          setClasses((prev) =>
            prev.map((c) => {
              const next = refreshed.classes?.find((r) => r.classNumber === c.classNumber);
              if (!next) return { ...c, pendingFiles: [] };
              const urls = Array.isArray(next.fileUrls) ? next.fileUrls : [];
              const downloads = Array.isArray(next.fileDownloadUrls) ? next.fileDownloadUrls : [];
              return {
                ...c,
                fileUrls: urls,
                fileDownloadUrls: urls.map((_, i) => downloads[i] ?? ""),
                pendingFiles: [],
              };
            })
          );
        } catch {
          setClasses((prev) =>
            prev.map((c) => {
              const uploaded = classToNewKeys.get(c.classNumber) ?? [];
              if (!uploaded.length) return c;
              return {
                ...c,
                fileUrls: [...c.fileUrls, ...uploaded],
                fileDownloadUrls: [...c.fileDownloadUrls, ...uploaded.map(() => "")],
                pendingFiles: [],
              };
            })
          );
        }
      }
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to save search report");
      throw err;
    } finally {
      setUploadProgressLabel(null);
      setSaving(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadId || !validateSearchReportInputs()) return;
    if (hasSentWhatsapp) {
      try {
        await saveSearchReport(false);
        toast.success("Search report updated successfully.");
        onSuccess?.(leadId);
      } catch {
        // Error toast is handled in saveSearchReport.
      }
      return;
    }
    setConfirmMode("send");
    setShowConfirmModal(true);
  };

  const handleConfirmProceed = () => {
    if (!leadId || saving || !validateSearchReportInputs()) return;
    setShowConfirmModal(false);
    (async () => {
      try {
        await saveSearchReport(true);
        setHasSentWhatsapp(true);
        onSentStatusChange?.(true);
        toast.success(
          confirmMode === "resend"
            ? "Search report resent to client via WhatsApp."
            : "Search report sent to client via WhatsApp."
        );
        onSuccess?.(leadId);
      } catch {
        // Error toast is handled in saveSearchReport.
      }
    })();
  };

  if (!leadId) {
    return (
      <div className="max-w-[1085px] flex flex-col gap-5">
        <p className="text-xs text-[#6D6D6D]">
          Please complete the previous steps to access this form.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-[1085px] flex items-center justify-center py-12">
        <p className="text-sm text-[#6D6D6D]">Loading search report details...</p>
      </div>
    );
  }

  return (
    <form
      id="search-report-form"
      onSubmit={handleSubmit}
      className="max-w-[1085px] w-full flex flex-col gap-5"
    >

      {/* Non-Distinctiveness */}
      <div className="flex flex-col gap-1 flex-1">
        <label className="text-xs text-[#222222] font-normal leading-5">
          Non-Distinctiveness
        </label>
        <Select
          value={nonDistinctivenessDisplay || undefined}
          onValueChange={(v) => {
            setNonDistinctivenessDisplay(v);
            setNonDistinctiveness(v === "distinct" ? false : v === "non-distinctive" ? true : "");
          }}
        >
          <SelectTrigger className="h-9 min-h-[44px] md:min-h-0 w-full text-[12px] md:text-sm rounded-[6px]">
            <SelectValue placeholder="Select an option" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="distinct">Distinct</SelectItem>
            <SelectItem value="non-distinctive">Non-Distinctive</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Per-class: Class | Similarity | File Upload */}
      <div className="flex flex-col p-4 md:p-5 gap-4 md:gap-5 bg-white border border-[#EEEEEE] rounded-[10px]">
        <div>
          <h2 className="text-sm font-semibold text-[#101111] leading-[14px] tracking-[0.01em]">
            Per Class
          </h2>
          <p className="text-xs text-[#7D7D7D] font-normal leading-6 mt-0.5 tracking-[0.04em]">
            Similarity and file upload per class from Step 6.
          </p>
          <p className="text-xs text-[#7D7D7D] font-normal leading-5 mt-1 tracking-[0.04em]">
            PDF only. Maximum file size {SEARCH_REPORT_MAX_PDF_MB} MB per file. Larger files may take
            longer to upload; progress is shown below while saving.
          </p>
        </div>
        {classes.length === 0 ? (
          <p className="text-xs text-[#6D6D6D]">
            No classes found. Please complete Class List (Step 6) first.
          </p>
        ) : (
          <div className="flex flex-col gap-4">
            {classes.map((row) => (
              <div
                key={row.classNumber}
                className="flex flex-col md:flex-row md:items-start gap-4 p-4 border border-[#EEE] rounded-[6px] bg-[#FCFCFC]"
              >
                <div className="flex flex-col gap-1 flex-shrink-0 md:w-[120px]">
                  <label className="text-xs text-[#222222] font-normal leading-5">Class</label>
                  <span className="text-[12px] md:text-sm font-medium text-[#222]">Class {row.classNumber}</span>
                </div>
                <div className="flex flex-col gap-1 flex-1 min-w-0 md:max-w-[200px]">
                  <label className="text-xs text-[#222222] font-normal leading-5">Similarity</label>
                  <Select
                    value={row.similarity ? "yes" : "no"}
                    onValueChange={(v) =>
                      handleSimilarityChange(row.classNumber, v === "yes")
                    }
                  >
                    <SelectTrigger className="h-9 min-h-[44px] md:min-h-0 w-full text-[12px] md:text-sm rounded-[6px]">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="no">No</SelectItem>
                      <SelectItem value="yes">Yes</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex flex-col gap-1 flex-1 min-w-0">
                  <label className="text-xs text-[#222222] font-normal leading-5">
                    File Upload <span className="text-red-500">*</span>
                  </label>
                  <div
                    onDragOver={(e) => handleDragOver(e, row.classNumber)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, row.classNumber)}
                    className={`flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-3 p-3 sm:p-4 border-2 border-dashed rounded-[12px] sm:rounded-[16px] bg-white transition-colors min-h-[80px] ${
                      classFileErrors.has(row.classNumber)
                        ? "border-red-400 bg-red-50"
                        : isDraggingByClass === row.classNumber
                          ? "border-[#222222] bg-[#F7F7F7]"
                          : "border-[#D8DAEB]"
                    }`}
                  >
                    <div className="flex-shrink-0 w-10 h-10 sm:w-[40px] sm:h-[40px] flex items-center justify-center">
                      <img src={fileIcon} alt="File" className="w-6 h-6" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[12px] md:text-xs text-[#7D7D7D]">
                        PDF — max {SEARCH_REPORT_MAX_PDF_MB} MB each
                      </p>
                      {(row.fileUrls.length > 0 || row.pendingFiles.length > 0) && (
                        <p className="text-[12px] md:text-xs text-[#222222] mt-0.5">
                          {row.fileUrls.length + row.pendingFiles.length} file(s)
                        </p>
                      )}
                    </div>
                    <label className="flex-shrink-0 touch-manipulation">
                      <input
                        type="file"
                        multiple
                        accept=".pdf,application/pdf"
                        onChange={(e) => handleFilesForClass(row.classNumber, e.target.files)}
                        className="sr-only"
                      />
                      <span className="inline-flex items-center justify-center min-h-[44px] h-9 px-4 text-[12px] md:text-sm font-medium text-[#2E3037] bg-white border border-[#D5D3E0] rounded-[10px] cursor-pointer hover:bg-gray-50 active:bg-gray-100 w-full sm:w-auto">
                        Select file
                      </span>
                    </label>
                  </div>
                  {(row.fileUrls.length > 0 || row.pendingFiles.length > 0) && (
                    <div className="flex flex-wrap gap-2 mt-1">
                      {row.fileUrls.map((key, i) => (
                        <span
                          key={`u-${i}`}
                          className="inline-flex items-center gap-1 px-2 py-1.5 text-[12px] md:text-xs bg-[#E6F4EA] text-[#1E6B3A] rounded-[6px]"
                        >
                          <button
                            type="button"
                            onClick={() => openUploadedPreview(row.classNumber, i)}
                            className="truncate max-w-[160px] sm:max-w-none underline-offset-2 hover:underline disabled:no-underline disabled:opacity-60"
                            disabled={!row.fileDownloadUrls[i]}
                            title="Preview file"
                          >
                            {getUploadedFileLabel(key, i)}
                          </button>
                          <button
                            type="button"
                            onClick={() => handleRemoveUploadedFile(row.classNumber, i)}
                            disabled={saving}
                            className="text-red-500 hover:text-red-700 p-0.5 -m-0.5 touch-manipulation shrink-0 disabled:opacity-50"
                            aria-label="Remove uploaded file"
                          >
                            <HiOutlineX className="w-3.5 h-3.5" strokeWidth={2} />
                          </button>
                        </span>
                      ))}
                      {row.pendingFiles.map((f, i) => (
                        <span
                          key={`p-${i}`}
                          className="inline-flex items-center gap-1 px-2 py-1.5 text-[12px] md:text-xs bg-[#EEE] rounded-[6px]"
                        >
                          <button
                            type="button"
                            onClick={() => openPendingPreview(row.classNumber, i)}
                            className="truncate max-w-[120px] sm:max-w-none underline-offset-2 hover:underline"
                            title="Preview file"
                          >
                            {f.name}
                          </button>
                          <button
                            type="button"
                            onClick={() => handleRemovePendingFile(row.classNumber, i)}
                            className="text-red-500 hover:text-red-700 p-0.5 -m-0.5 touch-manipulation shrink-0"
                            aria-label="Remove"
                          >
                            <HiOutlineX className="w-3.5 h-3.5" strokeWidth={2} />
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                  {classFileErrors.has(row.classNumber) && (
                    <p className="text-xs text-red-500 mt-0.5">
                      Please upload at least one PDF file for Class {row.classNumber}.
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {saving && uploadProgressLabel ? (
        <div
          className="flex items-center gap-2 rounded-[10px] border border-[#D8DAEB] bg-[#F7F7FC] px-4 py-3"
          role="status"
          aria-live="polite"
        >
          <span className="text-xs text-[#222222]">{uploadProgressLabel}</span>
        </div>
      ) : null}

      <ConfirmMessageModal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        previewContent={SEARCH_REPORT_MESSAGE_TEMPLATE}
        onConfirm={handleConfirmProceed}
      />

      <FilePreviewModal
        open={!!preview}
        onClose={closePreview}
        name={preview?.name ?? ""}
        url={preview?.url}
        kind={preview?.kind}
      />

      {hasSentWhatsapp && leadId && (
        <div className="flex items-center gap-3">
          <button
            type="button"
            disabled={saving}
            onClick={async () => {
              if (!leadId || saving || !validateSearchReportInputs()) return;
              try {
                await saveSearchReport(false);
                setConfirmMode("resend");
                setShowConfirmModal(true);
              } catch {
                // Error toast is handled in saveSearchReport.
              }
            }}
            className="inline-flex items-center justify-center h-9 px-4 text-xs font-medium leading-5 text-[#2E3037] bg-white border border-[#D5D3E0] rounded-[10px] whitespace-nowrap hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {saving ? "Resending…" : "Resend to WhatsApp"}
          </button>
        </div>
      )}
    </form>
  );
}

type LegalAdviceViewProps = {
  leadId: string | null;
  onSuccess?: (leadId: string) => void;
  onNewMarkSuccess?: (newLeadId: string) => void;
};

function LegalAdviceView({ leadId, onSuccess, onNewMarkSuccess }: LegalAdviceViewProps) {
  const [loading, setLoading] = useState(!!leadId);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [mark, setMark] = useState("");
  const [showNewMarkForm, setShowNewMarkForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);

  useEffect(() => {
    if (!leadId) {
      setMark("");
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    getLeadDetails(leadId)
      .then(({ lead }) => {
        if (!cancelled) setMark(lead.markName ?? "");
      })
      .catch((err) => {
        if (!cancelled) toast.error(err instanceof Error ? err.message : "Failed to load lead");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  const handleSaveAndContinue = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadId) return;
    setSaving(true);
    setSaveError(null);
    try {
      await completeLegalAdvice(leadId);
      toast.success("Legal advice completed successfully.");
      onSuccess?.(leadId);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to complete legal advice");
    } finally {
      setSaving(false);
    }
  };

  if (!leadId) {
    return (
      <div className="max-w-[1085px] flex flex-col gap-5" style={{ fontFamily: "Inter, sans-serif" }}>
        <div className="text-sm text-[#6D6D6D]">No lead selected. Please select a lead first.</div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="max-w-[1085px] flex flex-col gap-5" style={{ fontFamily: "Inter, sans-serif" }}>
        <div className="text-xs text-[#6D6D6D]">Loading lead details...</div>
      </div>
    );
  }

  return (
    <form
      id="legal-advice-form"
      onSubmit={handleSaveAndContinue}
      className="max-w-[1085px] flex flex-col gap-5"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      {/* Step 8: Legal Advice alert box */}
      <div className="flex flex-row flex-wrap items-center justify-between gap-5 p-5 rounded-2xl border border-dashed border-[#E18308] bg-[#FFECD3]">
        <div className="w-[72px] h-[72px] flex-shrink-0 flex items-center justify-center">
          <img src={LegalAdviceHeadset} alt="" className="w-[72px] h-[72px] object-contain" />
        </div>
        <div className="flex-1 min-w-[200px] flex flex-col gap-2">
          <h3 className="text-sm font-semibold text-[#222222]" style={{ lineHeight: "20px", letterSpacing: "0.14px" }}>
            Step 8: Legal Advice (Phone Conversation)
          </h3>
          <ul className="text-sm font-normal text-[#222222] list-disc list-inside space-y-1 pl-0" style={{ lineHeight: "20px" }}>
            <li>Nothing to be done here. It is a phone conversation with the client.</li>
            <li>If the client gets convinced that the mark they have given is not available for registration, they might share another mark for search.</li>
          </ul>
        </div>
        <button
          type="button"
          className="flex-shrink-0 h-9 px-4 text-xs font-semibold text-white rounded-md bg-[#222222] hover:bg-[#333333] transition-colors"
          style={{ lineHeight: "20px" }}
        >
          Call Now
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <label className="text-sm font-medium text-[#222222]" style={{ lineHeight: "20px" }}>
          Mark
        </label>
        <div className="flex flex-col gap-3">
          <input
            type="text"
            value={mark}
            readOnly
            placeholder="Enter Mark"
            className="w-full h-10 px-2.5 py-2.5 text-sm font-normal text-[#222222] border border-[#EEEEEE] rounded-md bg-[#F5F5F5] cursor-not-allowed placeholder:text-[#6D6D6D]"
          />
          <button
            type="button"
            onClick={() => setShowNewMarkForm((v) => !v)}
            className="text-sm font-semibold text-[#222222] hover:underline text-left w-fit"
            style={{ lineHeight: "20px" }}
          >
            +Add New Mark for Search
          </button>
        </div>
      </div>
      {showNewMarkForm && (
        <LegalAdviceNewMarkForm
          leadId={leadId}
          currentMarkName={mark}
          onSuccess={(newLeadId) => {
            setShowNewMarkForm(false);
            onNewMarkSuccess?.(newLeadId);
          }}
          onCancel={() => setShowNewMarkForm(false)}
        />
      )}
    </form>
  );
}

type LegalAdviceNewMarkFormProps = {
  leadId: string;
  currentMarkName: string;
  onSuccess: (leadId: string) => void;
  onCancel: () => void;
};

function LegalAdviceNewMarkForm({
  leadId,
  currentMarkName,
  onSuccess,
  onCancel,
}: LegalAdviceNewMarkFormProps) {
  const [markName, setMarkName] = useState("");
  const [contactName, setContactName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [callTime, setCallTime] = useState<Date | null>(new Date());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getLeadDetails(leadId)
      .then(({ lead: l }) => {
        if (!cancelled) {
          setContactName(l.contactName ?? "");
          setPhone(l.phone ?? "");
          setEmail(l.email ?? "");
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  const handleSubmit = async (): Promise<void> => {
    const trimmed = markName.trim();
    if (!trimmed) {
      toast.error("Mark name is required");
      return;
    }
    const normalized = trimmed.toLowerCase();
    if (currentMarkName.trim().toLowerCase() === normalized) {
      toast.error("New mark must be different from the current mark");
      return;
    }
    if (!contactName.trim()) {
      toast.error("Contact name is required");
      return;
    }
    const phoneErr = validateMobileNumber(phone);
    if (phoneErr) {
      toast.error(phoneErr);
      return;
    }
    const callTimeVal = callTime ?? new Date();
    setSaving(true);
    setError(null);
    try {
      const data = await submitNewMarkFromLegalAdvice(leadId, {
        markName: trimmed,
        contactName: contactName.trim(),
        phone: phone.trim(),
        email: email.trim() || undefined,
        callTime: callTimeVal.toISOString(),
      });
      toast.success("New mark submitted successfully.");
      onSuccess(data.leadId);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to submit new mark");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-4 border border-[#EEEEEE] rounded-md bg-[#FAFAFA]">
      <h4 className="text-sm font-medium text-[#222222]">Add New Mark for Search</h4>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#222222]">New Mark Name</label>
          <input
            type="text"
            value={markName}
            onChange={(e) => setMarkName(e.target.value)}
            placeholder="Enter new mark"
            className="h-9 w-full rounded-md border border-[#EEEEEE] bg-white px-2.5 py-2 text-xs text-[#222222] focus:border-[#222222] focus:outline-none focus:ring-1"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-xs text-[#222222]">Contact Name</label>
            <input
              type="text"
              value={contactName}
              onChange={(e) => setContactName(e.target.value)}
              placeholder="Contact name"
              className="h-9 w-full rounded-md border border-[#EEEEEE] bg-white px-2.5 py-2 text-xs text-[#222222] focus:border-[#222222] focus:outline-none focus:ring-1"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-[#222222]">Phone</label>
            <input
              type="tel"
              inputMode="numeric"
              value={phone}
              onChange={(e) => setPhone(formatPhoneInput(e.target.value))}
              placeholder="e.g. +919876543210 or 9876543210"
              className="h-9 w-full rounded-md border border-[#EEEEEE] bg-white px-2.5 py-2 text-xs text-[#222222] focus:border-[#222222] focus:outline-none focus:ring-1"
            />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#222222]">Email (optional)</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="h-9 w-full rounded-md border border-[#EEEEEE] bg-white px-2.5 py-2 text-xs text-[#222222] focus:border-[#222222] focus:outline-none focus:ring-1"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#222222]">Time & Date of call</label>
          <DateTimePicker
            value={callTime}
            onChange={setCallTime}
            showTime
          />
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={handleSubmit}
            disabled={saving}
            className="h-9 px-4 text-xs font-semibold text-white rounded-md bg-[#222222] hover:bg-[#333] disabled:opacity-60"
          >
            {saving ? "Submitting..." : "Add New Mark"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="h-9 px-4 text-xs font-semibold text-[#6D6D6D] border border-[#EEEEEE] rounded-md bg-white hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function InvoiceAdvanceAmountView({
  leadId,
  onSuccess,
}: InvoiceAdvanceAmountViewProps) {
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(INVOICE_ADVANCE_PHONE_DEFAULT);
  const [loading, setLoading] = useState(!!leadId);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [hasSentWhatsapp, setHasSentWhatsapp] = useState(false);
  const [confirmMode, setConfirmMode] = useState<"send" | "resend">("send");
  const parsedAdvanceAmount = Number.parseFloat(advanceAmount);
  const isAdvanceAmountValid =
    advanceAmount.trim().length > 0 &&
    Number.isFinite(parsedAdvanceAmount) &&
    parsedAdvanceAmount > 0;

  useEffect(() => {
    if (!leadId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    Promise.all([getAdvanceAmount(leadId), getLeadDetails(leadId)])
      .then(([advance, { lead }]) => {
        if (!cancelled) {
          if (advance.advanceAmount > 0) {
            setAdvanceAmount(String(advance.advanceAmount));
          }
          if (lead.phone) {
            setPhoneNumber(lead.phone);
          }
        }
      })
      .catch((err) => {
        if (!cancelled) {
          toast.error(err instanceof Error ? err.message : "Failed to load data");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  useEffect(() => {
    if (!leadId) {
      setHasSentWhatsapp(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const status = await getWorkflowStatus(leadId);
        const step = status.steps.find(
          (s) => s.slug === "S1_04_ADVANCE_INVOICE_TO_CLIENT"
        );
        if (!cancelled && step) {
          setHasSentWhatsapp(step.isCompleted);
        }
      } catch {
        if (!cancelled) setHasSentWhatsapp(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  const handleSaveAndContinue = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadId) return;
    if (!isAdvanceAmountValid) {
      setValidationError("Advance amount must be greater than 0.");
      toast.error("Advance amount must be greater than 0.");
      return;
    }
    setValidationError(null);
    if (hasSentWhatsapp) {
      setSaving(true);
      try {
        await invoiceAdvance(leadId, {
          advanceAmount: parsedAdvanceAmount,
          sendWhatsapp: false,
        });
        toast.success("Invoice advance updated successfully.");
        onSuccess?.(leadId);
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to save");
      } finally {
        setSaving(false);
      }
      return;
    }
    setConfirmMode("send");
    setShowConfirmModal(true);
  };

  const handleConfirmProceed = () => {
    if (!leadId) return;
    if (!isAdvanceAmountValid) {
      toast.error("Advance amount must be greater than 0.");
      return;
    }
    setShowConfirmModal(false);
    setSaving(true);
    (async () => {
      try {
        const shouldSendWhatsapp = confirmMode === "send" || confirmMode === "resend";
        await invoiceAdvance(leadId, {
          advanceAmount: parsedAdvanceAmount,
          sendWhatsapp: shouldSendWhatsapp,
        });
        if (confirmMode === "resend") {
          setHasSentWhatsapp(true);
          toast.success("Invoice advance resent to client successfully");
        } else if (shouldSendWhatsapp) {
          setHasSentWhatsapp(true);
          toast.success("Invoice advance sent to client successfully");
        } else {
          toast.success("Invoice advance updated successfully.");
        }
        onSuccess?.(leadId);
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to send");
      } finally {
        setSaving(false);
      }
    })();
  };

  if (loading) {
    return (
      <div className="max-w-[1085px] flex items-center justify-center py-12">
        <p className="text-sm text-[#6D6D6D]">Loading...</p>
      </div>
    );
  }

  return (
    <form
      id="invoice-advance-form"
      onSubmit={handleSaveAndContinue}
      className="max-w-[1085px] flex flex-col gap-5"
    >
      <div className="flex flex-col gap-1">
        <label className="text-xs text-[#222] font-normal leading-5">
          Advance Amount (Rs.)
        </label>
        <div className="flex gap-2 items-stretch">
          <input
            type="text"
            inputMode="decimal"
            placeholder="00.00"
            value={advanceAmount}
            onChange={(e) => {
              setAdvanceAmount(e.target.value);
              if (validationError) setValidationError(null);
            }}
            className="flex-1 min-w-0 px-2.5 py-2 text-xs border border-[#EEE] rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-[#222] placeholder:text-[#6D6D6D]"
          />
          <Select value="inr" onValueChange={() => {}}>
            <SelectTrigger className="h-[34px] w-auto min-w-[80px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="inr">Rs(₹)</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {validationError && <p className="text-[11px] text-[#D92D20]">{validationError}</p>}
      </div>
      <ConfirmMessageModal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        previewContent={buildInvoiceAdvanceMessage(advanceAmount || "0", INVOICE_ADVANCE_PAYMENT)}
        onConfirm={handleConfirmProceed}
        disableConfirm={!isAdvanceAmountValid}
      />
      <div className="flex flex-wrap items-center gap-3 mt-2">
        <input
          type="tel"
          inputMode="numeric"
          value={phoneNumber}
          readOnly
          placeholder="e.g. +919876543210 or 9876543210"
          className="w-full min-w-0 sm:w-[200px] h-9 px-2.5 py-2 text-xs text-[#222] border border-[#EEE] rounded-md bg-[#F7F7F7] placeholder:text-[#6D6D6D]"
        />
        {hasSentWhatsapp && leadId && (
          <button
            type="button"
            disabled={saving}
            onClick={async () => {
              if (!leadId || saving) return;
              if (!isAdvanceAmountValid) {
                toast.error("Advance amount must be greater than 0.");
                return;
              }
              setValidationError(null);
              setSaving(true);
              try {
                await invoiceAdvance(leadId, {
                  advanceAmount: parsedAdvanceAmount,
                  sendWhatsapp: false,
                });
                setConfirmMode("resend");
                setShowConfirmModal(true);
              } catch (err) {
                toast.error(
                  err instanceof Error ? err.message : "Failed to save invoice advance"
                );
              } finally {
                setSaving(false);
              }
            }}
            className="inline-flex items-center justify-center h-9 px-4 text-xs font-medium leading-5 text-[#2E3037] bg-white border border-[#D5D3E0] rounded-[10px] whitespace-nowrap hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {saving ? "Saving…" : "Resend to WhatsApp"}
          </button>
        )}
      </div>
    </form>
  );
}

type Section = "discussion" | "filing" | "status";

const LEAD_ASSIGNED_TO_ANOTHER_EMPLOYEE_MESSAGE =
  "This lead is assigned to another employee";

function isLeadOwnershipRestrictedError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.message.includes(LEAD_ASSIGNED_TO_ANOTHER_EMPLOYEE_MESSAGE);
}

export default function DashboardNewApplication() {
  const navigate = useNavigate();
  const { section, step, leadId } = useParams<{
    section?: string;
    step?: string;
    leadId?: string;
  }>();
  const [menuOpen, setMenuOpen] = useState(false);
  const [progressing, setProgressing] = useState(false);
  const [checklistSending, setChecklistSending] = useState(false);
  const [docChecklistSending, setDocChecklistSending] = useState(false);
  const [stepSaving, setStepSaving] = useState(false);
  const [progressError, setProgressError] = useState<string | null>(null);
  const [showF1ConfirmModal, setShowF1ConfirmModal] = useState(false);
  const [hasSentChecklistWhatsApp, setHasSentChecklistWhatsApp] = useState(false);
  const [checklistResending, setChecklistResending] = useState(false);
  const [showSearchChecklistResendModal, setShowSearchChecklistResendModal] =
    useState(false);
  const [showSearchChecklistSendModal, setShowSearchChecklistSendModal] =
    useState(false);
  const [hasSentClassListWhatsapp, setHasSentClassListWhatsapp] = useState(false);
  const [hasSentSearchReportWhatsapp, setHasSentSearchReportWhatsapp] = useState(false);
  const [hasSentProposalWhatsapp, setHasSentProposalWhatsapp] = useState(false);
  const [hasSentInvoiceAdvanceWhatsapp, setHasSentInvoiceAdvanceWhatsapp] = useState(false);
  const [hasSentInvoiceFinalWhatsapp, setHasSentInvoiceFinalWhatsapp] = useState(false);
  const [hasSentDocChecklistWhatsapp, setHasSentDocChecklistWhatsapp] = useState(false);
  const [hasSentFilingDetailsWhatsapp, setHasSentFilingDetailsWhatsapp] = useState(false);
  const [hasSentFilingConfirmationWhatsapp, setHasSentFilingConfirmationWhatsapp] = useState(false);
  const [hasSentStampDetailsWhatsapp, setHasSentStampDetailsWhatsapp] = useState(false);
  // Single shared workflow-status subscription — seeds all the hasSentX flags below
  // with one network request instead of 10 parallel ones.
  const { status: workflowStatus } = useWorkflowStatus(leadId ?? null);
  const [docChecklistResending, setDocChecklistResending] = useState(false);
  const [leadNoForHeader, setLeadNoForHeader] = useState<string | null>(null);
  const [markNameForHeader, setMarkNameForHeader] = useState<string | null>(null);
  const [leadAccessState, setLeadAccessState] = useState<
    "idle" | "checking" | "allowed" | "restricted"
  >(leadId ? "checking" : "idle");
  const [leadAccessMessage, setLeadAccessMessage] = useState<string>(
    LEAD_ASSIGNED_TO_ANOTHER_EMPLOYEE_MESSAGE
  );
  /** FC Pass: footer shows "Send" until S3_01a is completed */
  const [fcPassFooterNeedsSend, setFcPassFooterNeedsSend] = useState(false);
  /** FC Pass: after sent, footer shows "Save" (no continue) with inline Resend */
  const [fcPassFooterNeedsSave, setFcPassFooterNeedsSave] = useState(false);
  /** FC Fail → Notice to Client: footer Send & Continue until S3_01b(ii) is completed */
  const [fcFailNoticeFooterNeedsSend, setFcFailNoticeFooterNeedsSend] = useState(false);
  /** FC Fail → Inform Client: footer Send & Continue until S3_01b(iii) is completed */
  const [fcFailInformFooterNeedsSend, setFcFailInformFooterNeedsSend] = useState(false);
  /** FC Fail → Invoice: footer Send & Continue until invoice is sent (S3_01b(iv)c) */
  const [fcFailInvoiceFooterNeedsSend, setFcFailInvoiceFooterNeedsSend] = useState(false);
  /** FC Fail → Inform Client (Done): footer Send & Continue until S3_01b(ix) is completed */
  const [fcFailInformDoneFooterNeedsSend, setFcFailInformDoneFooterNeedsSend] =
    useState(false);
  /** FC Fail → Status of FC Failure: footer Save & Continue submits the form (advances sub-step) */
  const [fcFailStatusFooterNeedsSubmit, setFcFailStatusFooterNeedsSubmit] =
    useState(false);
  /** FC Fail → Notice/Inform/Invoice/InformDone Save-mode (after sent: footer Save & Continue advances) */
  const [fcFailNoticeFooterNeedsSave, setFcFailNoticeFooterNeedsSave] =
    useState(false);
  const [fcFailInformFooterNeedsSave, setFcFailInformFooterNeedsSave] =
    useState(false);
  const [fcFailInvoiceFooterNeedsSave, setFcFailInvoiceFooterNeedsSave] =
    useState(false);
  // Progress (skip) handler registered by FormalitiesCheckView for the Invoice
  // for FC Failure sub-step. Wrapped in an object so React doesn't treat the
  // function as a state updater.
  const [fcFailInvoiceProgressAction, setFcFailInvoiceProgressAction] =
    useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Payment sub-step
  // (Objected branch). Same wrapping pattern as above.
  const [
    examReportObjectionPaymentProgressAction,
    setExamReportObjectionPaymentProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Documents sub-step
  // (Objected branch — 3b(viii) Documents from Client for Reply to Objection).
  const [
    examReportObjectionDocumentsProgressAction,
    setExamReportObjectionDocumentsProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Payment sub-step
  // (Hearing-After-Objection branch — 3D(xii) Payment from Client for Hearing).
  const [
    examReportHaoPaymentProgressAction,
    setExamReportHaoPaymentProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Upload Documents
  // after Hearing sub-step (Hearing-After-Objection branch — 3D(xxv)).
  const [
    examReportHaoUploadDocsAfterHearingProgressAction,
    setExamReportHaoUploadDocsAfterHearingProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Invoice for
  // TM-M after Hearing sub-step (Hearing-After-Objection branch — 3D(xxvi)a).
  const [
    examReportHaoTmMAfterInvoiceProgressAction,
    setExamReportHaoTmMAfterInvoiceProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Invoice for
  // TM-M before Hearing sub-step (Hearing-After-Objection branch — 3D(viii)a).
  const [
    examReportHaoTmMBeforeInvoiceProgressAction,
    setExamReportHaoTmMBeforeInvoiceProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by ExaminationReportView's Documents from
  // Client for hearing sub-step (Hearing-After-Objection branch — 3D(xv)).
  const [
    examReportHaoDocsFromClientProgressAction,
    setExamReportHaoDocsFromClientProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Payment-from-Client-for-Counter sub-step — S3_04a(vii).
  const [counterPaymentProgressAction, setCounterPaymentProgressAction] =
    useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Notice-of-Counter-by-Registry sub-step — S3_04a(xi).
  const [counterNoticeOfCounterProgressAction, setCounterNoticeOfCounterProgressAction] =
    useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Documents-from-Client-for-Evidence sub-step — S3_04a(xxii).
  const [counterDocumentsFromClientEvidenceProgressAction, setCounterDocumentsFromClientEvidenceProgressAction] =
    useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Payment-from-Client-for-Opposition-Hearing sub-step — S3_04a(xl).
  const [
    counterOppositionHearingPaymentProgressAction,
    setCounterOppositionHearingPaymentProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Documents-from-Client-for-Opposition-Hearing sub-step — S3_04a(xli).
  const [
    counterDocumentsOppHearingProgressAction,
    setCounterDocumentsOppHearingProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Invoice-for-TM-M-before-Opposition-Hearing sub-step — S3_04a(xxxvi).
  const [
    counterTmMBeforeOppHearingInvoiceProgressAction,
    setCounterTmMBeforeOppHearingInvoiceProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Invoice-for-TM-M-after-Opposition-Hearing sub-step — S3_04a(xlvi).
  const [
    counterTmMAfterOppHearingInvoiceProgressAction,
    setCounterTmMAfterOppHearingInvoiceProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  // Progress (skip) handler registered by AdvertisedInJournalView's
  // Payment-from-Client-for-TM-M-after-Opposition-Hearing sub-step — S3_04a(xlvii).
  const [
    counterTmMAfterOppHearingPaymentProgressAction,
    setCounterTmMAfterOppHearingPaymentProgressAction,
  ] = useState<{ run: () => Promise<void> } | null>(null);
  const [fcFailInformDoneFooterNeedsSave, setFcFailInformDoneFooterNeedsSave] =
    useState(false);
  /** FC Fail → Call Client / Client Confirmation / Documents / Filing of Reply: form-mode */
  const [
    fcFailCallClientFooterNeedsSubmit,
    setFcFailCallClientFooterNeedsSubmit,
  ] = useState(false);
  const [
    fcFailConfirmationFooterNeedsSubmit,
    setFcFailConfirmationFooterNeedsSubmit,
  ] = useState(false);
  const [
    fcFailDocumentsFooterNeedsSubmit,
    setFcFailDocumentsFooterNeedsSubmit,
  ] = useState(false);
  const [
    fcFailFilingOfReplyFooterNeedsSubmit,
    setFcFailFilingOfReplyFooterNeedsSubmit,
  ] = useState(false);
  /** Marked for Exam → Accepted: footer Send & Continue until S3_03b is completed */
  const [markedForExamAcceptedFooterNeedsSend, setMarkedForExamAcceptedFooterNeedsSend] =
    useState(false);
  /** Marked for Exam → Accepted after Objection: footer Send & Continue until S3_03c(iii) is completed */
  const [markedForExamAAOFooterNeedsSend, setMarkedForExamAAOFooterNeedsSend] =
    useState(false);
  /** Examination Report → Notice to Client of Acceptance: footer Send & Continue until S3_03a is completed */
  const [examReportNoticeFooterNeedsSend, setExamReportNoticeFooterNeedsSend] =
    useState(false);
  /** Examination Report → Notice to Client of Acceptance (already sent): footer Save & Continue submits notice form (advance only) */
  const [examReportNoticeFooterNeedsSave, setExamReportNoticeFooterNeedsSave] =
    useState(false);
  /** Examination Report → Status of Acceptance: footer Save & Continue submits form (advances sub-step) */
  const [examReportSoaFooterNeedsSubmit, setExamReportSoaFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Inform client about Acceptance: footer Send & Continue until S3_03b is completed */
  const [examReportInformFooterNeedsSend, setExamReportInformFooterNeedsSend] =
    useState(false);
  /** Examination Report → Inform client about Acceptance (already sent): footer Save & Continue submits inform form (advance only) */
  const [examReportInformFooterNeedsSave, setExamReportInformFooterNeedsSave] =
    useState(false);
  /** Examination Report → Status of Objection: footer Save & Continue submits form (advances sub-step) */
  const [examReportSooFooterNeedsSubmit, setExamReportSooFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Notice to Client of Objection: footer Send & Continue until S3_03b(ii) is completed */
  const [examReportNtcoFooterNeedsSend, setExamReportNtcoFooterNeedsSend] =
    useState(false);
  /** Examination Report → Notice to Client of Objection (already sent): footer Save & Continue submits notice form (advance only) */
  const [examReportNtcoFooterNeedsSave, setExamReportNtcoFooterNeedsSave] =
    useState(false);
  /** Examination Report → Inform Client of Objection: footer Send & Continue until S3_03b(iii) is completed */
  const [examReportIncoFooterNeedsSend, setExamReportIncoFooterNeedsSend] =
    useState(false);
  /** Examination Report → Inform Client of Objection (already sent): footer Save & Continue submits inform form (advance only) */
  const [examReportIncoFooterNeedsSave, setExamReportIncoFooterNeedsSave] =
    useState(false);
  /** Examination Report → 3B(iv) Call Client about Reply to Objection: footer Save & Continue advances to 3B(v) */
  const [examReportCcroFooterNeedsSubmit, setExamReportCcroFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Client Confirmation (call client): footer Save & Continue records call + advances */
  const [examReportCcoFooterNeedsSubmit, setExamReportCcoFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Invoice to Client (Reply to Objection): footer Save & Continue advances to Payment */
  const [examReportInvFooterNeedsSubmit, setExamReportInvFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Payment (Reply to Objection): footer Save & Continue advances to Documents */
  const [examReportPayFooterNeedsSubmit, setExamReportPayFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Documents (Reply to Objection): footer Save & Continue records + advances */
  const [examReportDocFooterNeedsSubmit, setExamReportDocFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Filing Reply (Reply to Objection): footer Save & Continue saves + advances */
  const [examReportFroFooterNeedsSubmit, setExamReportFroFooterNeedsSubmit] =
    useState(false);
  /** Examination Report → Inform Client (Reply to Objection): footer Send & Continue until S3_03b(x) is completed */
  const [examReportIcrFooterNeedsSend, setExamReportIcrFooterNeedsSend] =
    useState(false);
  /** Examination Report → Inform Client (Reply to Objection) (already sent): footer Save & Continue (advance only) */
  const [examReportIcrFooterNeedsSave, setExamReportIcrFooterNeedsSave] =
    useState(false);
  /** Examination Report → Status of Accepted after Objection: footer Save & Continue advances sub-step */
  const [
    examReportAaoStatusFooterNeedsSubmit,
    setExamReportAaoStatusFooterNeedsSubmit,
  ] = useState(false);
  /** Examination Report → AAO Notice to Client: footer Send & Continue until S3_03c(ii) is completed */
  const [
    examReportAaoNoticeFooterNeedsSend,
    setExamReportAaoNoticeFooterNeedsSend,
  ] = useState(false);
  /** Examination Report → AAO Notice to Client (already sent): footer Save & Continue (advance only) */
  const [
    examReportAaoNoticeFooterNeedsSave,
    setExamReportAaoNoticeFooterNeedsSave,
  ] = useState(false);
  /** Examination Report → AAO Inform Client: footer Send & Continue until S3_03c(iii) is completed */
  const [
    examReportAaoInformFooterNeedsSend,
    setExamReportAaoInformFooterNeedsSend,
  ] = useState(false);
  /** Examination Report → AAO Inform Client (already sent): footer Save & Continue (advance only) */
  const [
    examReportAaoInformFooterNeedsSave,
    setExamReportAaoInformFooterNeedsSave,
  ] = useState(false);
  /** Examination Report → Hearing after Objection → Inform Client (Showcause): footer Send & Continue until S3_03d(iv) is completed */
  const [
    examReportHaoInformFooterNeedsSend,
    setExamReportHaoInformFooterNeedsSend,
  ] = useState(false);
  /** Examination Report → Hearing after Objection → Inform Client (Showcause) (already sent): footer Save & Continue (advance only) */
  const [
    examReportHaoInformFooterNeedsSave,
    setExamReportHaoInformFooterNeedsSave,
  ] = useState(false);
  /** HAO Status details: footer Save & Continue submits form (advances sub-step) */
  const [
    examReportHaoStatusFooterNeedsSubmit,
    setExamReportHaoStatusFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Notice to Client: footer Send & Continue until S3_03d(iii) is completed */
  const [
    examReportHaoNoticeFooterNeedsSend,
    setExamReportHaoNoticeFooterNeedsSend,
  ] = useState(false);
  /** HAO Notice to Client (already sent): footer Save & Continue (advance only) */
  const [
    examReportHaoNoticeFooterNeedsSave,
    setExamReportHaoNoticeFooterNeedsSave,
  ] = useState(false);
  /** HAO Inform Client about Hearing: footer Send & Continue until S3_03d(iv) is completed */
  const [
    examReportHaoInformHearingFooterNeedsSend,
    setExamReportHaoInformHearingFooterNeedsSend,
  ] = useState(false);
  /** HAO Inform Client about Hearing (already sent): footer Save & Continue (advance only) */
  const [
    examReportHaoInformHearingFooterNeedsSave,
    setExamReportHaoInformHearingFooterNeedsSave,
  ] = useState(false);
  /** HAO Call Client: footer Save & Continue submits the form (records call + advances) */
  const [
    examReportHaoCallClientFooterNeedsSubmit,
    setExamReportHaoCallClientFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Confirmation from Client: footer Save & Continue submits the form */
  const [
    examReportHaoConfirmationFooterNeedsSubmit,
    setExamReportHaoConfirmationFooterNeedsSubmit,
  ] = useState(false);
  /** HAO 3D(vii)a Revised Invoice for Hearing 1: footer Save & Continue submits (item 68) */
  const [
    examReportHaoRevisedInvoiceFooterNeedsSubmit,
    setExamReportHaoRevisedInvoiceFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Invoice for Hearing: footer Save & Continue submits the form */
  const [
    examReportHaoInvoiceFooterNeedsSubmit,
    setExamReportHaoInvoiceFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Invoice for Hearing: "sent" status — true after first send so the footer label flips from Send to Save */
  const [
    examReportHaoInvoiceSent,
    setExamReportHaoInvoiceSent,
  ] = useState(false);
  /** HAO TM-M Invoice / Payment / File / Inform / Hearing Payment footer states */
  const [
    examReportHaoTmMInvoiceFooterNeedsSubmit,
    setExamReportHaoTmMInvoiceFooterNeedsSubmit,
  ] = useState(false);
  /** HAO TM-M Invoice: "sent" status — true after first send so the footer label flips from Send to Save */
  const [
    examReportHaoTmMInvoiceSent,
    setExamReportHaoTmMInvoiceSent,
  ] = useState(false);
  /** HAO TM-M before Hearing Invoice: Skip mode when Confirmation != "TM-M for Postponement" */
  const [
    examReportHaoTmMInvoiceFooterNeedsSkip,
    setExamReportHaoTmMInvoiceFooterNeedsSkip,
  ] = useState(false);
  const [
    examReportHaoTmMPaymentFooterNeedsSubmit,
    setExamReportHaoTmMPaymentFooterNeedsSubmit,
  ] = useState(false);
  /** HAO TM-M before Hearing Payment: Skip mode when Confirmation != "TM-M for Postponement" */
  const [
    examReportHaoTmMPaymentFooterNeedsSkip,
    setExamReportHaoTmMPaymentFooterNeedsSkip,
  ] = useState(false);
  const [
    examReportHaoTmMFileFooterNeedsSubmit,
    setExamReportHaoTmMFileFooterNeedsSubmit,
  ] = useState(false);
  const [
    examReportHaoTmMInformFooterNeedsSend,
    setExamReportHaoTmMInformFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoTmMInformFooterNeedsSave,
    setExamReportHaoTmMInformFooterNeedsSave,
  ] = useState(false);
  const [
    examReportHaoPaymentFooterNeedsSubmit,
    setExamReportHaoPaymentFooterNeedsSubmit,
  ] = useState(false);
  const [
    examReportHaoStampVendorFooterNeedsSend,
    setExamReportHaoStampVendorFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoStampVendorFooterNeedsSave,
    setExamReportHaoStampVendorFooterNeedsSave,
  ] = useState(false);
  /** HAO Stamp Paper to Vendor: Skip mode when User Date != "Proposed to be used" */
  const [
    examReportHaoStampVendorFooterNeedsSkip,
    setExamReportHaoStampVendorFooterNeedsSkip,
  ] = useState(false);
  /** HAO Stamp Paper from Vendor: Save & Continue submits the form */
  const [
    examReportHaoStampFromVendorFooterNeedsSubmit,
    setExamReportHaoStampFromVendorFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Stamp Paper from Vendor: Skip mode when User Date != "Proposed to be used" */
  const [
    examReportHaoStampFromVendorFooterNeedsSkip,
    setExamReportHaoStampFromVendorFooterNeedsSkip,
  ] = useState(false);
  /** HAO Documents from Client: Save & Continue submits the form */
  const [
    examReportHaoDocsFromClientFooterNeedsSubmit,
    setExamReportHaoDocsFromClientFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Preparation of User Affidavit: Save & Continue submits the form */
  const [
    examReportHaoUserAffidavitFooterNeedsSubmit,
    setExamReportHaoUserAffidavitFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Preparation of User Affidavit: Skip mode when User Date != "Proposed to be used" */
  const [
    examReportHaoUserAffidavitFooterNeedsSkip,
    setExamReportHaoUserAffidavitFooterNeedsSkip,
  ] = useState(false);
  /** HAO Signature from Client: Save & Continue submits the form */
  const [
    examReportHaoSignatureFooterNeedsSubmit,
    setExamReportHaoSignatureFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Notarisation of Documents: Save & Continue submits the form */
  const [
    examReportHaoNotarisationFooterNeedsSubmit,
    setExamReportHaoNotarisationFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Notarisation of Documents: Skip mode when User Date != "Proposed to be used" */
  const [
    examReportHaoNotarisationFooterNeedsSkip,
    setExamReportHaoNotarisationFooterNeedsSkip,
  ] = useState(false);
  /** HAO Scanning of Documents: Save & Continue submits the form */
  const [
    examReportHaoScanningFooterNeedsSubmit,
    setExamReportHaoScanningFooterNeedsSubmit,
  ] = useState(false);
  /** HAO File Hearing Document: Save & Continue submits the form */
  const [
    examReportHaoFileHearingDocFooterNeedsSubmit,
    setExamReportHaoFileHearingDocFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Note on Hearing: Save & Continue submits the form */
  const [
    examReportHaoNoteOnHearingFooterNeedsSubmit,
    setExamReportHaoNoteOnHearingFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Attend Hearing: Save & Continue submits the form */
  const [
    examReportHaoAttendHearingFooterNeedsSubmit,
    setExamReportHaoAttendHearingFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Notice for hearing not happened: Send & Save modes */
  const [
    examReportHaoHearingNotHappenedFooterNeedsSend,
    setExamReportHaoHearingNotHappenedFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoHearingNotHappenedFooterNeedsSave,
    setExamReportHaoHearingNotHappenedFooterNeedsSave,
  ] = useState(false);
  /** HAO Notice for hearing not happened: Skip mode when no marks need a postponement notice */
  const [
    examReportHaoHearingNotHappenedFooterNeedsSkip,
    setExamReportHaoHearingNotHappenedFooterNeedsSkip,
  ] = useState(false);
  /** HAO Inform Client after hearing: Send & Save modes */
  const [
    examReportHaoInformAfterHearingFooterNeedsSend,
    setExamReportHaoInformAfterHearingFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoInformAfterHearingFooterNeedsSave,
    setExamReportHaoInformAfterHearingFooterNeedsSave,
  ] = useState(false);
  /** HAO Upload Documents after Hearing: Save & Continue */
  const [
    examReportHaoUploadDocsAfterHearingFooterNeedsSubmit,
    setExamReportHaoUploadDocsAfterHearingFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Invoice for TM-M after Hearing: Save & Continue */
  const [
    examReportHaoTmMAfterInvoiceFooterNeedsSubmit,
    setExamReportHaoTmMAfterInvoiceFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Invoice for TM-M after Hearing: Skip mode when hearing direction != "File TM-M" */
  const [
    examReportHaoTmMAfterInvoiceFooterNeedsSkip,
    setExamReportHaoTmMAfterInvoiceFooterNeedsSkip,
  ] = useState(false);
  /** HAO Payment for TM-M after Hearing: Save & Continue */
  const [
    examReportHaoTmMAfterPaymentFooterNeedsSubmit,
    setExamReportHaoTmMAfterPaymentFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Payment for TM-M after Hearing: Skip mode when hearing direction != "File TM-M" */
  const [
    examReportHaoTmMAfterPaymentFooterNeedsSkip,
    setExamReportHaoTmMAfterPaymentFooterNeedsSkip,
  ] = useState(false);
  /** HAO File TM-M after Hearing 1: Save & Continue */
  const [
    examReportHaoFileTmMAfterHearingFooterNeedsSubmit,
    setExamReportHaoFileTmMAfterHearingFooterNeedsSubmit,
  ] = useState(false);
  /** HAO File TM-M after Hearing 1: Skip mode when hearing direction != "File TM-M" */
  const [
    examReportHaoFileTmMAfterHearingFooterNeedsSkip,
    setExamReportHaoFileTmMAfterHearingFooterNeedsSkip,
  ] = useState(false);
  /** HAO Inform Client about Filing TM-M after Hearing: Send/Save modes */
  const [
    examReportHaoInformTmMAfterHearingFooterNeedsSend,
    setExamReportHaoInformTmMAfterHearingFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoInformTmMAfterHearingFooterNeedsSave,
    setExamReportHaoInformTmMAfterHearingFooterNeedsSave,
  ] = useState(false);
  /** HAO Inform Client about Filing TM-M after Hearing: Skip mode when no TM-M filed */
  const [
    examReportHaoInformTmMAfterHearingFooterNeedsSkip,
    setExamReportHaoInformTmMAfterHearingFooterNeedsSkip,
  ] = useState(false);
  /** HAO Subsequent Hearings: Send/Save modes */
  const [
    examReportHaoSubsequentHearingsFooterNeedsSend,
    setExamReportHaoSubsequentHearingsFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoSubsequentHearingsFooterNeedsSave,
    setExamReportHaoSubsequentHearingsFooterNeedsSave,
  ] = useState(false);
  /** HAO Subsequent Hearings: Skip mode when not active for this application */
  const [
    examReportHaoSubsequentHearingsFooterNeedsSkip,
    setExamReportHaoSubsequentHearingsFooterNeedsSkip,
  ] = useState(false);
  /** HAO Subsequent Hearing Invoice: Skip mode when not active for this application */
  const [
    examReportHaoSubsequentInvoiceFooterNeedsSkip,
    setExamReportHaoSubsequentInvoiceFooterNeedsSkip,
  ] = useState(false);
  /** HAO Subsequent Hearing Invoice (active): footer Send/Save & Continue submits the form */
  const [
    examReportHaoSubsequentInvoiceFooterNeedsSubmit,
    setExamReportHaoSubsequentInvoiceFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Subsequent Hearing Invoice: "sent" status — flips footer label between Send & Save */
  const [examReportHaoSubsequentInvoiceSent, setExamReportHaoSubsequentInvoiceSent] =
    useState(false);
  /** HAO Payment from Client for Subsequent Hearing: footer Save & Continue submits the form */
  const [
    examReportHaoSubsequentPaymentFooterNeedsSubmit,
    setExamReportHaoSubsequentPaymentFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Payment from Client for Subsequent Hearing: Skip mode when invoice not active for this application */
  const [
    examReportHaoSubsequentPaymentFooterNeedsSkip,
    setExamReportHaoSubsequentPaymentFooterNeedsSkip,
  ] = useState(false);
  /** HAO Attend Subsequent Hearing: footer Save & Continue submits the form */
  const [
    examReportHaoSubsequentAttendFooterNeedsSubmit,
    setExamReportHaoSubsequentAttendFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Attend Subsequent Hearing: Skip mode when Subsequent Hearings not active for this application */
  const [
    examReportHaoSubsequentAttendFooterNeedsSkip,
    setExamReportHaoSubsequentAttendFooterNeedsSkip,
  ] = useState(false);
  /** HAO Notice for Subsequent Hearing Postponed: footer Save & Continue submits the form */
  const [
    examReportHaoSubsequentPostponementFooterNeedsSubmit,
    setExamReportHaoSubsequentPostponementFooterNeedsSubmit,
  ] = useState(false);
  /** HAO Order of Hearing to Client: Send/Save modes */
  const [
    examReportHaoOrderOfHearingFooterNeedsSend,
    setExamReportHaoOrderOfHearingFooterNeedsSend,
  ] = useState(false);
  const [
    examReportHaoOrderOfHearingFooterNeedsSave,
    setExamReportHaoOrderOfHearingFooterNeedsSave,
  ] = useState(false);
  /** Advertised in Journal → Status Details: footer "Save & Continue" submits the status form (advances sub-step) */
  const [
    advJournalStatusDetailsFooterNeedsSubmit,
    setAdvJournalStatusDetailsFooterNeedsSubmit,
  ] = useState(false);
  /** Advertised in Journal → Notice to Client: footer "Send & Continue" until S3_04(ii) completed */
  const [advJournalNoticeFooterNeedsSend, setAdvJournalNoticeFooterNeedsSend] =
    useState(false);
  /** Advertised in Journal → Notice to Client (already sent): footer "Save & Continue" advances */
  const [advJournalNoticeFooterNeedsSave, setAdvJournalNoticeFooterNeedsSave] =
    useState(false);
  /** Advertised in Journal → Inform Client: footer "Send & Continue" until S3_04(iii) completed */
  const [advJournalInformFooterNeedsSend, setAdvJournalInformFooterNeedsSend] =
    useState(false);
  /** Advertised in Journal → Inform Client (already sent): "Save & Continue" advances */
  const [advJournalInformFooterNeedsSave, setAdvJournalInformFooterNeedsSave] =
    useState(false);
  /** Advertised in Journal → Opposed → Status details for Counter: "Save & Continue" submits the form */
  const [
    oppositionCounterStatusFooterNeedsSubmit,
    setOppositionCounterStatusFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Notice to Client for Counter: Send/Save modes */
  const [
    oppositionCounterNoticeFooterNeedsSend,
    setOppositionCounterNoticeFooterNeedsSend,
  ] = useState(false);
  const [
    oppositionCounterNoticeFooterNeedsSave,
    setOppositionCounterNoticeFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Inform Client about Counter: Send/Save modes */
  const [
    oppositionCounterInformFooterNeedsSend,
    setOppositionCounterInformFooterNeedsSend,
  ] = useState(false);
  const [
    oppositionCounterInformFooterNeedsSave,
    setOppositionCounterInformFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Call Client for Counter: Save & Continue submits the form */
  const [
    oppositionCounterCallFooterNeedsSubmit,
    setOppositionCounterCallFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Confirmation from Client for Counter: Save & Continue submits */
  const [
    counterConfirmationFooterNeedsSubmit,
    setCounterConfirmationFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Invoice to Client for Counter: Send/Save modes */
  const [counterInvoiceFooterNeedsSend, setCounterInvoiceFooterNeedsSend] =
    useState(false);
  const [counterInvoiceFooterNeedsSave, setCounterInvoiceFooterNeedsSave] =
    useState(false);
  /** Opposed → Payment from Client for Counter: Save & Continue submits */
  const [counterPaymentFooterNeedsSubmit, setCounterPaymentFooterNeedsSubmit] =
    useState(false);
  /** Opposed → Prepare Counter: Save & Continue submits */
  const [counterPrepareFooterNeedsSubmit, setCounterPrepareFooterNeedsSubmit] =
    useState(false);
  /** Opposed → File Counter: Save & Continue submits */
  const [counterFileFooterNeedsSubmit, setCounterFileFooterNeedsSubmit] =
    useState(false);
  /** Opposed → Inform Client about Filing of Counter: Send/Save */
  const [
    counterInformFilingFooterNeedsSend,
    setCounterInformFilingFooterNeedsSend,
  ] = useState(false);
  const [
    counterInformFilingFooterNeedsSave,
    setCounterInformFilingFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Notice of Counter by Registry: Save & Continue submits */
  const [
    counterNoticeOfCounterFooterNeedsSubmit,
    setCounterNoticeOfCounterFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Inform Client about Notice of Counter: Send/Save */
  const [
    counterInformNoticeFooterNeedsSend,
    setCounterInformNoticeFooterNeedsSend,
  ] = useState(false);
  const [
    counterInformNoticeFooterNeedsSave,
    setCounterInformNoticeFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Status details for Evidence by Opponent: Save & Continue submits */
  const [
    counterEvidenceByOpponentFooterNeedsSubmit,
    setCounterEvidenceByOpponentFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Notice to Client for Evidence by Opp...: Send/Save */
  const [
    counterNoticeEvidenceByOppFooterNeedsSend,
    setCounterNoticeEvidenceByOppFooterNeedsSend,
  ] = useState(false);
  const [
    counterNoticeEvidenceByOppFooterNeedsSave,
    setCounterNoticeEvidenceByOppFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Inform Client about Evidence by Opp...: Send/Save */
  const [
    counterInformEvidenceByOppFooterNeedsSend,
    setCounterInformEvidenceByOppFooterNeedsSend,
  ] = useState(false);
  const [
    counterInformEvidenceByOppFooterNeedsSave,
    setCounterInformEvidenceByOppFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Call Client for Evidence: Save & Continue submits */
  const [
    counterCallClientEvidenceFooterNeedsSubmit,
    setCounterCallClientEvidenceFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Confirmation from Client for Evidence: Save & Continue submits */
  const [
    counterEvidenceConfirmationFooterNeedsSubmit,
    setCounterEvidenceConfirmationFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Invoice to Client for Evidence: Send/Save */
  const [
    counterEvidenceInvoiceFooterNeedsSend,
    setCounterEvidenceInvoiceFooterNeedsSend,
  ] = useState(false);
  const [
    counterEvidenceInvoiceFooterNeedsSave,
    setCounterEvidenceInvoiceFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Payment from Client for Evidence: Save & Continue submits */
  const [
    counterEvidencePaymentFooterNeedsSubmit,
    setCounterEvidencePaymentFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Stamp Paper details to Vendor for Evidence: Send/Save */
  const [
    counterStampVendorEvidenceFooterNeedsSend,
    setCounterStampVendorEvidenceFooterNeedsSend,
  ] = useState(false);
  const [
    counterStampVendorEvidenceFooterNeedsSave,
    setCounterStampVendorEvidenceFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Stamp Paper from Vendor for Evidence: Save & Continue submits */
  const [
    counterStampFromVendorEvidenceFooterNeedsSubmit,
    setCounterStampFromVendorEvidenceFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Documents from Client for Evidence: Save & Continue submits */
  const [
    counterDocumentsFromClientEvidenceFooterNeedsSubmit,
    setCounterDocumentsFromClientEvidenceFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Preparation of Evidence Affidavit: Save & Continue submits */
  const [
    counterPreparationEvidenceAffidavitFooterNeedsSubmit,
    setCounterPreparationEvidenceAffidavitFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Signature from Client for Affidavit: Save & Continue records */
  const [
    counterSignatureAffidavitFooterNeedsSubmit,
    setCounterSignatureAffidavitFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Notarisation of Documents for Evidence: Save & Continue submits */
  const [
    counterNotarisationEvidenceFooterNeedsSubmit,
    setCounterNotarisationEvidenceFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Scanning of Documents for Evidence: Save & Continue records */
  const [
    counterScanningEvidenceFooterNeedsSubmit,
    setCounterScanningEvidenceFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → File Evidence Affidavit: Save & Continue submits */
  const [
    counterFileEvidenceAffidavitFooterNeedsSubmit,
    setCounterFileEvidenceAffidavitFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Inform Client about Filing of Evidence: Send/Save */
  const [
    counterInformFilingEvidenceFooterNeedsSend,
    setCounterInformFilingEvidenceFooterNeedsSend,
  ] = useState(false);
  const [
    counterInformFilingEvidenceFooterNeedsSave,
    setCounterInformFilingEvidenceFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Download Rejoinder Affidavit: Save & Continue submits */
  const [
    counterDownloadRejoinderFooterNeedsSubmit,
    setCounterDownloadRejoinderFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Status details of Opposition Hearing: Save & Continue submits */
  const [
    counterOppositionHearingStatusFooterNeedsSubmit,
    setCounterOppositionHearingStatusFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Notice to Client for Opposition Hearing: Send/Save */
  const [
    counterOppositionHearingNoticeFooterNeedsSend,
    setCounterOppositionHearingNoticeFooterNeedsSend,
  ] = useState(false);
  const [
    counterOppositionHearingNoticeFooterNeedsSave,
    setCounterOppositionHearingNoticeFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Inform Client about Opposition Hearing: Send/Save */
  const [
    counterOppositionHearingInformFooterNeedsSend,
    setCounterOppositionHearingInformFooterNeedsSend,
  ] = useState(false);
  const [
    counterOppositionHearingInformFooterNeedsSave,
    setCounterOppositionHearingInformFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Invoice to Client for Opposition Hearing: Send/Save */
  const [
    counterOppositionHearingInvoiceFooterNeedsSend,
    setCounterOppositionHearingInvoiceFooterNeedsSend,
  ] = useState(false);
  const [
    counterOppositionHearingInvoiceFooterNeedsSave,
    setCounterOppositionHearingInvoiceFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Call Client for Opposition Hearing: Save & Continue records */
  const [
    counterOppositionHearingCallFooterNeedsSubmit,
    setCounterOppositionHearingCallFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Confirmation from Client for Opposition Hearing: Save & Continue submits */
  const [
    counterOppositionHearingConfirmationFooterNeedsSubmit,
    setCounterOppositionHearingConfirmationFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Invoice for TM-M before Opposition Hearing: Send/Save */
  const [
    counterTmMBeforeHearingInvoiceFooterNeedsSend,
    setCounterTmMBeforeHearingInvoiceFooterNeedsSend,
  ] = useState(false);
  const [
    counterTmMBeforeHearingInvoiceFooterNeedsSave,
    setCounterTmMBeforeHearingInvoiceFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Payment from Client for TM-M before Opposition Hearing: Save & Continue submits */
  const [
    counterTmMBeforeHearingPaymentFooterNeedsSubmit,
    setCounterTmMBeforeHearingPaymentFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → File TM-M before Opposition Hearing: Save & Continue submits */
  const [
    counterTmMBeforeHearingFiledFooterNeedsSubmit,
    setCounterTmMBeforeHearingFiledFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Inform Client about Filing of TM-M before Opposition Hearing: Send/Save */
  const [
    counterTmMBeforeHearingInformFooterNeedsSend,
    setCounterTmMBeforeHearingInformFooterNeedsSend,
  ] = useState(false);
  const [
    counterTmMBeforeHearingInformFooterNeedsSave,
    setCounterTmMBeforeHearingInformFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Payment from Client for Opposition Hearing: Save & Continue submits */
  const [
    counterOppositionHearingPaymentFooterNeedsSubmit,
    setCounterOppositionHearingPaymentFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Documents from Client for Opposition Hearing: Save & Continue records */
  const [
    counterDocumentsOppHearingFooterNeedsSubmit,
    setCounterDocumentsOppHearingFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Filing of Opposition Hearing Document: Save & Continue records */
  const [
    counterFilingOppHearingDocFooterNeedsSubmit,
    setCounterFilingOppHearingDocFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Note on Opposition Hearing: Save & Continue submits */
  const [
    counterNoteOnOppHearingFooterNeedsSubmit,
    setCounterNoteOnOppHearingFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Attend Opposition Hearing: Save & Continue submits */
  const [
    counterAttendOppHearingFooterNeedsSubmit,
    setCounterAttendOppHearingFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Inform Client after Opposition Hearing: Send/Save */
  const [
    counterInformAfterOppHearingFooterNeedsSend,
    setCounterInformAfterOppHearingFooterNeedsSend,
  ] = useState(false);
  const [
    counterInformAfterOppHearingFooterNeedsSave,
    setCounterInformAfterOppHearingFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Invoice for TM-M after Opposition Hearing: Send/Save */
  const [
    counterInvoiceTmMAfterOppHearingFooterNeedsSend,
    setCounterInvoiceTmMAfterOppHearingFooterNeedsSend,
  ] = useState(false);
  const [
    counterInvoiceTmMAfterOppHearingFooterNeedsSave,
    setCounterInvoiceTmMAfterOppHearingFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Payment from Client for TM-M after Opposition Hearing: Save & Continue submits */
  const [
    counterPaymentTmMAfterOppHearingFooterNeedsSubmit,
    setCounterPaymentTmMAfterOppHearingFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → File TM-M after Opposition Hearing: Save & Continue submits */
  const [
    counterFileTmMAfterOppHearingFooterNeedsSubmit,
    setCounterFileTmMAfterOppHearingFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Inform Client after filing TM-M after Opp Hearing: Send/Save */
  const [
    counterInformTmMAfterOppHearingFooterNeedsSend,
    setCounterInformTmMAfterOppHearingFooterNeedsSend,
  ] = useState(false);
  const [
    counterInformTmMAfterOppHearingFooterNeedsSave,
    setCounterInformTmMAfterOppHearingFooterNeedsSave,
  ] = useState(false);
  /** Opposed → Subsequent Hearings for Opposition Hearing (empty placeholder): Save & Continue advances to Order */
  const [
    counterSubsequentOppHearingsFooterNeedsSubmit,
    setCounterSubsequentOppHearingsFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Invoice for Subsequent Opposition Hearing: Save & Continue */
  const [
    counterSubsequentOppHearingInvoiceFooterNeedsSubmit,
    setCounterSubsequentOppHearingInvoiceFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Payment from Client for Subsequent Opposition Hearing: Save & Continue */
  const [
    counterSubsequentOppHearingPaymentFooterNeedsSubmit,
    setCounterSubsequentOppHearingPaymentFooterNeedsSubmit,
  ] = useState(false);
  /** Opposed → Order of Opposition Hearing to Client: Send/Save */
  const [
    counterOrderOfOppHearingFooterNeedsSend,
    setCounterOrderOfOppHearingFooterNeedsSend,
  ] = useState(false);
  const [
    counterOrderOfOppHearingFooterNeedsSave,
    setCounterOrderOfOppHearingFooterNeedsSave,
  ] = useState(false);
  /** Final Order (s6) → Registered: Status Details (Save & Continue) */
  const [
    finalOrderRegStatusFooterNeedsSubmit,
    setFinalOrderRegStatusFooterNeedsSubmit,
  ] = useState(false);
  /** Final Order (s6) → Registered: Notice (Send/Save & Continue) */
  const [
    finalOrderRegNoticeFooterNeedsSend,
    setFinalOrderRegNoticeFooterNeedsSend,
  ] = useState(false);
  const [
    finalOrderRegNoticeFooterNeedsSave,
    setFinalOrderRegNoticeFooterNeedsSave,
  ] = useState(false);
  /** Final Order (s6) → Registered: Inform Client (Send/Save & Continue) */
  const [
    finalOrderRegInformFooterNeedsSend,
    setFinalOrderRegInformFooterNeedsSend,
  ] = useState(false);
  const [
    finalOrderRegInformFooterNeedsSave,
    setFinalOrderRegInformFooterNeedsSave,
  ] = useState(false);
  /** Final Order (s6) → Refused/Abandoned: Status Details (Save & Continue) */
  const [
    finalOrderRefStatusFooterNeedsSubmit,
    setFinalOrderRefStatusFooterNeedsSubmit,
  ] = useState(false);
  /** Final Order (s6) → Refused/Abandoned: Notice (Send/Save & Continue) */
  const [
    finalOrderRefNoticeFooterNeedsSend,
    setFinalOrderRefNoticeFooterNeedsSend,
  ] = useState(false);
  const [
    finalOrderRefNoticeFooterNeedsSave,
    setFinalOrderRefNoticeFooterNeedsSave,
  ] = useState(false);
  /** Final Order (s6) → Refused/Abandoned: Inform Client (Send/Save & Continue) */
  const [
    finalOrderRefInformFooterNeedsSend,
    setFinalOrderRefInformFooterNeedsSend,
  ] = useState(false);
  const [
    finalOrderRefInformFooterNeedsSave,
    setFinalOrderRefInformFooterNeedsSave,
  ] = useState(false);
  const prevStatusSectionRef = useRef<string>("");

  useEffect(() => {
    if (!leadId) {
      setLeadNoForHeader(null);
      setLeadAccessState("idle");
      setLeadAccessMessage(LEAD_ASSIGNED_TO_ANOTHER_EMPLOYEE_MESSAGE);
      return;
    }

    setLeadAccessState("checking");
    setLeadAccessMessage(LEAD_ASSIGNED_TO_ANOTHER_EMPLOYEE_MESSAGE);
    let cancelled = false;
    getLeadDetails(leadId)
      .then(({ lead }) => {
        if (!cancelled) {
          setLeadNoForHeader(lead.leadNo ?? null);
          setMarkNameForHeader(lead.markName ?? null);
          setLeadAccessState("allowed");
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setLeadNoForHeader(null);
        setMarkNameForHeader(null);
        if (isLeadOwnershipRestrictedError(err)) {
          setLeadAccessState("restricted");
          if (err.message.trim()) {
            setLeadAccessMessage(err.message);
          }
          return;
        }
        setLeadAccessState("allowed");
      });
    return () => {
      cancelled = true;
    };
  }, [leadId]);

  const activeTab: Section =
    section === "filing" ? "filing" : section === "status" ? "status" : "discussion";
  const activeMenuItem =
    activeTab === "discussion" && step ? STEP_SLUG_TO_ID[step] ?? "preliminary" : "preliminary";
  const activeFilingId =
    activeTab === "filing" && step ? FILING_SLUG_TO_ID[step] ?? "f1" : "f1";
  const activeStatusId =
    activeTab === "status" && step ? STATUS_SLUG_TO_ID[step] ?? "s1" : "s1";

  useEffect(() => {
    const key = `${activeTab}:${activeStatusId}`;
    const prev = prevStatusSectionRef.current;
    prevStatusSectionRef.current = key;
    if (prev.startsWith("status:s1") && !key.startsWith("status:s1")) {
      setFcPassFooterNeedsSend(false);
      setFcPassFooterNeedsSave(false);
      setFcFailNoticeFooterNeedsSend(false);
      setFcFailInformFooterNeedsSend(false);
      setFcFailInvoiceFooterNeedsSend(false);
      setFcFailInformDoneFooterNeedsSend(false);
    }
    if (prev.startsWith("status:s6") && !key.startsWith("status:s6")) {
      setFinalOrderRegStatusFooterNeedsSubmit(false);
      setFinalOrderRegNoticeFooterNeedsSend(false);
      setFinalOrderRegNoticeFooterNeedsSave(false);
      setFinalOrderRegInformFooterNeedsSend(false);
      setFinalOrderRegInformFooterNeedsSave(false);
      setFinalOrderRefStatusFooterNeedsSubmit(false);
      setFinalOrderRefNoticeFooterNeedsSend(false);
      setFinalOrderRefNoticeFooterNeedsSave(false);
      setFinalOrderRefInformFooterNeedsSend(false);
      setFinalOrderRefInformFooterNeedsSave(false);
    }
  }, [activeTab, activeStatusId]);

  // Derive the 10 "hasSentXWhatsapp" flags from the shared workflow status (one
  // network request seeds all of them). Children still bubble optimistic updates
  // via onSentStatusChange — and when a step isn't present in the response we
  // leave the flag unchanged to preserve those optimistic values.
  useEffect(() => {
    if (!leadId) {
      setHasSentChecklistWhatsApp(false);
      setHasSentStampDetailsWhatsapp(false);
      setHasSentFilingConfirmationWhatsapp(false);
      setHasSentFilingDetailsWhatsapp(false);
      setHasSentSearchReportWhatsapp(false);
      setHasSentClassListWhatsapp(false);
      setHasSentInvoiceAdvanceWhatsapp(false);
      setHasSentProposalWhatsapp(false);
      setHasSentInvoiceFinalWhatsapp(false);
      setHasSentDocChecklistWhatsapp(false);
      return;
    }
    if (!workflowStatus) return;
    const steps = workflowStatus.steps ?? [];
    const apply = (
      setter: (v: boolean) => void,
      ...slugs: string[]
    ): void => {
      const match = steps.find((s) => slugs.includes(s.slug));
      if (match) setter(match.isCompleted);
    };
    apply(setHasSentChecklistWhatsApp, "S1_02_SEARCH_CHECKLIST_TO_CLIENT");
    apply(setHasSentStampDetailsWhatsapp, "S2_05_STAMP_DETAILS_TO_VENDOR");
    apply(
      setHasSentFilingConfirmationWhatsapp,
      "S2_04_FILING_DETAILS_CONFIRMATION",
      "filing-details-confirmation",
    );
    apply(
      setHasSentFilingDetailsWhatsapp,
      "S2_03B_FILING_DETAILS_SENT_TO_CLIENT",
      "filing-details-sent-to-client",
    );
    apply(setHasSentSearchReportWhatsapp, "S1_07_SEARCH_REPORT_TO_CLIENT");
    apply(setHasSentClassListWhatsapp, "S1_06_CLASS_LIST_TO_CLIENT");
    apply(setHasSentInvoiceAdvanceWhatsapp, "S1_04_ADVANCE_INVOICE_TO_CLIENT");
    apply(
      setHasSentProposalWhatsapp,
      "S1_09C_PROPOSAL_SENT_TO_CLIENT",
      "proposal-sent-to-client",
    );
    apply(
      setHasSentInvoiceFinalWhatsapp,
      "S1_11B_INVOICE_SENT_TO_CLIENT",
      "invoice-sent-to-client",
    );
    apply(setHasSentDocChecklistWhatsapp, "S2_01_DOC_CHECKLIST_TO_CLIENT");
  }, [leadId, workflowStatus]);

  const handleResendChecklist = useCallback(() => {
    if (!leadId || checklistResending) return;
    setShowSearchChecklistResendModal(true);
  }, [leadId, checklistResending]);

  // Stable callbacks for child-registered "Progress (skip)" handlers. Inline
  // arrow props would change identity each render; the child effects list
  // these props in their deps and call setState in cleanup + body, which
  // causes "Maximum update depth exceeded" when the substep is active.
  const handleFcFailInvoiceProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setFcFailInvoiceProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handlePaymentObjectionProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportObjectionPaymentProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handleDocumentsObjectionProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportObjectionDocumentsProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handlePaymentFromClientHearingProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportHaoPaymentProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handleUploadDocsAfterHearingProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportHaoUploadDocsAfterHearingProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handleInvoiceTmMAfterHearingProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportHaoTmMAfterInvoiceProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handleInvoiceTmMBeforeHearingProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportHaoTmMBeforeInvoiceProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handleDocsFromClientForHearingProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setExamReportHaoDocsFromClientProgressAction(
        handler ? { run: handler } : null,
      );
    },
    [],
  );
  const handleCounterPaymentProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterPaymentProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterNoticeOfCounterProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterNoticeOfCounterProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterDocumentsFromClientEvidenceProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterDocumentsFromClientEvidenceProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterOppositionHearingPaymentProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterOppositionHearingPaymentProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterDocumentsOppHearingProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterDocumentsOppHearingProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterTmMBeforeOppHearingInvoiceProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterTmMBeforeOppHearingInvoiceProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterTmMAfterOppHearingInvoiceProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterTmMAfterOppHearingInvoiceProgressAction(handler ? { run: handler } : null);
    },
    [],
  );
  const handleCounterTmMAfterOppHearingPaymentProgressActionChange = useCallback(
    (handler: (() => Promise<void>) | null) => {
      setCounterTmMAfterOppHearingPaymentProgressAction(handler ? { run: handler } : null);
    },
    [],
  );

  useEffect(() => {
    if (!section || !step) {
      navigate("/dashboard/applications/new-application/discussion/preliminary-discussion-with-the-client", {
        replace: true,
      });
    }
  }, [section, step, navigate]);

  const showProgressButton =
    (activeTab === "discussion" && activeMenuItem in PROGRESS_STEPS) ||
    (activeTab === "filing" && activeFilingId in PROGRESS_STEPS) ||
    (activeTab === "status" &&
      (!!fcFailInvoiceProgressAction ||
        !!examReportObjectionPaymentProgressAction ||
        !!examReportObjectionDocumentsProgressAction ||
        !!examReportHaoPaymentProgressAction ||
        !!examReportHaoDocsFromClientProgressAction ||
        !!examReportHaoUploadDocsAfterHearingProgressAction ||
        !!examReportHaoTmMAfterInvoiceProgressAction ||
        !!examReportHaoTmMBeforeInvoiceProgressAction ||
        !!counterPaymentProgressAction ||
        !!counterNoticeOfCounterProgressAction ||
        !!counterDocumentsFromClientEvidenceProgressAction ||
        !!counterOppositionHearingPaymentProgressAction ||
        !!counterDocumentsOppHearingProgressAction ||
        !!counterTmMBeforeOppHearingInvoiceProgressAction ||
        !!counterTmMAfterOppHearingInvoiceProgressAction ||
        !!counterTmMAfterOppHearingPaymentProgressAction));
  const progressStepToSkip =
    activeTab === "discussion"
      ? PROGRESS_STEPS[activeMenuItem]
      : PROGRESS_STEPS[activeFilingId];

  const handleProgress = async () => {
    if (!leadId || progressing) return;
    // Status-tab sub-steps register their own progress handlers because their
    // skip target + post-skip navigation live inside the page (sub-step state),
    // not in the dashboard menu.
    if (activeTab === "status" && fcFailInvoiceProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await fcFailInvoiceProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && examReportObjectionPaymentProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportObjectionPaymentProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && examReportObjectionDocumentsProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportObjectionDocumentsProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && examReportHaoPaymentProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportHaoPaymentProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (
      activeTab === "status" &&
      examReportHaoUploadDocsAfterHearingProgressAction
    ) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportHaoUploadDocsAfterHearingProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (
      activeTab === "status" &&
      examReportHaoTmMAfterInvoiceProgressAction
    ) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportHaoTmMAfterInvoiceProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (
      activeTab === "status" &&
      examReportHaoTmMBeforeInvoiceProgressAction
    ) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportHaoTmMBeforeInvoiceProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (
      activeTab === "status" &&
      examReportHaoDocsFromClientProgressAction
    ) {
      setProgressError(null);
      setProgressing(true);
      try {
        await examReportHaoDocsFromClientProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterPaymentProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterPaymentProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterNoticeOfCounterProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterNoticeOfCounterProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterDocumentsFromClientEvidenceProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterDocumentsFromClientEvidenceProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterOppositionHearingPaymentProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterOppositionHearingPaymentProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterDocumentsOppHearingProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterDocumentsOppHearingProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterTmMBeforeOppHearingInvoiceProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterTmMBeforeOppHearingInvoiceProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterTmMAfterOppHearingInvoiceProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterTmMAfterOppHearingInvoiceProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (activeTab === "status" && counterTmMAfterOppHearingPaymentProgressAction) {
      setProgressError(null);
      setProgressing(true);
      try {
        await counterTmMAfterOppHearingPaymentProgressAction.run();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Failed to skip step");
      } finally {
        setProgressing(false);
      }
      return;
    }
    if (!progressStepToSkip) return;
    setProgressError(null);
    setProgressing(true);
    try {
      await skipStep(leadId, progressStepToSkip);
      toast.success("Step skipped successfully.");
      const items = activeTab === "filing" ? FILING_ITEMS : menuItems;
      const activeId = activeTab === "filing" ? activeFilingId : activeMenuItem;
      const idx = items.findIndex((m) => m.id === activeId);
      if (idx >= 0 && idx < items.length - 1) {
        navigateToStep(activeTab, items[idx + 1].id, leadId);
      } else if (idx === items.length - 1) {
        // Last step in current tab: go to first step of next section
        if (activeTab === "discussion") {
          navigateToStep("filing", FILING_ITEMS[0].id, leadId);
        } else if (activeTab === "filing") {
          navigateToStep("status", "s1", leadId);
        }
      }
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to skip step");
    } finally {
      setProgressing(false);
    }
  };

  const navigateToStep = (
    tab: Section,
    itemId: string,
    currentLeadId?: string | null
  ) => {
    const slug =
      tab === "discussion"
        ? STEP_ID_TO_SLUG[itemId]
        : tab === "filing"
          ? FILING_ID_TO_SLUG[itemId]
          : STATUS_ID_TO_SLUG[itemId] ?? "formalities-check";
    if (!slug) return;
    const base = `/dashboard/applications/new-application/${tab}/${slug}`;
    const path =
      currentLeadId && (tab === "discussion" || tab === "filing" || tab === "status")
        ? `${base}/${currentLeadId}`
        : base;
    navigate(path);
    setMenuOpen(false);
  };

  const handleTabChange = (tab: Section) => {
    const firstStep =
      tab === "discussion"
        ? "preliminary-discussion-with-the-client"
        : tab === "filing"
          ? "check-list-of-documents-to-client"
          : "formalities-check";
    const path =
      leadId
        ? `/dashboard/applications/new-application/${tab}/${firstStep}/${leadId}`
        : `/dashboard/applications/new-application/${tab}/${firstStep}`;
    navigate(path);
  };

  const menuItems = [
    { id: "preliminary", label: "Preliminary Discussion with the Client" },
    { id: "checklist", label: "Check list for Search to Client" },
    { id: "details", label: "Details for Search from Client" },
    { id: "invoice-advance", label: "Invoice of Advance Amount to Client" },
    { id: "advance-amount", label: "Advance Amount from Client" },
    { id: "class-list", label: "Class list to Client" },
    { id: "search-report", label: "Search Report to Client" },
    { id: "legal-advice", label: "Legal Advice" },
    { id: "proposal", label: "Proposal to Client" },
    { id: "confirmation", label: "Confirmation from Client" },
    { id: "invoice-final", label: "Invoice to Client (Final)" },
    { id: "payment", label: "Payment from Client" },
  ];

  const leftPanelItems =
    activeTab === "filing"
      ? FILING_ITEMS
      : activeTab === "status"
        ? STATUS_ITEMS
        : menuItems;
  const activeLeftId =
    activeTab === "filing"
      ? activeFilingId
      : activeTab === "status"
        ? activeStatusId
        : activeMenuItem;

  if (leadId && leadAccessState === "checking") {
    return (
      <DashboardLayout
        headerTitle="New Application"
        headerLeadNo={markNameForHeader}
        hideHeaderOnMobile
      >
        <div className="flex-1 p-2 min-h-0 flex flex-col min-w-0">
          <div className="bg-white rounded-[8px] h-full flex items-center justify-center px-6">
            <div className="text-sm text-[#6D6D6D]">Loading lead details...</div>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  if (leadId && leadAccessState === "restricted") {
    return (
      <DashboardLayout
        headerTitle="New Application"
        headerLeadNo={markNameForHeader}
        hideHeaderOnMobile
      >
        <div className="flex-1 p-2 min-h-0 flex flex-col min-w-0">
          <div className="bg-white rounded-[8px] h-full flex items-center justify-center px-6">
            <div className="w-full max-w-[520px] text-center">
              <p className="text-base font-semibold text-[#222]">Lead access restricted</p>
              <p className="mt-2 text-sm text-[#6D6D6D]">
                {leadAccessMessage || LEAD_ASSIGNED_TO_ANOTHER_EMPLOYEE_MESSAGE}
              </p>
              <button
                type="button"
                onClick={() => navigate("/dashboard/applications")}
                className="mt-6 px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
              >
                Back to Applications
              </button>
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout
      headerTitle="New Application"
      headerLeadNo={markNameForHeader}
      hideHeaderOnMobile
    >
      <div className="flex-1 p-2 min-h-0 flex flex-col min-w-0">
          <div className="bg-white rounded-[8px] h-full flex flex-col overflow-hidden">
            {/* Tab bar - Figma: pl-[10px] pt-[6px], 14px, semibold when active, border-b #222 */}
            <div className="flex items-center gap-0 border-b border-[#EEEEEE] pl-[10px] pt-[6px] flex-shrink-0">
              <button
                onClick={() => handleTabChange("discussion")}
                className={`px-2.5 py-2.5 text-[14px] leading-5 -mb-px border-b-2 transition-colors ${
                  activeTab === "discussion"
                    ? "font-semibold text-[#222] border-[#222]"
                    : "font-normal text-[#222] border-transparent"
                }`}
              >
                Discussion
              </button>
              <button
                onClick={() => handleTabChange("filing")}
                className={`px-2.5 py-2.5 text-[14px] leading-5 -mb-px border-b-2 transition-colors ${
                  activeTab === "filing"
                    ? "font-semibold text-[#222] border-[#222]"
                    : "font-normal text-[#222] border-transparent"
                }`}
              >
                Filing
              </button>
              <button
                onClick={() => handleTabChange("status")}
                className={`px-2.5 py-2.5 text-[14px] leading-5 -mb-px border-b-2 transition-colors ${
                  activeTab === "status"
                    ? "font-semibold text-[#222] border-[#222]"
                    : "font-normal text-[#222] border-transparent"
                }`}
              >
                Status
              </button>
            </div>

            {/* Mobile-only header: hamburger + "New Application" (Figma) */}
            <div className="md:hidden flex items-center gap-3 h-[65px] px-4 border-b border-[#E5E7EB] flex-shrink-0 pb-[0.833px]">
              <button
                type="button"
                aria-label="Open menu"
                onClick={() => setMenuOpen(true)}
                className="flex items-center justify-center rounded-[10px] w-9 h-9 min-w-[36px] min-h-[36px] hover:bg-[#F7F7F7]"
              >
                <HiOutlineMenu className="w-5 h-5 text-[#222]" strokeWidth={1.5} />
              </button>
              <div className="flex-1 min-w-0 font-medium text-[14px] leading-5 text-[#242424] truncate">
                New Application
                {leadNoForHeader ? (
                  <span className="font-normal text-[#6D6D6D]">
                    {" "}
                    | {leadNoForHeader}
                  </span>
                ) : null}
              </div>
            </div>

            <div className="flex flex-1 overflow-hidden relative">
              {menuOpen && (
                <div
                  className="absolute inset-0 bg-black/20 z-40 md:hidden"
                  onClick={() => setMenuOpen(false)}
                />
              )}

              <div className={`w-[279px] border-r border-[#EEEEEE] bg-white p-2.5 overflow-y-auto flex-shrink-0 ${
                menuOpen ? "absolute left-0 top-0 bottom-0 z-50 md:relative" : "hidden md:block"
              }`}>
                <div className="flex flex-col gap-2">
                  {leftPanelItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => navigateToStep(activeTab, item.id, leadId ?? null)}
                      className={`w-full flex items-center justify-between px-2.5 py-2.5 gap-2.5 rounded-[6px] text-xs font-${
                        activeLeftId === item.id ? "500" : "400"
                      } ${
                        activeLeftId === item.id
                          ? "bg-[#222222] text-white"
                          : "bg-[#F7F7F7] text-[#222222]"
                      } hover:bg-opacity-90 transition-colors`}
                    >
                      <span className="text-left line-clamp-1">{item.label}</span>
                      <HiOutlineChevronRight className="w-4 h-4 flex-shrink-0 ml-1" strokeWidth={1.5} />
                    </button>
                  ))}
                </div>
              </div>

              <div className="flex-1 flex flex-col min-w-0">
                <div className="flex-1 p-5 md:p-6 overflow-y-auto">
                  {activeTab === "status" ? (
                    activeStatusId === "s1" ? (
                      <FormalitiesCheckView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("status", "s2", id ?? leadId ?? null);
                        }}
                        onSavingChange={setStepSaving}
                        onFcPassFooterSendModeChange={setFcPassFooterNeedsSend}
                        onFcPassFooterSaveModeChange={setFcPassFooterNeedsSave}
                        onFcFailNoticeFooterSendModeChange={
                          setFcFailNoticeFooterNeedsSend
                        }
                        onFcFailInformFooterSendModeChange={
                          setFcFailInformFooterNeedsSend
                        }
                        onFcFailInvoiceFooterSendModeChange={
                          setFcFailInvoiceFooterNeedsSend
                        }
                        onFcFailInformDoneFooterSendModeChange={
                          setFcFailInformDoneFooterNeedsSend
                        }
                        onFcFailStatusFooterFormModeChange={
                          setFcFailStatusFooterNeedsSubmit
                        }
                        onFcFailNoticeFooterSaveModeChange={
                          setFcFailNoticeFooterNeedsSave
                        }
                        onFcFailInformFooterSaveModeChange={
                          setFcFailInformFooterNeedsSave
                        }
                        onFcFailInvoiceFooterSaveModeChange={
                          setFcFailInvoiceFooterNeedsSave
                        }
                        onFcFailInformDoneFooterSaveModeChange={
                          setFcFailInformDoneFooterNeedsSave
                        }
                        onFcFailCallClientFooterFormModeChange={
                          setFcFailCallClientFooterNeedsSubmit
                        }
                        onFcFailConfirmationFooterFormModeChange={
                          setFcFailConfirmationFooterNeedsSubmit
                        }
                        onFcFailDocumentsFooterFormModeChange={
                          setFcFailDocumentsFooterNeedsSubmit
                        }
                        onFcFailFilingOfReplyFooterFormModeChange={
                          setFcFailFilingOfReplyFooterNeedsSubmit
                        }
                        onFcFailInvoiceProgressActionChange={
                          handleFcFailInvoiceProgressActionChange
                        }
                      />
                    ) : activeStatusId === "s2" ? (
                      <MarkedForExamView
                        leadId={leadId ?? null}
                        onSavingChange={setStepSaving}
                        onAcceptedFooterSendModeChange={
                          setMarkedForExamAcceptedFooterNeedsSend
                        }
                        onAAOFooterSendModeChange={
                          setMarkedForExamAAOFooterNeedsSend
                        }
                        onSuccess={(id) => {
                          navigateToStep("status", "s3", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeStatusId === "s3" ? (
                      <ExaminationReportView
                        leadId={leadId ?? null}
                        onSavingChange={setStepSaving}
                        // 3D(vii) NO → 5B(i) Status details for Refusal or
                        // Abandonment (spec pg 87). That screen is the Final
                        // Order section's Refused-or-Abandoned sub-tab.
                        onAdvanceToRefusalAbandonment={() =>
                          navigate(
                            `/dashboard/applications/new-application/status/final-order/${leadId}?sub=refused-or-abandoned`
                          )
                        }
                        onNoticeToClientFooterSendModeChange={
                          setExamReportNoticeFooterNeedsSend
                        }
                        onNoticeToClientFooterSaveModeChange={
                          setExamReportNoticeFooterNeedsSave
                        }
                        onInformClientFooterSendModeChange={
                          setExamReportInformFooterNeedsSend
                        }
                        onInformClientFooterSaveModeChange={
                          setExamReportInformFooterNeedsSave
                        }
                        onStatusOfAcceptanceFooterFormModeChange={
                          setExamReportSoaFooterNeedsSubmit
                        }
                        onStatusOfObjectionFooterFormModeChange={
                          setExamReportSooFooterNeedsSubmit
                        }
                        onNoticeToClientObjectionFooterSendModeChange={
                          setExamReportNtcoFooterNeedsSend
                        }
                        onNoticeToClientObjectionFooterSaveModeChange={
                          setExamReportNtcoFooterNeedsSave
                        }
                        onInformClientObjectionFooterSendModeChange={
                          setExamReportIncoFooterNeedsSend
                        }
                        onInformClientObjectionFooterSaveModeChange={
                          setExamReportIncoFooterNeedsSave
                        }
                        onCallClientObjectionFooterFormModeChange={
                          setExamReportCcroFooterNeedsSubmit
                        }
                        onClientConfirmationObjectionFooterFormModeChange={
                          setExamReportCcoFooterNeedsSubmit
                        }
                        onInvoiceObjectionFooterFormModeChange={
                          setExamReportInvFooterNeedsSubmit
                        }
                        onPaymentObjectionFooterFormModeChange={
                          setExamReportPayFooterNeedsSubmit
                        }
                        onPaymentObjectionProgressActionChange={
                          handlePaymentObjectionProgressActionChange
                        }
                        onDocumentsObjectionFooterFormModeChange={
                          setExamReportDocFooterNeedsSubmit
                        }
                        onDocumentsObjectionProgressActionChange={
                          handleDocumentsObjectionProgressActionChange
                        }
                        onFilingReplyObjectionFooterFormModeChange={
                          setExamReportFroFooterNeedsSubmit
                        }
                        onInformClientReplyObjectionFooterSendModeChange={
                          setExamReportIcrFooterNeedsSend
                        }
                        onInformClientReplyObjectionFooterSaveModeChange={
                          setExamReportIcrFooterNeedsSave
                        }
                        onStatusOfAaoFooterFormModeChange={
                          setExamReportAaoStatusFooterNeedsSubmit
                        }
                        onNoticeToClientAaoFooterSendModeChange={
                          setExamReportAaoNoticeFooterNeedsSend
                        }
                        onNoticeToClientAaoFooterSaveModeChange={
                          setExamReportAaoNoticeFooterNeedsSave
                        }
                        onInformClientAaoFooterSendModeChange={
                          setExamReportAaoInformFooterNeedsSend
                        }
                        onInformClientAaoFooterSaveModeChange={
                          setExamReportAaoInformFooterNeedsSave
                        }
                        onInformClientHaoFooterSendModeChange={
                          setExamReportHaoInformFooterNeedsSend
                        }
                        onInformClientHaoFooterSaveModeChange={
                          setExamReportHaoInformFooterNeedsSave
                        }
                        onStatusDetailsOfHearingFooterFormModeChange={
                          setExamReportHaoStatusFooterNeedsSubmit
                        }
                        onNoticeToClientHearingFooterSendModeChange={
                          setExamReportHaoNoticeFooterNeedsSend
                        }
                        onNoticeToClientHearingFooterSaveModeChange={
                          setExamReportHaoNoticeFooterNeedsSave
                        }
                        onInformClientAboutHearingFooterSendModeChange={
                          setExamReportHaoInformHearingFooterNeedsSend
                        }
                        onInformClientAboutHearingFooterSaveModeChange={
                          setExamReportHaoInformHearingFooterNeedsSave
                        }
                        onCallClientHearingFooterFormModeChange={
                          setExamReportHaoCallClientFooterNeedsSubmit
                        }
                        onConfirmationFromClientHearingFooterFormModeChange={
                          setExamReportHaoConfirmationFooterNeedsSubmit
                        }
                        onRevisedInvoiceForHearingFooterFormModeChange={
                          setExamReportHaoRevisedInvoiceFooterNeedsSubmit
                        }
                        onInvoiceForHearingFooterFormModeChange={
                          setExamReportHaoInvoiceFooterNeedsSubmit
                        }
                        onInvoiceForHearingSentStatusChange={
                          setExamReportHaoInvoiceSent
                        }
                        onInvoiceForTmMBeforeHearingFooterFormModeChange={
                          setExamReportHaoTmMInvoiceFooterNeedsSubmit
                        }
                        onInvoiceForTmMBeforeHearingFooterSkipModeChange={
                          setExamReportHaoTmMInvoiceFooterNeedsSkip
                        }
                        onInvoiceForTmMBeforeHearingProgressActionChange={
                          handleInvoiceTmMBeforeHearingProgressActionChange
                        }
                        onInvoiceForTmMBeforeHearingSentStatusChange={
                          setExamReportHaoTmMInvoiceSent
                        }
                        onPaymentForTmMBeforeHearingFooterFormModeChange={
                          setExamReportHaoTmMPaymentFooterNeedsSubmit
                        }
                        onPaymentForTmMBeforeHearingFooterSkipModeChange={
                          setExamReportHaoTmMPaymentFooterNeedsSkip
                        }
                        onFileTmMBeforeHearingFooterFormModeChange={
                          setExamReportHaoTmMFileFooterNeedsSubmit
                        }
                        onInformClientTmMBeforeHearingFooterSendModeChange={
                          setExamReportHaoTmMInformFooterNeedsSend
                        }
                        onInformClientTmMBeforeHearingFooterSaveModeChange={
                          setExamReportHaoTmMInformFooterNeedsSave
                        }
                        onPaymentFromClientHearingFooterFormModeChange={
                          setExamReportHaoPaymentFooterNeedsSubmit
                        }
                        onPaymentFromClientHearingProgressActionChange={
                          handlePaymentFromClientHearingProgressActionChange
                        }
                        onStampPaperVendorHearingFooterSendModeChange={
                          setExamReportHaoStampVendorFooterNeedsSend
                        }
                        onStampPaperVendorHearingFooterSaveModeChange={
                          setExamReportHaoStampVendorFooterNeedsSave
                        }
                        onStampPaperVendorHearingFooterSkipModeChange={
                          setExamReportHaoStampVendorFooterNeedsSkip
                        }
                        onStampPaperFromVendorHearingFooterFormModeChange={
                          setExamReportHaoStampFromVendorFooterNeedsSubmit
                        }
                        onStampPaperFromVendorHearingFooterSkipModeChange={
                          setExamReportHaoStampFromVendorFooterNeedsSkip
                        }
                        onDocumentsFromClientHearingFooterFormModeChange={
                          setExamReportHaoDocsFromClientFooterNeedsSubmit
                        }
                        onUserAffidavitForHearingFooterFormModeChange={
                          setExamReportHaoUserAffidavitFooterNeedsSubmit
                        }
                        onUserAffidavitForHearingFooterSkipModeChange={
                          setExamReportHaoUserAffidavitFooterNeedsSkip
                        }
                        onSignatureFromClientHearingFooterFormModeChange={
                          setExamReportHaoSignatureFooterNeedsSubmit
                        }
                        onNotarisationOfDocumentsHearingFooterFormModeChange={
                          setExamReportHaoNotarisationFooterNeedsSubmit
                        }
                        onNotarisationOfDocumentsHearingFooterSkipModeChange={
                          setExamReportHaoNotarisationFooterNeedsSkip
                        }
                        onScanningOfDocumentsHearingFooterFormModeChange={
                          setExamReportHaoScanningFooterNeedsSubmit
                        }
                        onFileHearingDocumentFooterFormModeChange={
                          setExamReportHaoFileHearingDocFooterNeedsSubmit
                        }
                        onNoteOnHearingFooterFormModeChange={
                          setExamReportHaoNoteOnHearingFooterNeedsSubmit
                        }
                        onAttendHearingFooterFormModeChange={
                          setExamReportHaoAttendHearingFooterNeedsSubmit
                        }
                        onHearingNotHappenedFooterSendModeChange={
                          setExamReportHaoHearingNotHappenedFooterNeedsSend
                        }
                        onHearingNotHappenedFooterSaveModeChange={
                          setExamReportHaoHearingNotHappenedFooterNeedsSave
                        }
                        onHearingNotHappenedFooterSkipModeChange={
                          setExamReportHaoHearingNotHappenedFooterNeedsSkip
                        }
                        onInformAfterHearingFooterSendModeChange={
                          setExamReportHaoInformAfterHearingFooterNeedsSend
                        }
                        onInformAfterHearingFooterSaveModeChange={
                          setExamReportHaoInformAfterHearingFooterNeedsSave
                        }
                        onDocumentsFromClientHearingProgressActionChange={
                          handleDocsFromClientForHearingProgressActionChange
                        }
                        onUploadDocsAfterHearingFooterFormModeChange={
                          setExamReportHaoUploadDocsAfterHearingFooterNeedsSubmit
                        }
                        onUploadDocsAfterHearingProgressActionChange={
                          handleUploadDocsAfterHearingProgressActionChange
                        }
                        onInvoiceTmMAfterHearingFooterFormModeChange={
                          setExamReportHaoTmMAfterInvoiceFooterNeedsSubmit
                        }
                        onInvoiceTmMAfterHearingFooterSkipModeChange={
                          setExamReportHaoTmMAfterInvoiceFooterNeedsSkip
                        }
                        onInvoiceTmMAfterHearingProgressActionChange={
                          handleInvoiceTmMAfterHearingProgressActionChange
                        }
                        onPaymentTmMAfterHearingFooterFormModeChange={
                          setExamReportHaoTmMAfterPaymentFooterNeedsSubmit
                        }
                        onPaymentTmMAfterHearingFooterSkipModeChange={
                          setExamReportHaoTmMAfterPaymentFooterNeedsSkip
                        }
                        onFileTmMAfterHearingFooterFormModeChange={
                          setExamReportHaoFileTmMAfterHearingFooterNeedsSubmit
                        }
                        onFileTmMAfterHearingFooterSkipModeChange={
                          setExamReportHaoFileTmMAfterHearingFooterNeedsSkip
                        }
                        onInformTmMAfterHearingFooterSendModeChange={
                          setExamReportHaoInformTmMAfterHearingFooterNeedsSend
                        }
                        onInformTmMAfterHearingFooterSaveModeChange={
                          setExamReportHaoInformTmMAfterHearingFooterNeedsSave
                        }
                        onInformTmMAfterHearingFooterSkipModeChange={
                          setExamReportHaoInformTmMAfterHearingFooterNeedsSkip
                        }
                        onSubsequentHearingsFooterSendModeChange={
                          setExamReportHaoSubsequentHearingsFooterNeedsSend
                        }
                        onSubsequentHearingsFooterSaveModeChange={
                          setExamReportHaoSubsequentHearingsFooterNeedsSave
                        }
                        onSubsequentHearingsFooterSkipModeChange={
                          setExamReportHaoSubsequentHearingsFooterNeedsSkip
                        }
                        onSubsequentHearingInvoiceFooterSkipModeChange={
                          setExamReportHaoSubsequentInvoiceFooterNeedsSkip
                        }
                        onSubsequentHearingInvoiceFooterFormModeChange={
                          setExamReportHaoSubsequentInvoiceFooterNeedsSubmit
                        }
                        onSubsequentHearingInvoiceSentStatusChange={
                          setExamReportHaoSubsequentInvoiceSent
                        }
                        onSubsequentHearingPaymentFromClientFooterFormModeChange={
                          setExamReportHaoSubsequentPaymentFooterNeedsSubmit
                        }
                        onSubsequentHearingPaymentFromClientFooterSkipModeChange={
                          setExamReportHaoSubsequentPaymentFooterNeedsSkip
                        }
                        onSubsequentHearingAttendFooterFormModeChange={
                          setExamReportHaoSubsequentAttendFooterNeedsSubmit
                        }
                        onSubsequentHearingAttendFooterSkipModeChange={
                          setExamReportHaoSubsequentAttendFooterNeedsSkip
                        }
                        onSubsequentHearingPostponementFooterFormModeChange={
                          setExamReportHaoSubsequentPostponementFooterNeedsSubmit
                        }
                        onOrderOfHearingFooterSendModeChange={
                          setExamReportHaoOrderOfHearingFooterNeedsSend
                        }
                        onOrderOfHearingFooterSaveModeChange={
                          setExamReportHaoOrderOfHearingFooterNeedsSave
                        }
                        onSuccess={(id) => {
                          navigateToStep("status", "s4", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeStatusId === "s5" ? (
                      <AdvertisedInJournalView
                        leadId={leadId ?? null}
                        onSavingChange={setStepSaving}
                        // 4A(v) NO → 5B(i) Status details for Abandonment
                        // (spec pg 119). Same destination as 3D(vii) NO: the
                        // Final Order section's Refused-or-Abandoned sub-tab.
                        onAdvanceToRefusalAbandonment={() =>
                          navigate(
                            `/dashboard/applications/new-application/status/final-order/${leadId}?sub=refused-or-abandoned`
                          )
                        }
                        onStatusDetailsFooterFormModeChange={
                          setAdvJournalStatusDetailsFooterNeedsSubmit
                        }
                        onNoticeFooterSendModeChange={
                          setAdvJournalNoticeFooterNeedsSend
                        }
                        onNoticeFooterSaveModeChange={
                          setAdvJournalNoticeFooterNeedsSave
                        }
                        onInformFooterSendModeChange={
                          setAdvJournalInformFooterNeedsSend
                        }
                        onInformFooterSaveModeChange={
                          setAdvJournalInformFooterNeedsSave
                        }
                        onCounterStatusFooterFormModeChange={
                          setOppositionCounterStatusFooterNeedsSubmit
                        }
                        onCounterNoticeFooterSendModeChange={
                          setOppositionCounterNoticeFooterNeedsSend
                        }
                        onCounterNoticeFooterSaveModeChange={
                          setOppositionCounterNoticeFooterNeedsSave
                        }
                        onCounterInformFooterSendModeChange={
                          setOppositionCounterInformFooterNeedsSend
                        }
                        onCounterInformFooterSaveModeChange={
                          setOppositionCounterInformFooterNeedsSave
                        }
                        onCounterCallFooterFormModeChange={
                          setOppositionCounterCallFooterNeedsSubmit
                        }
                        onCounterConfirmationFooterFormModeChange={
                          setCounterConfirmationFooterNeedsSubmit
                        }
                        onCounterInvoiceFooterSendModeChange={
                          setCounterInvoiceFooterNeedsSend
                        }
                        onCounterInvoiceFooterSaveModeChange={
                          setCounterInvoiceFooterNeedsSave
                        }
                        onCounterPaymentFooterFormModeChange={
                          setCounterPaymentFooterNeedsSubmit
                        }
                        onCounterPaymentProgressActionChange={
                          handleCounterPaymentProgressActionChange
                        }
                        onCounterPrepareFooterFormModeChange={
                          setCounterPrepareFooterNeedsSubmit
                        }
                        onCounterFileFooterFormModeChange={
                          setCounterFileFooterNeedsSubmit
                        }
                        onCounterInformFilingFooterSendModeChange={
                          setCounterInformFilingFooterNeedsSend
                        }
                        onCounterInformFilingFooterSaveModeChange={
                          setCounterInformFilingFooterNeedsSave
                        }
                        onCounterNoticeOfCounterFooterFormModeChange={
                          setCounterNoticeOfCounterFooterNeedsSubmit
                        }
                        onCounterNoticeOfCounterProgressActionChange={
                          handleCounterNoticeOfCounterProgressActionChange
                        }
                        onCounterInformNoticeFooterSendModeChange={
                          setCounterInformNoticeFooterNeedsSend
                        }
                        onCounterInformNoticeFooterSaveModeChange={
                          setCounterInformNoticeFooterNeedsSave
                        }
                        onCounterEvidenceByOpponentFooterFormModeChange={
                          setCounterEvidenceByOpponentFooterNeedsSubmit
                        }
                        onCounterNoticeEvidenceByOppFooterSendModeChange={
                          setCounterNoticeEvidenceByOppFooterNeedsSend
                        }
                        onCounterNoticeEvidenceByOppFooterSaveModeChange={
                          setCounterNoticeEvidenceByOppFooterNeedsSave
                        }
                        onCounterInformEvidenceByOppFooterSendModeChange={
                          setCounterInformEvidenceByOppFooterNeedsSend
                        }
                        onCounterInformEvidenceByOppFooterSaveModeChange={
                          setCounterInformEvidenceByOppFooterNeedsSave
                        }
                        onCounterCallClientEvidenceFooterFormModeChange={
                          setCounterCallClientEvidenceFooterNeedsSubmit
                        }
                        onCounterEvidenceConfirmationFooterFormModeChange={
                          setCounterEvidenceConfirmationFooterNeedsSubmit
                        }
                        onCounterEvidenceInvoiceFooterSendModeChange={
                          setCounterEvidenceInvoiceFooterNeedsSend
                        }
                        onCounterEvidenceInvoiceFooterSaveModeChange={
                          setCounterEvidenceInvoiceFooterNeedsSave
                        }
                        onCounterEvidencePaymentFooterFormModeChange={
                          setCounterEvidencePaymentFooterNeedsSubmit
                        }
                        onCounterStampVendorEvidenceFooterSendModeChange={
                          setCounterStampVendorEvidenceFooterNeedsSend
                        }
                        onCounterStampVendorEvidenceFooterSaveModeChange={
                          setCounterStampVendorEvidenceFooterNeedsSave
                        }
                        onCounterStampFromVendorEvidenceFooterFormModeChange={
                          setCounterStampFromVendorEvidenceFooterNeedsSubmit
                        }
                        onCounterDocumentsFromClientEvidenceFooterFormModeChange={
                          setCounterDocumentsFromClientEvidenceFooterNeedsSubmit
                        }
                        onCounterDocumentsFromClientEvidenceProgressActionChange={
                          handleCounterDocumentsFromClientEvidenceProgressActionChange
                        }
                        onCounterPreparationEvidenceAffidavitFooterFormModeChange={
                          setCounterPreparationEvidenceAffidavitFooterNeedsSubmit
                        }
                        onCounterSignatureAffidavitFooterFormModeChange={
                          setCounterSignatureAffidavitFooterNeedsSubmit
                        }
                        onCounterNotarisationEvidenceFooterFormModeChange={
                          setCounterNotarisationEvidenceFooterNeedsSubmit
                        }
                        onCounterScanningEvidenceFooterFormModeChange={
                          setCounterScanningEvidenceFooterNeedsSubmit
                        }
                        onCounterFileEvidenceAffidavitFooterFormModeChange={
                          setCounterFileEvidenceAffidavitFooterNeedsSubmit
                        }
                        onCounterInformFilingEvidenceFooterSendModeChange={
                          setCounterInformFilingEvidenceFooterNeedsSend
                        }
                        onCounterInformFilingEvidenceFooterSaveModeChange={
                          setCounterInformFilingEvidenceFooterNeedsSave
                        }
                        onCounterDownloadRejoinderFooterFormModeChange={
                          setCounterDownloadRejoinderFooterNeedsSubmit
                        }
                        onCounterOppositionHearingStatusFooterFormModeChange={
                          setCounterOppositionHearingStatusFooterNeedsSubmit
                        }
                        onCounterOppositionHearingNoticeFooterSendModeChange={
                          setCounterOppositionHearingNoticeFooterNeedsSend
                        }
                        onCounterOppositionHearingNoticeFooterSaveModeChange={
                          setCounterOppositionHearingNoticeFooterNeedsSave
                        }
                        onCounterOppositionHearingInformFooterSendModeChange={
                          setCounterOppositionHearingInformFooterNeedsSend
                        }
                        onCounterOppositionHearingInformFooterSaveModeChange={
                          setCounterOppositionHearingInformFooterNeedsSave
                        }
                        onCounterOppositionHearingInvoiceFooterSendModeChange={
                          setCounterOppositionHearingInvoiceFooterNeedsSend
                        }
                        onCounterOppositionHearingInvoiceFooterSaveModeChange={
                          setCounterOppositionHearingInvoiceFooterNeedsSave
                        }
                        onCounterOppositionHearingCallFooterFormModeChange={
                          setCounterOppositionHearingCallFooterNeedsSubmit
                        }
                        onCounterOppositionHearingConfirmationFooterFormModeChange={
                          setCounterOppositionHearingConfirmationFooterNeedsSubmit
                        }
                        onCounterTmMBeforeHearingInvoiceFooterSendModeChange={
                          setCounterTmMBeforeHearingInvoiceFooterNeedsSend
                        }
                        onCounterTmMBeforeHearingInvoiceFooterSaveModeChange={
                          setCounterTmMBeforeHearingInvoiceFooterNeedsSave
                        }
                        onCounterTmMBeforeHearingInvoiceProgressActionChange={
                          handleCounterTmMBeforeOppHearingInvoiceProgressActionChange
                        }
                        onCounterTmMBeforeHearingPaymentFooterFormModeChange={
                          setCounterTmMBeforeHearingPaymentFooterNeedsSubmit
                        }
                        onCounterTmMBeforeHearingFiledFooterFormModeChange={
                          setCounterTmMBeforeHearingFiledFooterNeedsSubmit
                        }
                        onCounterTmMBeforeHearingInformFooterSendModeChange={
                          setCounterTmMBeforeHearingInformFooterNeedsSend
                        }
                        onCounterTmMBeforeHearingInformFooterSaveModeChange={
                          setCounterTmMBeforeHearingInformFooterNeedsSave
                        }
                        onCounterOppositionHearingPaymentFooterFormModeChange={
                          setCounterOppositionHearingPaymentFooterNeedsSubmit
                        }
                        onCounterOppositionHearingPaymentProgressActionChange={
                          handleCounterOppositionHearingPaymentProgressActionChange
                        }
                        onCounterDocumentsOppHearingFooterFormModeChange={
                          setCounterDocumentsOppHearingFooterNeedsSubmit
                        }
                        onCounterDocumentsOppHearingProgressActionChange={
                          handleCounterDocumentsOppHearingProgressActionChange
                        }
                        onCounterFilingOppHearingDocFooterFormModeChange={
                          setCounterFilingOppHearingDocFooterNeedsSubmit
                        }
                        onCounterNoteOnOppHearingFooterFormModeChange={
                          setCounterNoteOnOppHearingFooterNeedsSubmit
                        }
                        onCounterAttendOppHearingFooterFormModeChange={
                          setCounterAttendOppHearingFooterNeedsSubmit
                        }
                        onCounterInformAfterOppHearingFooterSendModeChange={
                          setCounterInformAfterOppHearingFooterNeedsSend
                        }
                        onCounterInformAfterOppHearingFooterSaveModeChange={
                          setCounterInformAfterOppHearingFooterNeedsSave
                        }
                        onCounterInvoiceTmMAfterOppHearingFooterSendModeChange={
                          setCounterInvoiceTmMAfterOppHearingFooterNeedsSend
                        }
                        onCounterInvoiceTmMAfterOppHearingFooterSaveModeChange={
                          setCounterInvoiceTmMAfterOppHearingFooterNeedsSave
                        }
                        onCounterInvoiceTmMAfterOppHearingProgressActionChange={
                          handleCounterTmMAfterOppHearingInvoiceProgressActionChange
                        }
                        onCounterPaymentTmMAfterOppHearingFooterFormModeChange={
                          setCounterPaymentTmMAfterOppHearingFooterNeedsSubmit
                        }
                        onCounterPaymentTmMAfterOppHearingProgressActionChange={
                          handleCounterTmMAfterOppHearingPaymentProgressActionChange
                        }
                        onCounterFileTmMAfterOppHearingFooterFormModeChange={
                          setCounterFileTmMAfterOppHearingFooterNeedsSubmit
                        }
                        onCounterInformTmMAfterOppHearingFooterSendModeChange={
                          setCounterInformTmMAfterOppHearingFooterNeedsSend
                        }
                        onCounterInformTmMAfterOppHearingFooterSaveModeChange={
                          setCounterInformTmMAfterOppHearingFooterNeedsSave
                        }
                        onCounterSubsequentOppHearingsFooterFormModeChange={
                          setCounterSubsequentOppHearingsFooterNeedsSubmit
                        }
                        onCounterSubsequentOppHearingInvoiceFooterFormModeChange={
                          setCounterSubsequentOppHearingInvoiceFooterNeedsSubmit
                        }
                        onCounterSubsequentOppHearingPaymentFooterFormModeChange={
                          setCounterSubsequentOppHearingPaymentFooterNeedsSubmit
                        }
                        onCounterOrderOfOppHearingFooterSendModeChange={
                          setCounterOrderOfOppHearingFooterNeedsSend
                        }
                        onCounterOrderOfOppHearingFooterSaveModeChange={
                          setCounterOrderOfOppHearingFooterNeedsSave
                        }
                        onSuccess={(id) => {
                          // Stay in s5; the view advances internally to its sub-steps
                          if (id) {
                            // no-op — leadId already set
                          }
                        }}
                      />
                    ) : activeStatusId === "s6" ? (
                      <FinalOrderView
                        leadId={leadId ?? null}
                        onSavingChange={setStepSaving}
                        onRegisteredStatusFooterFormModeChange={
                          setFinalOrderRegStatusFooterNeedsSubmit
                        }
                        onRegisteredNoticeFooterSendModeChange={
                          setFinalOrderRegNoticeFooterNeedsSend
                        }
                        onRegisteredNoticeFooterSaveModeChange={
                          setFinalOrderRegNoticeFooterNeedsSave
                        }
                        onRegisteredInformFooterSendModeChange={
                          setFinalOrderRegInformFooterNeedsSend
                        }
                        onRegisteredInformFooterSaveModeChange={
                          setFinalOrderRegInformFooterNeedsSave
                        }
                        onRefusedStatusFooterFormModeChange={
                          setFinalOrderRefStatusFooterNeedsSubmit
                        }
                        onRefusedNoticeFooterSendModeChange={
                          setFinalOrderRefNoticeFooterNeedsSend
                        }
                        onRefusedNoticeFooterSaveModeChange={
                          setFinalOrderRefNoticeFooterNeedsSave
                        }
                        onRefusedInformFooterSendModeChange={
                          setFinalOrderRefInformFooterNeedsSend
                        }
                        onRefusedInformFooterSaveModeChange={
                          setFinalOrderRefInformFooterNeedsSave
                        }
                        onSuccess={(id) => {
                          // Stay in s6; the view advances internally to its sub-steps
                          if (id) {
                            // no-op — leadId already set
                          }
                        }}
                      />
                    ) : activeStatusId === "s7" ? (
                      <StatusHistoryView leadId={leadId ?? null} />
                    ) : (
                      <div className="flex flex-col gap-4 w-full max-w-[1085px]" style={{ fontFamily: "Inter, sans-serif" }}>
                        <p className="text-sm text-[#6D6D6D]">
                          {STATUS_ITEMS.find((s) => s.id === activeStatusId)?.label} — Coming soon
                        </p>
                      </div>
                    )
                  ) : activeTab === "filing" ? (
                    activeFilingId === "f1" ? (
                      <ChecklistDocumentsToClientView leadId={leadId ?? null} />
                    ) : activeFilingId === "f2" ? (
                      <DocumentsFromClientView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f3", id);
                        }}
                      />
                    ) : activeFilingId === "f3" ? (
                      <FilingDetailsToClientView
                        leadId={leadId ?? null}
                        onSentStatusChange={setHasSentFilingDetailsWhatsapp}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f4", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f4" ? (
                      <ConfirmationOfFilingDetailsView
                        leadId={leadId ?? null}
                        onSentStatusChange={setHasSentFilingConfirmationWhatsapp}
                        onGoToEditFilingDetails={
                          leadId
                            ? () => {
                                navigateToStep("filing", "f3", leadId);
                              }
                            : undefined
                        }
                        onSuccess={(id) => {
                          navigateToStep("filing", "f5", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f5" ? (
                      <StampPaperDetailsToVendorView
                        leadId={leadId ?? null}
                        onSentStatusChange={setHasSentStampDetailsWhatsapp}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f6", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f6" ? (
                      <StampPaperFromVendorView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f7", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f7" ? (
                      <PreparationOfPowerOfAttorneyView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f8", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f8" ? (
                      <PreparationOfUserAffidavitView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f9", id ?? leadId ?? null);
                        }}
                        onSkipToNextStep={() => {
                          const idx = FILING_ITEMS.findIndex((f) => f.id === activeFilingId);
                          if (idx >= 0 && idx < FILING_ITEMS.length - 1) {
                            navigateToStep("filing", FILING_ITEMS[idx + 1].id, leadId ?? null);
                          }
                        }}
                      />
                    ) : activeFilingId === "f9" ? (
                      <SignatureFromClientView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f10", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f10" ? (
                      <NotarisationOfDocumentsView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f11", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f11" ? (
                      <ScanningOfDocumentsView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f12", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f12" ? (
                      <UploadingApplicationDetailsView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f13", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f13" ? (
                      <FilingOfApplicationView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f14", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f14" ? (
                      <AcknowledgementToClientView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f15", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f15" ? (
                      <FilingOfExpeditedApplicationView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f16", id ?? leadId ?? null);
                        }}
                      />
                    ) : activeFilingId === "f16" ? (
                      <InvoiceToClientForExpeditedApplicationView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("filing", "f17", id ?? leadId ?? null);
                        }}
                        onSavingChange={setStepSaving}
                      />
                    ) : activeFilingId === "f17" ? (
                      <PaymentFromClientExpeditedView
                        leadId={leadId ?? null}
                        onSuccess={(id) => {
                          navigateToStep("status", "s1", id ?? leadId ?? null);
                        }}
                        onSavingChange={setStepSaving}
                      />
                    ) : (
                      <div className="text-sm text-[#6D6D6D]">
                        Content for {FILING_ITEMS.find((f) => f.id === activeFilingId)?.label} — Coming soon
                      </div>
                    )
                  ) : activeMenuItem === "details" ? (
                    <DetailsSearchFromClientView
                      leadId={leadId ?? undefined}
                      onSuccess={(id) => {
                        navigateToStep(
                          "discussion",
                          "invoice-advance",
                          id ?? leadId ?? null
                        );
                      }}
                    />
                  ) : activeMenuItem === "checklist" ? (
                    <ChecklistSearchToClientView
                      leadId={leadId}
                      canResend={hasSentChecklistWhatsApp}
                      onResend={handleResendChecklist}
                      resending={checklistResending}
                    />
                  ) : activeMenuItem === "invoice-advance" ? (
                    <InvoiceAdvanceAmountView
                      leadId={leadId ?? null}
                      onSuccess={(id) => {
                        navigateToStep(
                          "discussion",
                          "advance-amount",
                          id ?? leadId ?? null
                        );
                      }}
                    />
                  ) : activeMenuItem === "advance-amount" ? (
                    <AdvanceAmountFromClientView
                      leadId={leadId ?? null}
                      onSuccess={(id) => {
                        navigateToStep(
                          "discussion",
                          "class-list",
                          id ?? leadId ?? null
                        );
                      }}
                    />
                  ) : activeMenuItem === "class-list" ? (
                    <ClassListToClientView
                      leadId={leadId ?? null}
                      onSentStatusChange={setHasSentClassListWhatsapp}
                      onSuccess={(id) => {
                        navigateToStep(
                          "discussion",
                          "search-report",
                          id ?? leadId ?? null
                        );
                      }}
                    />
                  ) : activeMenuItem === "search-report" ? (
                    <SearchReportToClientView
                      leadId={leadId ?? null}
                      onSentStatusChange={setHasSentSearchReportWhatsapp}
                      onSuccess={(id) => {
                        navigateToStep(
                          "discussion",
                          "legal-advice",
                          id ?? leadId ?? null
                        );
                      }}
                    />
                  ) : activeMenuItem === "legal-advice" ? (
                    <LegalAdviceView
                      leadId={leadId ?? null}
                      onSuccess={(id) => {
                        navigateToStep("discussion", "proposal", id);
                      }}
                      onNewMarkSuccess={(newLeadId) => {
                        navigateToStep("discussion", "checklist", newLeadId);
                      }}
                    />
                  ) : activeMenuItem === "proposal" ? (
                    <ProposalToClientView
                      leadId={leadId ?? null}
                      onSuccess={(id) => {
                        navigateToStep(
                          "discussion",
                          "confirmation",
                          id ?? leadId ?? null
                        );
                      }}
                      onSavingChange={setStepSaving}
                      onSentStatusChange={setHasSentProposalWhatsapp}
                    />
                  ) : activeMenuItem === "confirmation" ? (
                    <ConfirmationFromClientView
                      leadId={leadId ?? null}
                      onSuccess={(id) => {
                        navigateToStep("discussion", "invoice-final", id);
                      }}
                      onSavingChange={setStepSaving}
                    />
                  ) : activeMenuItem === "invoice-final" ? (
                    <InvoiceToClientFinalView
                      leadId={leadId ?? null}
                      onSentStatusChange={setHasSentInvoiceFinalWhatsapp}
                      onSuccess={(id) => {
                        navigateToStep("discussion", "payment", id);
                      }}
                      onSavingChange={setStepSaving}
                    />
                  ) : activeMenuItem === "payment" ? (
                    <PaymentFromClientView
                      leadId={leadId ?? null}
                      onSuccess={(id) => {
                        navigateToStep("filing", "f1", id ?? leadId ?? null);
                      }}
                      onSavingChange={setStepSaving}
                    />
                  ) : (
                    <PreliminaryDiscussionView
                      leadId={leadId ?? undefined}
                      onSuccess={(newLeadId) => {
                        navigate(
                          `/dashboard/applications/new-application/discussion/check-list-for-search-to-client/${newLeadId}`
                        );
                      }}
                    />
                  )}
                </div>
                <div className="border-t border-[#EEE] p-3 flex items-center justify-between gap-2 flex-shrink-0">
                  <button
                    onClick={() => {
                      const items =
                        activeTab === "filing"
                          ? FILING_ITEMS
                          : activeTab === "status"
                            ? STATUS_ITEMS
                            : menuItems;
                      const activeId =
                        activeTab === "filing"
                          ? activeFilingId
                          : activeTab === "status"
                            ? activeStatusId
                            : activeMenuItem;
                      const idx = items.findIndex((m) => m.id === activeId);
                      if (idx > 0) {
                        navigateToStep(activeTab, items[idx - 1].id, leadId ?? null);
                      }
                    }}
                    className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                  >
                    Back
                  </button>
                  <div className="flex items-center gap-5">
                    <button
                      type="button"
                      onClick={() => navigate("/dashboard/applications")}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Close
                    </button>
                    {showProgressButton && (
                      <button
                        type="button"
                        onClick={handleProgress}
                        disabled={!leadId || progressing}
                        className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7] disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        {progressing ? "Skipping…" : "Progress"}
                      </button>
                    )}
                    <button
                      className="px-4 py-2 h-9 min-w-[128px] text-[12px] font-semibold text-white rounded-[6px] bg-[#222] hover:bg-[#333] disabled:opacity-60 disabled:cursor-not-allowed"
                      disabled={
                        stepSaving ||
                        (activeMenuItem === "checklist" && checklistSending) ||
                        (activeTab === "filing" && activeFilingId === "f1" && docChecklistSending)
                      }
                      type={
                        activeTab === "status" &&
                        activeStatusId === "s1" &&
                        (fcPassFooterNeedsSend ||
                          fcPassFooterNeedsSave ||
                          fcFailNoticeFooterNeedsSend ||
                          fcFailInformFooterNeedsSend ||
                          fcFailInvoiceFooterNeedsSend ||
                          fcFailInformDoneFooterNeedsSend ||
                          fcFailStatusFooterNeedsSubmit ||
                          fcFailNoticeFooterNeedsSave ||
                          fcFailInformFooterNeedsSave ||
                          fcFailInvoiceFooterNeedsSave ||
                          fcFailInformDoneFooterNeedsSave ||
                          fcFailCallClientFooterNeedsSubmit ||
                          fcFailConfirmationFooterNeedsSubmit ||
                          fcFailDocumentsFooterNeedsSubmit ||
                          fcFailFilingOfReplyFooterNeedsSubmit)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s2" &&
                              (markedForExamAcceptedFooterNeedsSend ||
                                markedForExamAAOFooterNeedsSend)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportNoticeFooterNeedsSend ||
                                examReportNoticeFooterNeedsSave ||
                                examReportInformFooterNeedsSend ||
                                examReportInformFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportSoaFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportSooFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportNtcoFooterNeedsSend ||
                                examReportNtcoFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportIncoFooterNeedsSend ||
                                examReportIncoFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportCcroFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportCcoFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportInvFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportPayFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportDocFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportFroFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportIcrFooterNeedsSend ||
                                examReportIcrFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportAaoStatusFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportAaoNoticeFooterNeedsSend ||
                                examReportAaoNoticeFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportAaoInformFooterNeedsSend ||
                                examReportAaoInformFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoInformFooterNeedsSend ||
                                examReportHaoInformFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoStatusFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoNoticeFooterNeedsSend ||
                                examReportHaoNoticeFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoInformHearingFooterNeedsSend ||
                                examReportHaoInformHearingFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoCallClientFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoConfirmationFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoRevisedInvoiceFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoInvoiceFooterNeedsSubmit
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoTmMInvoiceFooterNeedsSubmit ||
                                examReportHaoTmMInvoiceFooterNeedsSkip ||
                                examReportHaoTmMPaymentFooterNeedsSubmit ||
                                examReportHaoTmMPaymentFooterNeedsSkip ||
                                examReportHaoTmMFileFooterNeedsSubmit ||
                                examReportHaoTmMInformFooterNeedsSend ||
                                examReportHaoTmMInformFooterNeedsSave ||
                                examReportHaoPaymentFooterNeedsSubmit ||
                                examReportHaoStampVendorFooterNeedsSend ||
                                examReportHaoStampVendorFooterNeedsSave ||
                                examReportHaoStampVendorFooterNeedsSkip)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoStampFromVendorFooterNeedsSubmit ||
                                examReportHaoStampFromVendorFooterNeedsSkip ||
                                examReportHaoDocsFromClientFooterNeedsSubmit ||
                                examReportHaoUserAffidavitFooterNeedsSubmit ||
                                examReportHaoUserAffidavitFooterNeedsSkip ||
                                examReportHaoSignatureFooterNeedsSubmit ||
                                examReportHaoNotarisationFooterNeedsSubmit ||
                                examReportHaoNotarisationFooterNeedsSkip ||
                                examReportHaoScanningFooterNeedsSubmit ||
                                examReportHaoFileHearingDocFooterNeedsSubmit)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoNoteOnHearingFooterNeedsSubmit ||
                                examReportHaoAttendHearingFooterNeedsSubmit ||
                                examReportHaoHearingNotHappenedFooterNeedsSend ||
                                examReportHaoHearingNotHappenedFooterNeedsSave ||
                                examReportHaoHearingNotHappenedFooterNeedsSkip ||
                                examReportHaoInformAfterHearingFooterNeedsSend ||
                                examReportHaoInformAfterHearingFooterNeedsSave ||
                                examReportHaoUploadDocsAfterHearingFooterNeedsSubmit ||
                                examReportHaoTmMAfterInvoiceFooterNeedsSubmit ||
                                examReportHaoTmMAfterInvoiceFooterNeedsSkip ||
                                examReportHaoTmMAfterPaymentFooterNeedsSubmit ||
                                examReportHaoTmMAfterPaymentFooterNeedsSkip)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoFileTmMAfterHearingFooterNeedsSubmit ||
                                examReportHaoFileTmMAfterHearingFooterNeedsSkip ||
                                examReportHaoInformTmMAfterHearingFooterNeedsSend ||
                                examReportHaoInformTmMAfterHearingFooterNeedsSave ||
                                examReportHaoInformTmMAfterHearingFooterNeedsSkip ||
                                examReportHaoSubsequentHearingsFooterNeedsSend ||
                                examReportHaoSubsequentHearingsFooterNeedsSave ||
                                examReportHaoSubsequentHearingsFooterNeedsSkip ||
                                examReportHaoSubsequentInvoiceFooterNeedsSkip ||
                                examReportHaoSubsequentInvoiceFooterNeedsSubmit ||
                                examReportHaoSubsequentPaymentFooterNeedsSubmit ||
                                examReportHaoSubsequentPaymentFooterNeedsSkip ||
                                examReportHaoSubsequentAttendFooterNeedsSubmit ||
                                examReportHaoSubsequentAttendFooterNeedsSkip ||
                                examReportHaoSubsequentPostponementFooterNeedsSubmit ||
                                examReportHaoOrderOfHearingFooterNeedsSend ||
                                examReportHaoOrderOfHearingFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (advJournalStatusDetailsFooterNeedsSubmit ||
                                advJournalNoticeFooterNeedsSend ||
                                advJournalNoticeFooterNeedsSave ||
                                advJournalInformFooterNeedsSend ||
                                advJournalInformFooterNeedsSave ||
                                oppositionCounterStatusFooterNeedsSubmit ||
                                oppositionCounterNoticeFooterNeedsSend ||
                                oppositionCounterNoticeFooterNeedsSave ||
                                oppositionCounterInformFooterNeedsSend ||
                                oppositionCounterInformFooterNeedsSave ||
                                oppositionCounterCallFooterNeedsSubmit ||
                                counterConfirmationFooterNeedsSubmit ||
                                counterInvoiceFooterNeedsSend ||
                                counterInvoiceFooterNeedsSave ||
                                counterPaymentFooterNeedsSubmit ||
                                counterPrepareFooterNeedsSubmit ||
                                counterFileFooterNeedsSubmit ||
                                counterInformFilingFooterNeedsSend ||
                                counterInformFilingFooterNeedsSave ||
                                counterNoticeOfCounterFooterNeedsSubmit ||
                                counterInformNoticeFooterNeedsSend ||
                                counterInformNoticeFooterNeedsSave ||
                                counterEvidenceByOpponentFooterNeedsSubmit ||
                                counterNoticeEvidenceByOppFooterNeedsSend ||
                                counterNoticeEvidenceByOppFooterNeedsSave ||
                                counterInformEvidenceByOppFooterNeedsSend ||
                                counterInformEvidenceByOppFooterNeedsSave ||
                                counterCallClientEvidenceFooterNeedsSubmit ||
                                counterEvidenceConfirmationFooterNeedsSubmit ||
                                counterEvidenceInvoiceFooterNeedsSend ||
                                counterEvidenceInvoiceFooterNeedsSave ||
                                counterEvidencePaymentFooterNeedsSubmit ||
                                counterStampVendorEvidenceFooterNeedsSend ||
                                counterStampVendorEvidenceFooterNeedsSave ||
                                counterStampFromVendorEvidenceFooterNeedsSubmit ||
                                counterDocumentsFromClientEvidenceFooterNeedsSubmit ||
                                counterPreparationEvidenceAffidavitFooterNeedsSubmit ||
                                counterSignatureAffidavitFooterNeedsSubmit ||
                                counterNotarisationEvidenceFooterNeedsSubmit ||
                                counterScanningEvidenceFooterNeedsSubmit ||
                                counterFileEvidenceAffidavitFooterNeedsSubmit ||
                                counterInformFilingEvidenceFooterNeedsSend ||
                                counterInformFilingEvidenceFooterNeedsSave ||
                                counterDownloadRejoinderFooterNeedsSubmit ||
                                counterOppositionHearingStatusFooterNeedsSubmit ||
                                counterOppositionHearingNoticeFooterNeedsSend ||
                                counterOppositionHearingNoticeFooterNeedsSave ||
                                counterOppositionHearingInformFooterNeedsSend ||
                                counterOppositionHearingInformFooterNeedsSave ||
                                counterOppositionHearingInvoiceFooterNeedsSend ||
                                counterOppositionHearingInvoiceFooterNeedsSave ||
                                counterOppositionHearingCallFooterNeedsSubmit ||
                                counterOppositionHearingConfirmationFooterNeedsSubmit ||
                                counterTmMBeforeHearingInvoiceFooterNeedsSend ||
                                counterTmMBeforeHearingInvoiceFooterNeedsSave ||
                                counterTmMBeforeHearingPaymentFooterNeedsSubmit ||
                                counterTmMBeforeHearingFiledFooterNeedsSubmit ||
                                counterTmMBeforeHearingInformFooterNeedsSend ||
                                counterTmMBeforeHearingInformFooterNeedsSave ||
                                counterOppositionHearingPaymentFooterNeedsSubmit ||
                                counterDocumentsOppHearingFooterNeedsSubmit ||
                                counterFilingOppHearingDocFooterNeedsSubmit ||
                                counterNoteOnOppHearingFooterNeedsSubmit ||
                                counterAttendOppHearingFooterNeedsSubmit ||
                                counterInformAfterOppHearingFooterNeedsSend ||
                                counterInformAfterOppHearingFooterNeedsSave ||
                                counterInvoiceTmMAfterOppHearingFooterNeedsSend ||
                                counterInvoiceTmMAfterOppHearingFooterNeedsSave ||
                                counterPaymentTmMAfterOppHearingFooterNeedsSubmit ||
                                counterFileTmMAfterOppHearingFooterNeedsSubmit ||
                                counterInformTmMAfterOppHearingFooterNeedsSend ||
                                counterInformTmMAfterOppHearingFooterNeedsSave ||
                                counterSubsequentOppHearingsFooterNeedsSubmit ||
                                counterSubsequentOppHearingInvoiceFooterNeedsSubmit ||
                                counterSubsequentOppHearingPaymentFooterNeedsSubmit ||
                                counterOrderOfOppHearingFooterNeedsSend ||
                                counterOrderOfOppHearingFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              (finalOrderRegStatusFooterNeedsSubmit ||
                                finalOrderRegNoticeFooterNeedsSend ||
                                finalOrderRegNoticeFooterNeedsSave ||
                                finalOrderRegInformFooterNeedsSend ||
                                finalOrderRegInformFooterNeedsSave ||
                                finalOrderRefStatusFooterNeedsSubmit ||
                                finalOrderRefNoticeFooterNeedsSend ||
                                finalOrderRefNoticeFooterNeedsSave ||
                                finalOrderRefInformFooterNeedsSend ||
                                finalOrderRefInformFooterNeedsSave)
                          ? "submit"
                          : activeTab === "status"
                          ? "button"
                          : activeTab === "filing"
                          ? FILING_FORM_IDS[activeFilingId]
                            ? "submit"
                            : "button"
                          : activeMenuItem === "preliminary"
                            ? "submit"
                            : activeMenuItem === "details"
                            ? "submit"
                            : activeMenuItem === "invoice-advance"
                              ? "submit"
                              : activeMenuItem === "advance-amount"
                                ? "submit"
                                : activeMenuItem === "class-list"
                                  ? "submit"
                                  : activeMenuItem === "search-report"
                                    ? "submit"
                                    : activeMenuItem === "legal-advice"
                                      ? "submit"
                                      : activeMenuItem === "proposal"
                                        ? "submit"
                                        : activeMenuItem === "confirmation"
                                          ? "submit"
                                          : activeMenuItem === "invoice-final"
                                            ? "submit"
                                            : activeMenuItem === "payment"
                                              ? "submit"
                                              : "button"
                      }
                      form={
                        activeTab === "status" &&
                        activeStatusId === "s1" &&
                        (fcPassFooterNeedsSend || fcPassFooterNeedsSave)
                          ? "formalities-check-fc-pass-form"
                          : activeTab === "status" &&
                              activeStatusId === "s1" &&
                              (fcFailNoticeFooterNeedsSend ||
                                fcFailNoticeFooterNeedsSave)
                            ? "formalities-check-fc-fail-notice-form"
                            : activeTab === "status" &&
                                activeStatusId === "s1" &&
                                (fcFailInformFooterNeedsSend ||
                                  fcFailInformFooterNeedsSave)
                              ? "formalities-check-fc-fail-inform-client-form"
                              : activeTab === "status" &&
                                  activeStatusId === "s1" &&
                                  (fcFailInvoiceFooterNeedsSend ||
                                    fcFailInvoiceFooterNeedsSave)
                                ? "formalities-check-fc-fail-invoice-form"
                                : activeTab === "status" &&
                                    activeStatusId === "s1" &&
                                    (fcFailInformDoneFooterNeedsSend ||
                                      fcFailInformDoneFooterNeedsSave)
                                  ? "formalities-check-fc-fail-inform-done-form"
                                  : activeTab === "status" &&
                                      activeStatusId === "s1" &&
                                      fcFailStatusFooterNeedsSubmit
                                    ? "formalities-check-fc-fail-status-form"
                                    : activeTab === "status" &&
                                        activeStatusId === "s1" &&
                                        fcFailCallClientFooterNeedsSubmit
                                      ? "formalities-check-fc-fail-call-client-form"
                                      : activeTab === "status" &&
                                          activeStatusId === "s1" &&
                                          fcFailConfirmationFooterNeedsSubmit
                                        ? "formalities-check-fc-fail-client-confirmation-form"
                                        : activeTab === "status" &&
                                            activeStatusId === "s1" &&
                                            fcFailDocumentsFooterNeedsSubmit
                                          ? "formalities-check-fc-fail-documents-form"
                                          : activeTab === "status" &&
                                              activeStatusId === "s1" &&
                                              fcFailFilingOfReplyFooterNeedsSubmit
                                            ? "formalities-check-fc-fail-filing-of-reply-form"
                          : activeTab === "status" &&
                              activeStatusId === "s2" &&
                              markedForExamAcceptedFooterNeedsSend
                          ? MARKED_FOR_EXAM_ACCEPTED_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s2" &&
                              markedForExamAAOFooterNeedsSend
                          ? MARKED_FOR_EXAM_AAO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportNoticeFooterNeedsSend ||
                                examReportNoticeFooterNeedsSave)
                          ? EXAMINATION_REPORT_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportInformFooterNeedsSend ||
                                examReportInformFooterNeedsSave)
                          ? EXAMINATION_REPORT_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportSoaFooterNeedsSubmit
                          ? EXAMINATION_REPORT_SOA_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportSooFooterNeedsSubmit
                          ? EXAMINATION_REPORT_SOO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportNtcoFooterNeedsSend ||
                                examReportNtcoFooterNeedsSave)
                          ? EXAMINATION_REPORT_NTCO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportIncoFooterNeedsSend ||
                                examReportIncoFooterNeedsSave)
                          ? EXAMINATION_REPORT_INCO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportCcroFooterNeedsSubmit
                          ? EXAMINATION_REPORT_CCRO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportCcoFooterNeedsSubmit
                          ? EXAMINATION_REPORT_CCO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportInvFooterNeedsSubmit
                          ? EXAMINATION_REPORT_INV_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportPayFooterNeedsSubmit
                          ? EXAMINATION_REPORT_PAY_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportDocFooterNeedsSubmit
                          ? EXAMINATION_REPORT_DOC_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportFroFooterNeedsSubmit
                          ? EXAMINATION_REPORT_FRO_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportIcrFooterNeedsSend ||
                                examReportIcrFooterNeedsSave)
                          ? EXAMINATION_REPORT_ICR_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportAaoStatusFooterNeedsSubmit
                          ? EXAMINATION_REPORT_AAO_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportAaoNoticeFooterNeedsSend ||
                                examReportAaoNoticeFooterNeedsSave)
                          ? EXAMINATION_REPORT_AAO_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportAaoInformFooterNeedsSend ||
                                examReportAaoInformFooterNeedsSave)
                          ? EXAMINATION_REPORT_AAO_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoInformFooterNeedsSend ||
                                examReportHaoInformFooterNeedsSave)
                          ? EXAMINATION_REPORT_HAO_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoStatusFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoNoticeFooterNeedsSend ||
                                examReportHaoNoticeFooterNeedsSave)
                          ? EXAMINATION_REPORT_HAO_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoInformHearingFooterNeedsSend ||
                                examReportHaoInformHearingFooterNeedsSave)
                          ? EXAMINATION_REPORT_HAO_INFORM_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoCallClientFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_CALL_CLIENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoConfirmationFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_CONFIRMATION_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoRevisedInvoiceFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_REVISED_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoInvoiceFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoTmMInvoiceFooterNeedsSubmit ||
                                examReportHaoTmMInvoiceFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_TMM_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoTmMPaymentFooterNeedsSubmit ||
                                examReportHaoTmMPaymentFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_TMM_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoTmMFileFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_TMM_FILE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoTmMInformFooterNeedsSend ||
                                examReportHaoTmMInformFooterNeedsSave)
                          ? EXAMINATION_REPORT_HAO_TMM_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoPaymentFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoStampVendorFooterNeedsSend ||
                                examReportHaoStampVendorFooterNeedsSave ||
                                examReportHaoStampVendorFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_STAMP_VENDOR_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoStampFromVendorFooterNeedsSubmit ||
                                examReportHaoStampFromVendorFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_STAMP_FROM_VENDOR_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoDocsFromClientFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_DOCS_FROM_CLIENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoUserAffidavitFooterNeedsSubmit ||
                                examReportHaoUserAffidavitFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_USER_AFFIDAVIT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoSignatureFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_SIGNATURE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoNotarisationFooterNeedsSubmit ||
                                examReportHaoNotarisationFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_NOTARISATION_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoScanningFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_SCANNING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoFileHearingDocFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_FILE_HEARING_DOC_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoNoteOnHearingFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_NOTE_ON_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoAttendHearingFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_ATTEND_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoHearingNotHappenedFooterNeedsSend ||
                                examReportHaoHearingNotHappenedFooterNeedsSave ||
                                examReportHaoHearingNotHappenedFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_HEARING_NOT_HAPPENED_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoInformAfterHearingFooterNeedsSend ||
                                examReportHaoInformAfterHearingFooterNeedsSave)
                          ? EXAMINATION_REPORT_HAO_INFORM_AFTER_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoUploadDocsAfterHearingFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_UPLOAD_DOCS_AFTER_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoTmMAfterInvoiceFooterNeedsSubmit ||
                                examReportHaoTmMAfterInvoiceFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_TMM_AFTER_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoTmMAfterPaymentFooterNeedsSubmit ||
                                examReportHaoTmMAfterPaymentFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_TMM_AFTER_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoFileTmMAfterHearingFooterNeedsSubmit ||
                                examReportHaoFileTmMAfterHearingFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_FILE_TMM_AFTER_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoInformTmMAfterHearingFooterNeedsSend ||
                                examReportHaoInformTmMAfterHearingFooterNeedsSave ||
                                examReportHaoInformTmMAfterHearingFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_INFORM_TMM_AFTER_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoSubsequentHearingsFooterNeedsSend ||
                                examReportHaoSubsequentHearingsFooterNeedsSave ||
                                examReportHaoSubsequentHearingsFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_SUBSEQUENT_HEARINGS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoSubsequentInvoiceFooterNeedsSkip ||
                                examReportHaoSubsequentInvoiceFooterNeedsSubmit)
                          ? EXAMINATION_REPORT_HAO_SUBSEQUENT_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoSubsequentPaymentFooterNeedsSubmit ||
                                examReportHaoSubsequentPaymentFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_SUBSEQUENT_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoSubsequentAttendFooterNeedsSubmit ||
                                examReportHaoSubsequentAttendFooterNeedsSkip)
                          ? EXAMINATION_REPORT_HAO_SUBSEQUENT_ATTEND_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              examReportHaoSubsequentPostponementFooterNeedsSubmit
                          ? EXAMINATION_REPORT_HAO_SUBSEQUENT_POSTPONEMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s3" &&
                              (examReportHaoOrderOfHearingFooterNeedsSend ||
                                examReportHaoOrderOfHearingFooterNeedsSave)
                          ? EXAMINATION_REPORT_HAO_ORDER_OF_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              advJournalStatusDetailsFooterNeedsSubmit
                          ? ADVERTISED_IN_JOURNAL_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (advJournalNoticeFooterNeedsSend ||
                                advJournalNoticeFooterNeedsSave)
                          ? ADVERTISED_IN_JOURNAL_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (advJournalInformFooterNeedsSend ||
                                advJournalInformFooterNeedsSave)
                          ? ADVERTISED_IN_JOURNAL_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              oppositionCounterStatusFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (oppositionCounterNoticeFooterNeedsSend ||
                                oppositionCounterNoticeFooterNeedsSave)
                          ? OPPOSITION_COUNTER_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (oppositionCounterInformFooterNeedsSend ||
                                oppositionCounterInformFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              oppositionCounterCallFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_CALL_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterConfirmationFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_CONFIRMATION_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInvoiceFooterNeedsSend ||
                                counterInvoiceFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterPaymentFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterPrepareFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_PREPARE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterFileFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_FILE_COUNTER_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInformFilingFooterNeedsSend ||
                                counterInformFilingFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_FILING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterNoticeOfCounterFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_NOTICE_OF_COUNTER_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInformNoticeFooterNeedsSend ||
                                counterInformNoticeFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterEvidenceByOpponentFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_EVIDENCE_BY_OPPONENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterNoticeEvidenceByOppFooterNeedsSend ||
                                counterNoticeEvidenceByOppFooterNeedsSave)
                          ? OPPOSITION_COUNTER_NOTICE_EVIDENCE_BY_OPP_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInformEvidenceByOppFooterNeedsSend ||
                                counterInformEvidenceByOppFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_EVIDENCE_BY_OPP_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterCallClientEvidenceFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_CALL_CLIENT_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterEvidenceConfirmationFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_EVIDENCE_CONFIRMATION_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterEvidenceInvoiceFooterNeedsSend ||
                                counterEvidenceInvoiceFooterNeedsSave)
                          ? OPPOSITION_COUNTER_EVIDENCE_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterEvidencePaymentFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_EVIDENCE_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterStampVendorEvidenceFooterNeedsSend ||
                                counterStampVendorEvidenceFooterNeedsSave)
                          ? OPPOSITION_COUNTER_STAMP_VENDOR_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterStampFromVendorEvidenceFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_STAMP_FROM_VENDOR_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterDocumentsFromClientEvidenceFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_DOCUMENTS_FROM_CLIENT_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterPreparationEvidenceAffidavitFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_PREPARATION_EVIDENCE_AFFIDAVIT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterSignatureAffidavitFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_SIGNATURE_AFFIDAVIT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterNotarisationEvidenceFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_NOTARISATION_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterScanningEvidenceFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_SCANNING_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterFileEvidenceAffidavitFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_FILE_EVIDENCE_AFFIDAVIT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInformFilingEvidenceFooterNeedsSend ||
                                counterInformFilingEvidenceFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_FILING_EVIDENCE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterDownloadRejoinderFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_DOWNLOAD_REJOINDER_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterOppositionHearingStatusFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterOppositionHearingNoticeFooterNeedsSend ||
                                counterOppositionHearingNoticeFooterNeedsSave)
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterOppositionHearingInformFooterNeedsSend ||
                                counterOppositionHearingInformFooterNeedsSave)
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterOppositionHearingInvoiceFooterNeedsSend ||
                                counterOppositionHearingInvoiceFooterNeedsSave)
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterOppositionHearingCallFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_CALL_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterOppositionHearingConfirmationFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_CONFIRMATION_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterTmMBeforeHearingInvoiceFooterNeedsSend ||
                                counterTmMBeforeHearingInvoiceFooterNeedsSave)
                          ? OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterTmMBeforeHearingPaymentFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterTmMBeforeHearingFiledFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_FILED_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterTmMBeforeHearingInformFooterNeedsSend ||
                                counterTmMBeforeHearingInformFooterNeedsSave)
                          ? OPPOSITION_COUNTER_TM_M_BEFORE_HEARING_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterOppositionHearingPaymentFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_OPPOSITION_HEARING_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterDocumentsOppHearingFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_DOCUMENTS_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterFilingOppHearingDocFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_FILING_OPP_HEARING_DOC_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterNoteOnOppHearingFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_NOTE_ON_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterAttendOppHearingFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_ATTEND_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInformAfterOppHearingFooterNeedsSend ||
                                counterInformAfterOppHearingFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_AFTER_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInvoiceTmMAfterOppHearingFooterNeedsSend ||
                                counterInvoiceTmMAfterOppHearingFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INVOICE_TMM_AFTER_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterPaymentTmMAfterOppHearingFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_PAYMENT_TMM_AFTER_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterFileTmMAfterOppHearingFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_FILE_TMM_AFTER_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterInformTmMAfterOppHearingFooterNeedsSend ||
                                counterInformTmMAfterOppHearingFooterNeedsSave)
                          ? OPPOSITION_COUNTER_INFORM_TMM_AFTER_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterSubsequentOppHearingsFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_SUBSEQUENT_OPP_HEARINGS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterSubsequentOppHearingInvoiceFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_SUBSEQUENT_OPP_HEARING_INVOICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              counterSubsequentOppHearingPaymentFooterNeedsSubmit
                          ? OPPOSITION_COUNTER_SUBSEQUENT_OPP_HEARING_PAYMENT_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s5" &&
                              (counterOrderOfOppHearingFooterNeedsSend ||
                                counterOrderOfOppHearingFooterNeedsSave)
                          ? OPPOSITION_COUNTER_ORDER_OF_OPP_HEARING_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              finalOrderRegStatusFooterNeedsSubmit
                          ? FINAL_ORDER_REGISTERED_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              (finalOrderRegNoticeFooterNeedsSend ||
                                finalOrderRegNoticeFooterNeedsSave)
                          ? FINAL_ORDER_REGISTERED_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              (finalOrderRegInformFooterNeedsSend ||
                                finalOrderRegInformFooterNeedsSave)
                          ? FINAL_ORDER_REGISTERED_INFORM_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              finalOrderRefStatusFooterNeedsSubmit
                          ? FINAL_ORDER_REFUSED_STATUS_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              (finalOrderRefNoticeFooterNeedsSend ||
                                finalOrderRefNoticeFooterNeedsSave)
                          ? FINAL_ORDER_REFUSED_NOTICE_FORM_ID
                          : activeTab === "status" &&
                              activeStatusId === "s6" &&
                              (finalOrderRefInformFooterNeedsSend ||
                                finalOrderRefInformFooterNeedsSave)
                          ? FINAL_ORDER_REFUSED_INFORM_FORM_ID
                          : activeTab === "filing"
                          ? FILING_FORM_IDS[activeFilingId]
                          : activeMenuItem === "preliminary"
                          ? "preliminary-form"
                          : activeMenuItem === "details"
                            ? "details-search-form"
                            : activeMenuItem === "invoice-advance"
                              ? "invoice-advance-form"
                              : activeMenuItem === "advance-amount"
                                ? "advance-amount-form"
                                : activeMenuItem === "class-list"
                                  ? "class-list-form"
                                  : activeMenuItem === "search-report"
                                    ? "search-report-form"
                                    : activeMenuItem === "legal-advice"
                                      ? "legal-advice-form"
                                      : activeMenuItem === "proposal"
                                        ? "proposal-form"
                                        : activeMenuItem === "confirmation"
                                          ? "confirmation-form"
                                          : activeMenuItem === "invoice-final"
                                            ? "invoice-final-form"
                                            : activeMenuItem === "payment"
                                              ? "payment-form"
                                              : undefined
                      }
                      onClick={
                        (() => {
                          const formId =
                            activeTab === "filing"
                              ? FILING_FORM_IDS[activeFilingId]
                              : undefined;
                          if (formId) {
                            return (e: React.MouseEvent<HTMLButtonElement>) => {
                              e.preventDefault();
                              const form = document.getElementById(formId);
                              if (form instanceof HTMLFormElement) {
                                form.requestSubmit();
                              } else {
                                // Form not in DOM (e.g. "Not Required" state) – navigate to next step
                                const items =
                                  activeTab === "filing" ? FILING_ITEMS : menuItems;
                                const activeId =
                                  activeTab === "filing"
                                    ? activeFilingId
                                    : activeMenuItem;
                                const idx = items.findIndex((m) => m.id === activeId);
                                if (idx >= 0 && idx < items.length - 1) {
                                  navigateToStep(
                                    activeTab,
                                    items[idx + 1].id,
                                    leadId ?? null
                                  );
                                } else if (
                                  activeTab === "filing" &&
                                  activeFilingId === "f17"
                                ) {
                                  // Last filing step; expedited payment UI hidden when flow skipped
                                  navigateToStep("status", "s1", leadId ?? null);
                                }
                              }
                            };
                          }
                          if (
                            activeMenuItem === "checklist" &&
                            leadId
                          ) {
                            return async () => {
                              // First send: show the message preview + confirmation before sending.
                              if (!hasSentChecklistWhatsApp) {
                                setShowSearchChecklistSendModal(true);
                                return;
                              }
                              // Already sent: Save & Continue just advances; re-sending is
                              // explicit via the "Resend to WhatsApp" button.
                              const idx = menuItems.findIndex((m) => m.id === "checklist");
                              if (idx >= 0 && idx < menuItems.length - 1) {
                                navigateToStep(
                                  "discussion",
                                  menuItems[idx + 1].id,
                                  leadId
                                );
                              }
                            };
                          }
                          if (
                            activeTab === "filing" &&
                            activeFilingId === "f1" &&
                            leadId
                          ) {
                            return () => {
                              if (!hasSentDocChecklistWhatsapp) {
                                setShowF1ConfirmModal(true);
                                return;
                              }
                              const idx = FILING_ITEMS.findIndex((m) => m.id === "f1");
                              if (idx >= 0 && idx < FILING_ITEMS.length - 1) {
                                navigateToStep("filing", FILING_ITEMS[idx + 1].id, leadId);
                              }
                            };
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s1" &&
                            (fcPassFooterNeedsSend ||
                              fcPassFooterNeedsSave ||
                              fcFailNoticeFooterNeedsSend ||
                              fcFailInformFooterNeedsSend ||
                              fcFailInvoiceFooterNeedsSend ||
                              fcFailInformDoneFooterNeedsSend ||
                              fcFailStatusFooterNeedsSubmit ||
                              fcFailNoticeFooterNeedsSave ||
                              fcFailInformFooterNeedsSave ||
                              fcFailInvoiceFooterNeedsSave ||
                              fcFailInformDoneFooterNeedsSave ||
                              fcFailCallClientFooterNeedsSubmit ||
                              fcFailConfirmationFooterNeedsSubmit ||
                              fcFailDocumentsFooterNeedsSubmit ||
                              fcFailFilingOfReplyFooterNeedsSubmit)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s2" &&
                            (markedForExamAcceptedFooterNeedsSend ||
                              markedForExamAAOFooterNeedsSend)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportNoticeFooterNeedsSend ||
                              examReportNoticeFooterNeedsSave ||
                              examReportInformFooterNeedsSend ||
                              examReportInformFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportSoaFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportSooFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportNtcoFooterNeedsSend ||
                              examReportNtcoFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportIncoFooterNeedsSend ||
                              examReportIncoFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportCcroFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportCcoFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportInvFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportPayFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportDocFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportFroFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportIcrFooterNeedsSend ||
                              examReportIcrFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            examReportAaoStatusFooterNeedsSubmit
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportAaoNoticeFooterNeedsSend ||
                              examReportAaoNoticeFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportAaoInformFooterNeedsSend ||
                              examReportAaoInformFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportHaoInformFooterNeedsSend ||
                              examReportHaoInformFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s3" &&
                            (examReportHaoStatusFooterNeedsSubmit ||
                              examReportHaoNoticeFooterNeedsSend ||
                              examReportHaoNoticeFooterNeedsSave ||
                              examReportHaoInformHearingFooterNeedsSend ||
                              examReportHaoInformHearingFooterNeedsSave ||
                              examReportHaoCallClientFooterNeedsSubmit ||
                              examReportHaoConfirmationFooterNeedsSubmit ||
                              examReportHaoRevisedInvoiceFooterNeedsSubmit ||
                              examReportHaoInvoiceFooterNeedsSubmit ||
                              examReportHaoTmMInvoiceFooterNeedsSubmit ||
                              examReportHaoTmMInvoiceFooterNeedsSkip ||
                              examReportHaoTmMPaymentFooterNeedsSubmit ||
                              examReportHaoTmMPaymentFooterNeedsSkip ||
                              examReportHaoTmMFileFooterNeedsSubmit ||
                              examReportHaoTmMInformFooterNeedsSend ||
                              examReportHaoTmMInformFooterNeedsSave ||
                              examReportHaoPaymentFooterNeedsSubmit ||
                              examReportHaoStampVendorFooterNeedsSend ||
                              examReportHaoStampVendorFooterNeedsSave ||
                              examReportHaoStampVendorFooterNeedsSkip ||
                              examReportHaoStampFromVendorFooterNeedsSubmit ||
                              examReportHaoStampFromVendorFooterNeedsSkip ||
                              examReportHaoDocsFromClientFooterNeedsSubmit ||
                              examReportHaoUserAffidavitFooterNeedsSubmit ||
                              examReportHaoUserAffidavitFooterNeedsSkip ||
                              examReportHaoSignatureFooterNeedsSubmit ||
                              examReportHaoNotarisationFooterNeedsSubmit ||
                              examReportHaoNotarisationFooterNeedsSkip ||
                              examReportHaoScanningFooterNeedsSubmit ||
                              examReportHaoFileHearingDocFooterNeedsSubmit ||
                              examReportHaoNoteOnHearingFooterNeedsSubmit ||
                              examReportHaoAttendHearingFooterNeedsSubmit ||
                              examReportHaoHearingNotHappenedFooterNeedsSend ||
                              examReportHaoHearingNotHappenedFooterNeedsSave ||
                              examReportHaoInformAfterHearingFooterNeedsSend ||
                              examReportHaoInformAfterHearingFooterNeedsSave ||
                              examReportHaoUploadDocsAfterHearingFooterNeedsSubmit ||
                              examReportHaoTmMAfterInvoiceFooterNeedsSubmit ||
                              examReportHaoTmMAfterInvoiceFooterNeedsSkip ||
                              examReportHaoTmMAfterPaymentFooterNeedsSubmit ||
                              examReportHaoTmMAfterPaymentFooterNeedsSkip ||
                              examReportHaoFileTmMAfterHearingFooterNeedsSubmit ||
                              examReportHaoFileTmMAfterHearingFooterNeedsSkip ||
                              examReportHaoInformTmMAfterHearingFooterNeedsSend ||
                              examReportHaoInformTmMAfterHearingFooterNeedsSave ||
                              examReportHaoInformTmMAfterHearingFooterNeedsSkip ||
                              examReportHaoSubsequentHearingsFooterNeedsSend ||
                              examReportHaoSubsequentHearingsFooterNeedsSave ||
                              examReportHaoSubsequentHearingsFooterNeedsSkip ||
                              examReportHaoSubsequentInvoiceFooterNeedsSkip ||
                              examReportHaoSubsequentInvoiceFooterNeedsSubmit ||
                              examReportHaoSubsequentPaymentFooterNeedsSubmit ||
                              examReportHaoSubsequentPaymentFooterNeedsSkip ||
                              examReportHaoSubsequentAttendFooterNeedsSubmit ||
                              examReportHaoSubsequentAttendFooterNeedsSkip ||
                              examReportHaoSubsequentPostponementFooterNeedsSubmit ||
                              examReportHaoOrderOfHearingFooterNeedsSend ||
                              examReportHaoOrderOfHearingFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s5" &&
                            (advJournalStatusDetailsFooterNeedsSubmit ||
                              advJournalNoticeFooterNeedsSend ||
                              advJournalNoticeFooterNeedsSave ||
                              advJournalInformFooterNeedsSend ||
                              advJournalInformFooterNeedsSave ||
                              oppositionCounterStatusFooterNeedsSubmit ||
                              oppositionCounterNoticeFooterNeedsSend ||
                              oppositionCounterNoticeFooterNeedsSave ||
                              oppositionCounterInformFooterNeedsSend ||
                              oppositionCounterInformFooterNeedsSave ||
                              oppositionCounterCallFooterNeedsSubmit ||
                              counterConfirmationFooterNeedsSubmit ||
                              counterInvoiceFooterNeedsSend ||
                              counterInvoiceFooterNeedsSave ||
                              counterPaymentFooterNeedsSubmit ||
                              counterPrepareFooterNeedsSubmit ||
                              counterFileFooterNeedsSubmit ||
                              counterInformFilingFooterNeedsSend ||
                              counterInformFilingFooterNeedsSave ||
                              counterNoticeOfCounterFooterNeedsSubmit ||
                              counterInformNoticeFooterNeedsSend ||
                              counterInformNoticeFooterNeedsSave ||
                              counterEvidenceByOpponentFooterNeedsSubmit ||
                              counterNoticeEvidenceByOppFooterNeedsSend ||
                              counterNoticeEvidenceByOppFooterNeedsSave ||
                              counterInformEvidenceByOppFooterNeedsSend ||
                              counterInformEvidenceByOppFooterNeedsSave ||
                              counterCallClientEvidenceFooterNeedsSubmit ||
                              counterEvidenceConfirmationFooterNeedsSubmit ||
                              counterEvidenceInvoiceFooterNeedsSend ||
                              counterEvidenceInvoiceFooterNeedsSave ||
                              counterEvidencePaymentFooterNeedsSubmit ||
                              counterStampVendorEvidenceFooterNeedsSend ||
                              counterStampVendorEvidenceFooterNeedsSave ||
                              counterStampFromVendorEvidenceFooterNeedsSubmit ||
                              counterDocumentsFromClientEvidenceFooterNeedsSubmit ||
                              counterPreparationEvidenceAffidavitFooterNeedsSubmit ||
                              counterSignatureAffidavitFooterNeedsSubmit ||
                              counterNotarisationEvidenceFooterNeedsSubmit ||
                              counterScanningEvidenceFooterNeedsSubmit ||
                              counterFileEvidenceAffidavitFooterNeedsSubmit ||
                              counterInformFilingEvidenceFooterNeedsSend ||
                              counterInformFilingEvidenceFooterNeedsSave ||
                              counterDownloadRejoinderFooterNeedsSubmit ||
                              counterOppositionHearingStatusFooterNeedsSubmit ||
                              counterOppositionHearingNoticeFooterNeedsSend ||
                              counterOppositionHearingNoticeFooterNeedsSave ||
                              counterOppositionHearingInformFooterNeedsSend ||
                              counterOppositionHearingInformFooterNeedsSave ||
                              counterOppositionHearingInvoiceFooterNeedsSend ||
                              counterOppositionHearingInvoiceFooterNeedsSave ||
                              counterOppositionHearingCallFooterNeedsSubmit ||
                              counterOppositionHearingConfirmationFooterNeedsSubmit ||
                              counterTmMBeforeHearingInvoiceFooterNeedsSend ||
                              counterTmMBeforeHearingInvoiceFooterNeedsSave ||
                              counterTmMBeforeHearingPaymentFooterNeedsSubmit ||
                              counterTmMBeforeHearingFiledFooterNeedsSubmit ||
                              counterTmMBeforeHearingInformFooterNeedsSend ||
                              counterTmMBeforeHearingInformFooterNeedsSave ||
                              counterOppositionHearingPaymentFooterNeedsSubmit ||
                              counterDocumentsOppHearingFooterNeedsSubmit ||
                              counterFilingOppHearingDocFooterNeedsSubmit ||
                              counterNoteOnOppHearingFooterNeedsSubmit ||
                              counterAttendOppHearingFooterNeedsSubmit ||
                              counterInformAfterOppHearingFooterNeedsSend ||
                              counterInformAfterOppHearingFooterNeedsSave ||
                              counterInvoiceTmMAfterOppHearingFooterNeedsSend ||
                              counterInvoiceTmMAfterOppHearingFooterNeedsSave ||
                              counterPaymentTmMAfterOppHearingFooterNeedsSubmit ||
                              counterFileTmMAfterOppHearingFooterNeedsSubmit ||
                              counterInformTmMAfterOppHearingFooterNeedsSend ||
                              counterInformTmMAfterOppHearingFooterNeedsSave ||
                              counterSubsequentOppHearingsFooterNeedsSubmit ||
                              counterSubsequentOppHearingInvoiceFooterNeedsSubmit ||
                              counterSubsequentOppHearingPaymentFooterNeedsSubmit ||
                              counterOrderOfOppHearingFooterNeedsSend ||
                              counterOrderOfOppHearingFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (
                            activeTab === "status" &&
                            activeStatusId === "s6" &&
                            (finalOrderRegStatusFooterNeedsSubmit ||
                              finalOrderRegNoticeFooterNeedsSend ||
                              finalOrderRegNoticeFooterNeedsSave ||
                              finalOrderRegInformFooterNeedsSend ||
                              finalOrderRegInformFooterNeedsSave ||
                              finalOrderRefStatusFooterNeedsSubmit ||
                              finalOrderRefNoticeFooterNeedsSend ||
                              finalOrderRefNoticeFooterNeedsSave ||
                              finalOrderRefInformFooterNeedsSend ||
                              finalOrderRefInformFooterNeedsSave)
                          ) {
                            return undefined;
                          }
                          if (activeTab === "status") {
                            return () => {
                              const idx = STATUS_ITEMS.findIndex((s) => s.id === activeStatusId);
                              if (idx >= 0 && idx < STATUS_ITEMS.length - 1) {
                                navigateToStep("status", STATUS_ITEMS[idx + 1].id, leadId ?? null);
                              }
                            };
                          }
                          const hasNavigateHandler =
                            (activeTab === "filing" && activeFilingId === "f1") ||
                            (activeMenuItem !== "preliminary" &&
                              activeMenuItem !== "details" &&
                              activeMenuItem !== "invoice-advance" &&
                              activeMenuItem !== "advance-amount" &&
                              activeMenuItem !== "class-list" &&
                              activeMenuItem !== "search-report" &&
                              activeMenuItem !== "legal-advice" &&
                              activeMenuItem !== "proposal" &&
                              activeMenuItem !== "confirmation" &&
                              activeMenuItem !== "invoice-final" &&
                              activeMenuItem !== "payment");
                          if (hasNavigateHandler) {
                            return () => {
                              const items =
                                activeTab === "filing" ? FILING_ITEMS : menuItems;
                              const activeId =
                                activeTab === "filing"
                                  ? activeFilingId
                                  : activeMenuItem;
                              const idx = items.findIndex((m) => m.id === activeId);
                              if (idx >= 0 && idx < items.length - 1) {
                                navigateToStep(
                                  activeTab,
                                  items[idx + 1].id,
                                  leadId ?? null
                                );
                              }
                            };
                          }
                          return undefined;
                        })()
                      }
                    >
                      {activeTab === "status" &&
                      activeStatusId === "s1" &&
                      (fcFailNoticeFooterNeedsSend ||
                        fcFailInformFooterNeedsSend ||
                        fcFailInvoiceFooterNeedsSend)
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s1" &&
                          (fcPassFooterNeedsSend || fcFailInformDoneFooterNeedsSend)
                        ? stepSaving
                          ? "Sending…"
                          : "Send"
                        : activeTab === "status" &&
                          activeStatusId === "s1" &&
                          (fcFailInformDoneFooterNeedsSave || fcPassFooterNeedsSave)
                        ? stepSaving
                          ? "Saving…"
                          : "Save"
                        : activeTab === "status" &&
                          activeStatusId === "s2" &&
                          (markedForExamAcceptedFooterNeedsSend ||
                            markedForExamAAOFooterNeedsSend)
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportInformFooterNeedsSave
                        ? stepSaving
                          ? "Saving…"
                          : "Save"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportNtcoFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportIncoFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportIcrFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportAaoNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportAaoInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoInformHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoTmMInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoStampVendorFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoHearingNotHappenedFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoTmMInvoiceFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoTmMPaymentFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoStampVendorFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoStampFromVendorFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoUserAffidavitFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoNotarisationFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoSubsequentHearingsFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoSubsequentInvoiceFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoSubsequentPaymentFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoSubsequentAttendFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoTmMAfterInvoiceFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoTmMAfterPaymentFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoFileTmMAfterHearingFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoInformTmMAfterHearingFooterNeedsSkip
                        ? stepSaving
                          ? "Skipping…"
                          : "Skip & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoHearingNotHappenedFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoInformAfterHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoInformTmMAfterHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoSubsequentHearingsFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoOrderOfHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoInvoiceFooterNeedsSubmit &&
                          !examReportHaoInvoiceSent
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoTmMInvoiceFooterNeedsSubmit &&
                          !examReportHaoTmMInvoiceSent
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s3" &&
                          examReportHaoSubsequentInvoiceFooterNeedsSubmit &&
                          !examReportHaoSubsequentInvoiceSent
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          advJournalNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          advJournalInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          oppositionCounterNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          oppositionCounterInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInvoiceFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInformFilingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInformNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterNoticeEvidenceByOppFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInformEvidenceByOppFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterEvidenceInvoiceFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterStampVendorEvidenceFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInformFilingEvidenceFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterOppositionHearingNoticeFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterOppositionHearingInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterOppositionHearingInvoiceFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterTmMBeforeHearingInvoiceFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterTmMBeforeHearingInformFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInformAfterOppHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInvoiceTmMAfterOppHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterInformTmMAfterOppHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s5" &&
                          counterOrderOfOppHearingFooterNeedsSend
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s6" &&
                          (finalOrderRegNoticeFooterNeedsSend ||
                            finalOrderRefNoticeFooterNeedsSend)
                        ? stepSaving
                          ? "Sending…"
                          : "Send & Continue"
                        : activeTab === "status" &&
                          activeStatusId === "s6" &&
                          (finalOrderRegInformFooterNeedsSend ||
                            finalOrderRefInformFooterNeedsSend)
                        ? stepSaving
                          ? "Sending…"
                          : "Send"
                        : activeTab === "status" &&
                          activeStatusId === "s6" &&
                          (finalOrderRegInformFooterNeedsSave ||
                            finalOrderRefInformFooterNeedsSave)
                        ? stepSaving
                          ? "Saving…"
                          : "Save"
                        : activeTab === "status"
                        ? "Save & Continue"
                        : stepSaving
                        ? "Saving…"
                        : activeMenuItem === "checklist" && checklistSending
                          ? "Sending…"
                          : activeTab === "filing" && activeFilingId === "f1" && docChecklistSending
                            ? "Sending…"
                            : activeTab === "filing" && activeFilingId === "f1"
                              ? hasSentDocChecklistWhatsapp
                                ? "Save & Continue"
                                : "Send & Continue"
                            : activeTab === "filing" && activeFilingId === "f2"
                              ? "Save & Continue"
                            : activeTab === "filing" && activeFilingId === "f3"
                              ? hasSentFilingDetailsWhatsapp
                                ? "Save & Continue"
                                : "Send & Continue"
                            : activeTab === "filing" && activeFilingId === "f4"
                              ? "Save & Continue"
                            : activeTab === "filing" && activeFilingId === "f5"
                              ? hasSentStampDetailsWhatsapp
                                ? "Save & Continue"
                                : "Send & Continue"
                            : activeMenuItem === "checklist"
                              ? hasSentChecklistWhatsApp
                                ? "Save & Continue"
                                : "Send & Continue"
                              : activeMenuItem === "invoice-advance"
                                ? hasSentInvoiceAdvanceWhatsapp
                                  ? "Save & Continue"
                                  : "Send & Continue"
                              : activeMenuItem === "class-list"
                                ? hasSentClassListWhatsapp
                                  ? "Save & Continue"
                                  : "Send & Continue"
                              : activeMenuItem === "search-report"
                                ? hasSentSearchReportWhatsapp
                                  ? "Save & Continue"
                                  : "Send & Continue"
                              : activeMenuItem === "proposal"
                                ? hasSentProposalWhatsapp
                                  ? "Save & Continue"
                                  : "Send & Continue"
                              : activeMenuItem === "invoice-final"
                                ? hasSentInvoiceFinalWhatsapp
                                  ? "Save & Continue"
                                  : "Send & Continue"
                              : "Save & Continue"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <ConfirmMessageModal
        open={showSearchChecklistResendModal}
        onClose={() => setShowSearchChecklistResendModal(false)}
        title="Resend search checklist"
        previewContent={CHECKLIST_MESSAGE_TEMPLATE}
        disableConfirm={checklistResending}
        onConfirm={() => {
          setShowSearchChecklistResendModal(false);
          if (!leadId) return;
          setChecklistResending(true);
          void (async () => {
            try {
              await sendChecklist(leadId);
              toast.success("Search checklist resent to client successfully.");
            } catch (err) {
              toast.error(
                err instanceof Error ? err.message : "Failed to resend checklist"
              );
            } finally {
              setChecklistResending(false);
            }
          })();
        }}
      />

      <ConfirmMessageModal
        open={showSearchChecklistSendModal}
        onClose={() => setShowSearchChecklistSendModal(false)}
        title="Send search checklist"
        previewContent={CHECKLIST_MESSAGE_TEMPLATE}
        disableConfirm={checklistSending}
        onConfirm={() => {
          setShowSearchChecklistSendModal(false);
          if (!leadId) return;
          setChecklistSending(true);
          void (async () => {
            try {
              await sendChecklist(leadId);
              setHasSentChecklistWhatsApp(true);
              toast.success("Search checklist sent successfully");
              const idx = menuItems.findIndex((m) => m.id === "checklist");
              if (idx >= 0 && idx < menuItems.length - 1) {
                navigateToStep("discussion", menuItems[idx + 1].id, leadId);
              }
            } catch (err) {
              toast.error(
                err instanceof Error ? err.message : "Failed to send checklist"
              );
            } finally {
              setChecklistSending(false);
            }
          })();
        }}
      />

      <ConfirmMessageModal
        open={showF1ConfirmModal}
        onClose={() => setShowF1ConfirmModal(false)}
        previewContent={DOCUMENTS_PREVIEW_TEXT}
        onConfirm={() => {
          setShowF1ConfirmModal(false);
          if (!leadId) return;
          (async () => {
            setDocChecklistSending(true);
            try {
              if (!hasSentDocChecklistWhatsapp) {
                await sendDocChecklist(leadId);
                setHasSentDocChecklistWhatsapp(true);
                toast.success("Document checklist sent successfully.");
              } else {
                toast.success("Document checklist already sent. Proceeding to next step.");
              }
              const idx = FILING_ITEMS.findIndex((m) => m.id === "f1");
              if (idx >= 0 && idx < FILING_ITEMS.length - 1) {
                navigateToStep("filing", FILING_ITEMS[idx + 1].id, leadId);
              }
            } catch (err) {
              toast.error(
                err instanceof Error ? err.message : "Failed to send document checklist"
              );
            } finally {
              setDocChecklistSending(false);
            }
          })();
        }}
      />
    </DashboardLayout>
  );
}
